import lodashOrderBy from 'lodash/orderBy';
import createHash from 'create-hash';
import dayjs from 'dayjs';
import { api } from '@/api/api';
import { globalStoreConfig } from '@/api/data/store';
import { apis, inWindow, isElectron, reLoginCodeList } from '@/config';
import { ActionStore, localSearchDataFilterName, mailAttachmentOfContentFilterName, mailBoxOfDefault, mailBoxOfDeleted, mailBoxOfDraft, mailBoxOfFakeThread, mailBoxOfSent, mailBoxOfWaitingIssue, mailBoxTable, mailContentFilterName, mailContentFolderFilterName, mailDbCommonQueryFilterName, mailComposeDataTable, mailSearchAttachmentFilterName, mailTable, mailBoxOfTask, mailBoxOfDefer, mailAttrFilterName, tpMailFilterName, mailBoxOfSpam, mailBoxOfFilterStar, } from './mail_action_store_model';
import { SystemAccounts, FLOLDER, } from '@/api/logical/mail';
import { MailModelHandler } from './mail_entry_helper';
import { MailContactHandler } from './mail_obtain_contact_helper';
import { MailContentDbHelper } from './mail_content_db_handler';
import { MailContentHandler } from './mail_content_handler';
import { isWinmailDatAttachment, util, wait, isOwnDomainEmail } from '@/api/util';
import { MailSendHandler } from './mail_send_handler';
import { ErrResult } from '@/api/errMap';
import { mailPerfTool } from '@/api/util/mail_perf';
import { edmMailHelper } from '@/api/util/edm_mail_helper';
import { startWatchMailMessage } from '@/api/store/api_store';
import { MailCustomerHelper } from './mail_customer';
import { getOs } from '../../../utils/confOs';
import { getIn18Text, setMailAttSource } from '@/api/utils';
import { getSidRegexp } from '@/const';
import { parseMailto } from '../../../utils/mailtohelper';
const inElectron = api.getSystemApi().isElectron();
const inMainPage = api.getSystemApi().isMainPage();
const MAIL_CACHE_CUSTOMDIRKEY = 'mailCacheCustomPath';
function traverseMailBoxs(mailBoxs, resArr) {
    if (mailBoxs && mailBoxs.length) {
        mailBoxs.forEach(mailBoxItem => {
            resArr.push(mailBoxItem);
            if (mailBoxItem.children && mailBoxItem.children.length) {
                traverseMailBoxs(mailBoxItem.children, resArr);
            }
        });
    }
}
const OPEN_URL_PATHS_KEY = 'openUrlPaths';
class MailApiImpl {
    constructor() {
        this.dbName = 'mail_new';
        this.topTaskNum = 2;
        this.markStarMailQueue = { queue: [], runningId: '' };
        this.scanningMails = false;
        this.contactReady = false;
        this.markingMailsRead = {};
        this.enableExcuteBridge = api.getSystemApi().isElectron();
        this.isMac = getOs() === 'mac';
        this.sidRegexp = getSidRegexp();
        this.actions = new ActionStore();
        this.subActions = new Map();
        this.modelHandler = new MailModelHandler(this.actions, this.subActions);
        this.contactHandler = new MailContactHandler(this.actions, this.subActions);
        this.loggerHelper = api.requireLogicalApi(apis.loggerApiImpl);
        this.dataTrackerHelper = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.mailDbHandler = new MailContentDbHelper(this.actions, this.modelHandler, this.contactHandler, this.subActions);
        this.mailContentHandler = new MailSendHandler(this.actions, this.modelHandler, this.contactHandler, this.mailDbHandler, this.subActions);
        this.mailCustomerHandler = new MailCustomerHelper();
        this.mailOperationHandler = this.mailContentHandler;
        this.db = api.requireLogicalApi(apis.dbInterfaceApiImpl);
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.impl = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.eventApi = api.getEventApi();
        this.fileApi = api.getFileApi();
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.pushApi = api.requireLogicalApi(apis.pushApiImpl);
        this.errReporter = api.requireLogicalApi(apis.errorReportImpl);
        this.name = apis.mailApiImpl;
        this.isMailPage = inWindow() ? window.location.pathname.indexOf('writeMail') >= 0 : false;
        this.mailPraiseApi = api.requireLogicalApi(apis.mailPraiseApiImpl);
        this.mailDraftApi = api.requireLogicalApi(apis.mailDraftApiImpl);
        this.mailTaskApi = api.requireLogicalApi(apis.taskMailImplApi);
        this.mailStrangerApi = api.requireLogicalApi(apis.mailStrangerApiImpl);
        this.productApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.mailPlusCustomerApi = api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
        this.mailMsgCenter = {
            syncMail: {
                regularMail: { received: false, diff: false },
            },
        };
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.edmRoleApi = api.requireLogicalApi(apis.edmRoleApiImpl);
    }
    async setMailContentDbCachePath() {
        try {
            const path = await this.getMailCachePath();
            if (path) {
                this.mailDbHandler.setMailCachePath(path);
            }
        }
        catch (ex) {
            console.error('setMailContentDbCachePath-error', ex);
        }
    }
    createSubActions(_account) {
        if (this.subActions.has(_account)) {
            return { suc: true, msg: 'existed' };
        }
        this.subActions.set(_account, new ActionStore());
        return { suc: true, msg: 'suc' };
    }
    syncSubActions() {
        const subAccounts = this.storeApi.getSubAccountList();
        if ((subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length) > 0) {
            subAccounts.forEach((subAccount) => {
                if (!this.subActions.has(subAccount.email)) {
                    this.createSubActions(subAccount.email);
                }
            });
            this.mailConfApi.syncSubActions();
        }
    }
    removeSubActions(_account) {
        this.subActions.delete(_account);
    }
    getActions(params) {
        var _a;
        const { actions, subActions, _account } = params;
        if (!_account) {
            return { suc: true, val: actions };
        }
        const targetAccountId = this.accountApi.getEmailIdByEmail(_account);
        if (targetAccountId === '') {
            return { suc: true, val: actions };
        }
        const mainAccountId = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        if (targetAccountId === mainAccountId) {
            return { suc: true, val: actions };
        }
        const targetActions = subActions === null || subActions === void 0 ? void 0 : subActions.get(targetAccountId);
        if (targetActions) {
            return { suc: true, val: targetActions };
        }
        return { suc: false, val: null, msg: 'account not existed' };
    }
    cidGetAccountId(cid) {
        return cid.split('&seq&')[0];
    }
    async doCompleteTrustMail(id) {
        return this.mailContentHandler.doCompleteTrustMail(id);
    }
    async doReportOrTrustMail(id, fid, spamType, isThread, needCheckThread = true, _account) {
        if (needCheckThread) {
            const { threadIds, normalIds } = await this.mailDbHandler.classifyThreadMailsByIds(id, undefined, _account);
            const normalPromise = normalIds.length > 0 ? this.doReportOrTrustMail(normalIds, fid, spamType, false, false, _account) : Promise.resolve({ succ: true });
            const threadPromise = threadIds.length > 0 ? this.doReportOrTrustMail(threadIds, fid, spamType, true, false, _account) : Promise.resolve({ succ: true });
            return Promise.all([normalPromise, threadPromise]).then(([v1, v2]) => {
                if (v1 && v2 && v1.succ && v2.succ) {
                    return { succ: true };
                }
                return Promise.reject();
            });
        }
        return this.mailContentHandler.doReportOrTrustMail(id, fid, spamType, isThread, _account);
    }
    doAdvanceSearchMail(search, noCache, _account) {
        this.loggerHelper.track('mail_search_advance_start', { search, noCache });
        return this.mailContentHandler.doAdvanceSearchMail(search, noCache, _account);
    }
    doAdvanceSearchMail_sd(search, colleagueAccId, subEmails) {
        return this.mailContentHandler.doAdvanceSearchMail_sd(search, colleagueAccId, subEmails);
    }
    doAdvanceSearchMail_sd_more(search) {
        return this.mailContentHandler.doAdvanceSearchMail_sd_more(search);
    }
    AIServerGetAILists() {
        const url = this.impl.buildUrl(this.systemApi.getUrl('AIServerGetAILists'), { readNew: true });
        try {
            return this.impl.get(url, { readNew: true }).then(res => {
                var _a;
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200 && !!(res === null || res === void 0 ? void 0 : res.data)) {
                    return res === null || res === void 0 ? void 0 : res.data.data;
                }
                return [];
            });
        }
        catch (error) {
            console.error('mail_impl AIServerGetAILists error', error);
            return Promise.resolve([]);
        }
    }
    getColleagueMonitorRule() {
        const url = this.systemApi.getUrl('getColleagueMonitorRule');
        return this.impl.get(url, {}).then(res => {
            var _a, _b, _c;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200 && !!((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data)) {
                return Promise.resolve((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data);
            }
            return Promise.resolve(null);
        });
    }
    AIServerReadMsg(id) {
        const url = this.systemApi.getUrl('AIServerReadMsg');
        return this.impl.post(url, { id }, { contentType: 'form' }).then(res => {
            var _a;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200) {
                return Promise.resolve(true);
            }
            return Promise.resolve(false);
        });
    }
    AIServerReadNew(id) {
        const url = this.systemApi.getUrl('AIServerReadNew');
        return this.impl.post(url, { id }, { contentType: 'form' }).then(res => {
            var _a;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200) {
                return Promise.resolve(true);
            }
            return Promise.resolve(false);
        });
    }
    AIServerGetUsedNum(type) {
        const url = this.systemApi.getUrl('AIServerGetUsedNum');
        return this.impl.post(url, { type }, { contentType: 'form' }).then(res => {
            var _a, _b;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200) {
                return Promise.resolve(Number((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) || 0);
            }
            return Promise.resolve(0);
        });
    }
    AIServerRequestAgent(type, staffList) {
        const url = this.systemApi.getUrl('AIServerRequestAgent');
        return this.impl
            .post(url, { type, staffList }, { contentType: 'json' })
            .then(res => {
            var _a, _b;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200) {
                return Promise.resolve(true);
            }
            throw new Error(((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message) || '未知错误');
        })
            .catch(error => {
            throw error;
        });
    }
    getMailListFromSdAI(param) {
        return this.mailContentHandler.getMailListFromSdAI(param);
    }
    buildAdvancedSearchEntryReq_more(search) {
        return this.mailContentHandler.buildAdvancedSearchEntryReq_more(search);
    }
    async batchDeleteAdvnceSearch(params) {
        const { mailSearchAccount } = params;
        this.loggerHelper.track('mail_search_batch_delete', { type: 'advance' });
        const list = await this.mailContentHandler.batchDeleteAdvnceSearch(params);
        const size = 200;
        if (list && list.length) {
            for (let i = 0; i < list.length; i += size) {
                const ids = list.slice(i, i + size);
                try {
                    await this.doMoveMail(ids, mailBoxOfDeleted.id, false, true, mailSearchAccount);
                    await wait(600);
                }
                catch (ex) {
                    console.error('batchDeleteAdvnceSearch-error', ex);
                }
            }
        }
        return true;
    }
    handleWriteMail(ev) {
        if (inMainPage && inElectron)
            this.electronMainPageHandleWriteMail(ev);
        if (inMainPage && !inElectron)
            this.webMainPageHandleWriteMail(ev);
        if (this.isMailPage && inElectron)
            this.mailWinHandleWriteMail(ev);
        if (!inMainPage && !inElectron)
            this.webMainPageHandleWriteMail(ev);
    }
    commonMainPageHandleWriteMail(ev) {
        var _a;
        const { eventFrom, eventStrData, eventTarget, _account } = ev;
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (eventFrom !== undefined && eventStrData) {
            const webFrom = Number(eventFrom);
            if (eventStrData === 'writePageDataExchange') {
                targetActions === null || targetActions === void 0 ? void 0 : targetActions.paramDispatched.add(webFrom);
                if (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailParamMap[webFrom]) {
                    this.mailOperationHandler.sendDataToWritePage(targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailParamMap[webFrom], webFrom, ev);
                    targetActions === null || targetActions === void 0 ? true : delete targetActions.mailParamMap[webFrom];
                }
                else {
                    this.resetWriteMailContent(webFrom, _account);
                }
            }
            if (['sendSucceed', 'scheduleDateSucceed'].includes(eventStrData)) {
                setTimeout(() => {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailChanged',
                        eventStrData: 'syncDraft',
                        eventData: {},
                        _account,
                    });
                }, 1500);
            }
            if (['saveSucceed', 'autoSaveSucceed'].includes(eventStrData)) {
                setTimeout(() => {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailChanged',
                        eventStrData: 'syncDraft',
                        eventData: {},
                        _account,
                    });
                }, 1500);
            }
            if (eventStrData === 'sending') {
                this.mailContentHandler.cleanCacheStatus(_account);
            }
        }
        if (eventStrData === 'initData' && !eventTarget) {
            this.handleWriteLatterEvent(ev, false);
        }
    }
    webMainPageHandleWriteMail(ev) {
        this.commonMainPageHandleWriteMail(ev);
    }
    electronMainPageHandleWriteMail(ev) {
        this.commonMainPageHandleWriteMail(ev);
    }
    mailWinHandleWriteMail(ev) {
        var _a;
        const { eventTarget, eventData, eventStrData, _account } = ev;
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (!eventTarget || !eventData)
            return;
        if (eventStrData === 'initData') {
            this.handleWriteLatterEvent(ev, false, eventTarget);
            setTimeout(() => {
                var _a;
                (_a = this.eventApi
                    .sendSysEvent({
                    eventName: 'writePageDataExchange',
                    eventStrData: 'writePageWindowCreated',
                    eventData,
                    _account,
                })) === null || _a === void 0 ? void 0 : _a.catch(ex => {
                    console.error(ex);
                });
            }, 0);
            if (this.systemApi.isElectron()) {
                this.eventApi.registerSysEventObserver('electronClose', {
                    func: () => {
                        if (targetActions)
                            targetActions.writeMailPageDataReceived = false;
                    },
                });
                this.systemApi.addWindowHookConf({
                    observerWinId: -1,
                    hookObjName: 'mail-hooks-obj',
                    intercept: true,
                    hooksEventExtraData: { mailPageIntercept: true },
                    hooksName: 'onBeforeClose',
                });
            }
        }
        if (eventStrData === 'prepareData') {
            this.handleWriteLatterEvent(ev, true, eventTarget);
        }
    }
    resetWriteMailContent(webFrom, _account) {
        this.initModel({ mailType: 'common', writeType: 'common', _account }).then(res => {
            var _a;
            (_a = this.eventApi
                .sendSysEvent({
                eventName: 'writePageDataExchange',
                eventData: res,
                eventStrData: 'prepareData',
                eventTarget: String(webFrom),
                _account,
            })) === null || _a === void 0 ? void 0 : _a.catch(ex => {
                console.error(ex);
            });
        });
    }
    handleWriteLatterEvent(ev, prepare, eventTarget) {
        const eventObj = {
            eventName: 'writeLatter',
            eventData: {
                result: Object.assign(Object.assign({}, ev.eventData), { eventTarget }),
            },
            eventTarget,
        };
        this.eventApi.sendSysEvent(eventObj);
        if (prepare) {
            console.log('[mail write] prepare event handle');
        }
        else if (this.systemApi.isElectron() && window.electronLib) {
            window.electronLib.windowManage.show();
        }
    }
    init() {
        if (inWindow()) {
            MailApiImpl.user = this.systemApi.getCurrentUser() || undefined;
            this.modelHandler.init();
            this.eventApi.registerSysEventObserver('mailPushNotify', {
                name: 'mailPushWatcher',
                func: async (ev) => {
                    if (ev) {
                        if (ev.eventStrData === 'notify') {
                            const subAccounts = await this.accountApi.getSubAccounts();
                            const currentSubAccount = subAccounts.find(item => { var _a; return this.systemApi.md5(item.id || '----') === (((_a = ev.eventData) === null || _a === void 0 ? void 0 : _a.accountId) || ''); });
                            this.doUpdateMailBoxStat('push', ev.eventData, currentSubAccount === null || currentSubAccount === void 0 ? void 0 : currentSubAccount.id).then();
                        }
                    }
                },
            });
            this.eventApi.registerSysEventObserver('writePageDataExchange', {
                name: 'writeMailLogicalOb',
                func: this.handleWriteMail.bind(this),
            });
            this.eventApi.registerSysEventObserver('openWritePageFromMain', {
                name: 'mailOpenWritePageFromMain',
                func: ev => {
                    if (this.systemApi.isMainPage()) {
                        const account = ev._account;
                        this.callWriteLetterFunc(Object.assign({ _account: account }, ev.eventData));
                    }
                },
            });
            const mailContentFilter = (it) => {
                const mail = it;
                return mail.folder !== mailBoxOfDeleted.id;
            };
            const mailContentFolderFilter = (it) => {
                const mail = it;
                return mail.folder !== mailBoxOfDeleted.id && mail.folder !== mailBoxOfDraft.id && mail.folder !== mailBoxOfSpam.id;
            };
            this.db.addFilterRegistry({
                name: mailContentFilterName,
                filterFunc: mailContentFilter,
            });
            this.db.addFilterRegistry({
                name: mailContentFolderFilterName,
                filterFunc: mailContentFolderFilter,
            });
            this.registerMailAttrFilter();
            this.registerTpMailFilter();
            const mailDbCommonQueryFilter = (it, query) => {
                var _a;
                const mail = it;
                if (query && query.additionalData && 'isThread' in query.additionalData && ((_a = query === null || query === void 0 ? void 0 : query.additionalData) === null || _a === void 0 ? void 0 : _a.isThread) === 1) {
                    return it.isThread && mail.folder === mailBoxOfFakeThread.id;
                }
                return !it.isThread && mail.folder !== mailBoxOfDeleted.id;
            };
            this.db.addFilterRegistry({
                name: mailDbCommonQueryFilterName,
                filterFunc: mailDbCommonQueryFilter,
            });
            const localSearchDataFilter = (item, query) => {
                var _a, _b, _c, _d, _e;
                if (!((_a = query === null || query === void 0 ? void 0 : query.additionalData) === null || _a === void 0 ? void 0 : _a.searchType) || ((_b = query === null || query === void 0 ? void 0 : query.additionalData) === null || _b === void 0 ? void 0 : _b.isThread) === undefined || !((_c = query === null || query === void 0 ? void 0 : query.additionalData) === null || _c === void 0 ? void 0 : _c.key)) {
                    return false;
                }
                const data = item;
                if (data.isThread !== query.additionalData.isThread) {
                    return false;
                }
                return this.mailContentHandler.getSearchDataCondition(data, (_d = query === null || query === void 0 ? void 0 : query.additionalData) === null || _d === void 0 ? void 0 : _d.key.toLowerCase(), ((_e = query === null || query === void 0 ? void 0 : query.additionalData) === null || _e === void 0 ? void 0 : _e.searchType) || 'all');
            };
            this.db.addFilterRegistry({
                name: localSearchDataFilterName,
                filterFunc: localSearchDataFilter,
            });
            const mailSearchAttachmentFilter = (item, query) => {
                var _a, _b, _c, _d, _e;
                if (!((_a = query === null || query === void 0 ? void 0 : query.additionalData) === null || _a === void 0 ? void 0 : _a.searchType) || ((_b = query === null || query === void 0 ? void 0 : query.additionalData) === null || _b === void 0 ? void 0 : _b.isThread) === undefined || !((_c = query === null || query === void 0 ? void 0 : query.additionalData) === null || _c === void 0 ? void 0 : _c.key)) {
                    return false;
                }
                const data = item;
                console.log('1111mailSearchAttachmentFilter', data, query === null || query === void 0 ? void 0 : query.additionalData);
                if (data.isThread !== ((_d = query === null || query === void 0 ? void 0 : query.additionalData) === null || _d === void 0 ? void 0 : _d.isThread)) {
                    return false;
                }
                return util.testArrayContainsKey((_e = query === null || query === void 0 ? void 0 : query.additionalData) === null || _e === void 0 ? void 0 : _e.key, data.attachmentNames);
            };
            this.db.addFilterRegistry({
                name: mailSearchAttachmentFilterName,
                filterFunc: mailSearchAttachmentFilter,
            });
            const mailAttachmentOfContentFilter = (item, query) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (!((_a = query === null || query === void 0 ? void 0 : query.additionalData) === null || _a === void 0 ? void 0 : _a.searchType) || ((_b = query === null || query === void 0 ? void 0 : query.additionalData) === null || _b === void 0 ? void 0 : _b.isThread) === undefined || !((_c = query === null || query === void 0 ? void 0 : query.additionalData) === null || _c === void 0 ? void 0 : _c.key)) {
                    return false;
                }
                const data = item;
                console.log('1111mailAttachmentOfContentFilter', data, query === null || query === void 0 ? void 0 : query.additionalData);
                if (data.isThread !== ((_d = query === null || query === void 0 ? void 0 : query.additionalData) === null || _d === void 0 ? void 0 : _d.isThread)) {
                    return false;
                }
                return (util.testArrayContainsKey((_e = query === null || query === void 0 ? void 0 : query.additionalData) === null || _e === void 0 ? void 0 : _e.key, data.ccContactName) ||
                    util.testArrayContainsKey((_f = query === null || query === void 0 ? void 0 : query.additionalData) === null || _f === void 0 ? void 0 : _f.key, data.ccEmail) ||
                    util.testArrayContainsKey((_g = query === null || query === void 0 ? void 0 : query.additionalData) === null || _g === void 0 ? void 0 : _g.key, data.bccContactName) ||
                    util.testArrayContainsKey((_h = query === null || query === void 0 ? void 0 : query.additionalData) === null || _h === void 0 ? void 0 : _h.key, data.bccEmail));
            };
            this.db.addFilterRegistry({
                name: mailAttachmentOfContentFilterName,
                filterFunc: mailAttachmentOfContentFilter,
            });
            this.impl.addConfig({
                matcher: /^(\/lx-web)?\/(?:(?:bj)?js6)|(?:upxmail)|(?:corp-mail)|(?:todo\/api\/biz\/taskEmail)|(?:praise-mail\/reward\/person\/praise)\/.*/i,
                requestAutoReLogin: (data) => {
                    if (/func=user(?:%3A|:)authenticate2/.test((data === null || data === void 0 ? void 0 : data.uri) || '')) {
                        return false;
                    }
                    return !!data.data && !!data.data.code && data.data.code in reLoginCodeList;
                },
                reLoginUrlHandler: conf => {
                    var _a;
                    const subAccount = this.impl.getSubAccountByReqConfig(conf);
                    const originUrl = conf.url;
                    const currentUser = this.systemApi.getCurrentUser(!subAccount ? '' : subAccount);
                    if (currentUser) {
                        conf.url = (_a = conf.url) === null || _a === void 0 ? void 0 : _a.replace(this.sidRegexp, 'sid=' + currentUser.sessionId);
                    }
                    console.log('mail_re_login_change_url', {
                        originUrl,
                        url: conf.url,
                        sid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId,
                    });
                    return conf;
                },
                cachePolicyGenerator: config => {
                    var _a;
                    const mainRq = {
                        url: (_a = config.url) === null || _a === void 0 ? void 0 : _a.replace(this.sidRegexp, ''),
                        data: config.contentType === 'stream' ? new Date().getTime() : config.data,
                        method: config.method,
                    };
                    const cacheKey = this.systemApi.md5(JSON.stringify(mainRq), true);
                    return { cacheKey };
                },
                canCache: (data) => !!data.data && !!data.data.code && data.data.code === MailContentHandler.sOk,
            });
            if (process.env.BUILD_ISELECTRON) {
                if (window.location.pathname.includes('api_data_init')) {
                    this.eventApi.registerSysEventObserver('contactNotify', {
                        func: (ev) => {
                            if (MailApiImpl.user && ev && ev._account !== MailApiImpl.user.id) {
                                return;
                            }
                            console.log('contactNotify', ev);
                            if (!this.contactReady) {
                                this.contactReady = true;
                            }
                        },
                    });
                }
            }
            else if (this.systemApi.isMainPage()) {
                this.eventApi.registerSysEventObserver('contactNotify', {
                    func: () => {
                        if (!this.contactReady) {
                            this.contactReady = true;
                        }
                    },
                });
            }
            const isLowMemoryMode = this.systemApi.getIsLowMemoryModeSync();
            const isBgPage = window.isBridgeWorker;
            if (inWindow() && !isLowMemoryMode && isBgPage) {
                if (isElectron()) {
                    setTimeout(() => {
                        console.warn('[file auto download] started in background page');
                        this.doAutoSaveFilesInMail().then();
                    }, MailApiImpl.SAVE_FILES_WAIT);
                }
                this.systemApi.intervalEvent({
                    seq: 0,
                    eventPeriod: 'extLong',
                    id: 'clearExpiredMailsTimer',
                    handler: () => {
                        this.clearExpiredMails().catch();
                    },
                });
            }
            if (process.env.BUILD_ISELECTRON && inWindow() && this.systemApi.isMainWindow()) {
                const currentUser = this.systemApi.getCurrentUser();
                if (currentUser) {
                    this.getEmlFilePaths().then(emlFilePaths => {
                        if (!emlFilePaths || !emlFilePaths.length)
                            return;
                        this.resetEmlFilePaths().catch();
                        this.openEmlMails(emlFilePaths).catch();
                    });
                    this.getSendFilePaths().then(sendFilePaths => {
                        if (!sendFilePaths || !sendFilePaths.length)
                            return;
                        this.resetSendFilePaths();
                        this.handleSendFileAsAttachment(sendFilePaths);
                    });
                    this.getUrlPaths().then(urlPaths => {
                        if (!urlPaths || !urlPaths.length)
                            return;
                        this.storeOpenUrlPaths([]);
                        this.handleOpenUrlFromApp(urlPaths);
                    });
                }
                window.electronLib.windowManage.addOpenFileListener(async (fileInfos) => {
                    const currentUser = this.systemApi.getCurrentUser();
                    if (currentUser) {
                        if (fileInfos.type === 'open') {
                            this.openEmlMails(fileInfos.paths).catch(e => {
                                console.warn('[open eml] error', e);
                            });
                        }
                        else if (fileInfos.type === 'send') {
                            this.handleSendFileAsAttachment(fileInfos.paths);
                        }
                        else if (fileInfos.type === 'url') {
                            this.handleOpenUrlFromApp(fileInfos.paths);
                        }
                    }
                    else {
                        if (fileInfos.type === 'open') {
                            let emlFilePaths = await this.getEmlFilePaths();
                            if (!emlFilePaths) {
                                emlFilePaths = [];
                            }
                            emlFilePaths.push(...fileInfos.paths);
                            this.storeEmlFilePaths(emlFilePaths).catch();
                        }
                        else if (fileInfos.type === 'send') {
                            this.storeSendFilePaths(fileInfos.paths);
                        }
                        else if (fileInfos.type === 'url') {
                            this.storeOpenUrlPaths(fileInfos.paths);
                        }
                    }
                });
            }
        }
        return this.name;
    }
    handleOpenUrlFromApp(urlPaths) {
        if (urlPaths && urlPaths.length) {
            urlPaths.forEach(urlStr => {
                if (urlStr.indexOf('mailto:') === 0) {
                    this.parseMailToWriteLetter({ mailTo: urlStr });
                }
            });
        }
    }
    async storeEmlFilePaths(filePaths) {
        await window.electronLib.storeManage.set('memory', 'emlFilePaths', filePaths);
    }
    async storeSendFilePaths(filePaths) {
        await window.electronLib.storeManage.set('memory', 'sendFilePaths', filePaths);
    }
    async storeOpenUrlPaths(urlPaths) {
        await window.electronLib.storeManage.set('memory', OPEN_URL_PATHS_KEY, urlPaths);
    }
    registerMailAttrFilter() {
        const mailAttrFilter = (item, query) => {
            const data = item;
            const { exchangeType, filterValue } = (query === null || query === void 0 ? void 0 : query.additionalData) || {};
            if (!exchangeType || !Array.isArray(filterValue) || filterValue.length === 0) {
                return true;
            }
            const fromHasValue = (data.filterValues.from || []).some(v => filterValue.includes(v));
            if (exchangeType === 'send') {
                return fromHasValue;
            }
            if (exchangeType === 'receive') {
                if (!fromHasValue) {
                    return true;
                }
                return (data.filterValues.to || []).some(v => filterValue.includes(v));
            }
            return true;
        };
        this.db.addFilterRegistry({
            name: mailAttrFilterName,
            filterFunc: mailAttrFilter,
        });
    }
    registerTpMailFilter() {
        const isValidToList = (toList) => Array.isArray(toList) && toList.length > 0;
        const sendFilter = (data, from, toList) => {
            const fromIsSender = data.entryModel.sender.contact.contact.accountName === from;
            const toIsReceiver = isValidToList(toList) ? data.entryModel.receiver.some(v => toList.includes(v.contact.contact.accountName)) : true;
            return fromIsSender && toIsReceiver;
        };
        const receiveFilter = (data, from, toList) => {
            const fromIsReceiver = data.entryModel.receiver.some(v => v.contact.contact.accountName === from);
            const toIsSender = isValidToList(toList) ? toList.includes(data.entryModel.sender.contact.contact.accountName) : true;
            return fromIsReceiver && toIsSender;
        };
        const tpMailFilter = (item, query) => {
            const { exchangeType, toList, from } = (query === null || query === void 0 ? void 0 : query.additionalData) || {};
            if (!exchangeType && !isValidToList(toList)) {
                return true;
            }
            const data = item;
            if (!exchangeType) {
                return sendFilter(data, from, toList) || receiveFilter(data, from, toList);
            }
            if (exchangeType === 'send') {
                return sendFilter(data, from, toList);
            }
            return receiveFilter(data, from, toList);
        };
        this.db.addFilterRegistry({
            name: tpMailFilterName,
            filterFunc: tpMailFilter,
        });
    }
    async resetEmlFilePaths() {
        await window.electronLib.storeManage.set('memory', 'emlFilePaths', []);
    }
    async getEmlFilePaths() {
        const emlFilePaths = await window.electronLib.storeManage.get('memory', 'emlFilePaths');
        return emlFilePaths && emlFilePaths.length ? emlFilePaths : null;
    }
    async getSendFilePaths() {
        const sendFilePaths = await window.electronLib.storeManage.get('memory', 'sendFilePaths');
        return sendFilePaths && sendFilePaths.length ? sendFilePaths : null;
    }
    async getUrlPaths() {
        const sendFilePaths = await window.electronLib.storeManage.get('memory', OPEN_URL_PATHS_KEY);
        return sendFilePaths && sendFilePaths.length ? sendFilePaths : null;
    }
    async resetSendFilePaths() {
        try {
            await window.electronLib.storeManage.set('memory', 'sendFilePaths', []);
        }
        catch (ex) {
            console.error('resetSendFilePaths-catch', ex);
        }
    }
    async doAutoSaveFilesInMail() {
        return this.mailDbHandler.saveFilesInMail(true).catch(err => {
            console.warn('[file auto download] error', err);
        });
    }
    async mkDownloadDir(type, config, fallbackToDefault) {
        return this.mailDbHandler.mkDownloadDir(type, config, fallbackToDefault);
    }
    sendMailRefreshMessage(data, checkType, diff, _account) {
        console.log('[mail msg] sendMailRefreshMessage', data, checkType, diff, _account);
        const eventData = data ? Object.assign(Object.assign({}, data), { checkType, diff }) : { checkType, diff };
        this.eventApi.sendSysEvent({
            eventName: 'mailStoreRefresh',
            eventStrData: 'refreshFromDb',
            eventData,
            _account,
        });
    }
    doCallMailMsgCenter(params, _account) {
        var _a, _b, _c, _d;
        const refreshType = (_a = params.msgCenter) === null || _a === void 0 ? void 0 : _a.refreshType;
        const msgType = params.type;
        const msgData = params.data;
        console.log('[mail msg center] received ', params, refreshType);
        if (!((_b = params.msgCenter) === null || _b === void 0 ? void 0 : _b.merge)) {
            this.sendMailRefreshMessage(msgData, params.checkType, (_c = params.msgCenter) === null || _c === void 0 ? void 0 : _c.diff, _account);
            console.log('[mail msg center] immediate sent ' + refreshType, params, this.mailMsgCenter);
            return;
        }
        const refreshTypes = Object.keys(this.mailMsgCenter[msgType]);
        if (refreshType && refreshTypes.includes(refreshType)) {
            this.mailMsgCenter[msgType][refreshType] = {
                received: true,
                diff: !!((_d = params.msgCenter) === null || _d === void 0 ? void 0 : _d.diff),
            };
            const { allReceived, diff } = this.checkMsgCenter(msgType);
            if (allReceived) {
                this.sendMailRefreshMessage(msgData, params.checkType, diff, _account);
                console.log(`[mail msg center] all received and diff:${diff}, controlled sent ` + refreshType, params, this.mailMsgCenter);
                setTimeout(() => {
                    this.resetMsgCenter(msgType);
                }, 500);
            }
            else {
                console.log('[mail msg center] waiting other message ', params, this.mailMsgCenter);
            }
        }
        else {
            this.sendMailRefreshMessage(msgData, params.checkType, true, _account);
            console.log('[mail msg center] uncontrolled sent ' + refreshType, params, this.mailMsgCenter);
        }
    }
    checkMsgCenter(msgType) {
        const msgCenter = this.mailMsgCenter[msgType];
        const targets = Object.keys(msgCenter);
        return {
            allReceived: targets.every(key => msgCenter[key].received),
            diff: targets.some(key => msgCenter[key].diff),
        };
    }
    resetMsgCenter(msgType) {
        const msgCenter = this.mailMsgCenter[msgType];
        Object.keys(msgCenter).forEach(key => {
            this.mailMsgCenter[msgType][key] = {
                received: false,
                diff: false,
            };
        });
    }
    afterInit() {
        try {
            const subAccounts = this.storeApi.getSubAccountList();
            if ((subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length) > 0) {
                subAccounts.forEach((subAccount) => this.createSubActions(subAccount.email));
            }
        }
        catch (error) {
            console.log('获取子账号并设置 error', error);
        }
        this.contactReady = false;
        if (this.systemApi.getCurrentUser()) {
            this.db.initDb(this.dbName);
            this.initData();
            startWatchMailMessage();
        }
        return this.name;
    }
    async startWatchMail() {
        if (this.systemApi.isMainPage()) {
            const currentUser = this.systemApi.getCurrentUser();
            if (currentUser && currentUser.sessionId) {
                await wait(10000);
                this.doUpdateMailBoxStatCall('default').then(console.log).catch(console.warn);
            }
            this.systemApi.intervalEvent({
                seq: 1,
                eventPeriod: 'long',
                id: 'mailSync',
                handler: ev => {
                    console.log('[mail sync] interval long event:', ev);
                    const currentUserInterval = this.systemApi.getCurrentUser();
                    if (currentUserInterval && currentUserInterval.sessionId) {
                        MailApiImpl.user = currentUserInterval;
                        if (ev.seq % 2 === 0 && ev.seq > 3) {
                            this.doUpdateMailBoxStatCall('time').then();
                        }
                    }
                },
            });
        }
        else if (window.location.pathname.indexOf('writeMail')) {
        }
    }
    async getPraiseMedals() {
        var _a;
        const response = await this.mailPraiseApi.getMedals();
        this.actions.praiseMedals = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.medals) || [];
    }
    onPathChange(ev) {
        var _a;
        if (((_a = ev === null || ev === void 0 ? void 0 : ev.curPath) === null || _a === void 0 ? void 0 : _a.pathname) === '/') {
            const currentUser = this.systemApi.getCurrentUser();
            if (currentUser) {
                this.db.initDb(this.dbName);
                this.initData();
            }
        }
        return this.name;
    }
    afterLogin(ev) {
        var _a;
        if (!ev || !ev.data) {
            return this.name;
        }
        const user = (_a = ev.data) === null || _a === void 0 ? void 0 : _a.eventData;
        MailApiImpl.user = user;
        this.db.initDb(this.dbName);
        this.initData();
        return this.name;
    }
    initData() {
        console.log('initModule send mail');
        this.eventApi.sendSysEvent({
            eventName: 'initModule',
            eventStrData: 'mail',
        });
    }
    beforeLogout() {
        var _a;
        MailApiImpl.user = undefined;
        this.actions = new ActionStore();
        this.db.closeSpecific(this.dbName);
        (_a = this.pushApi) === null || _a === void 0 ? void 0 : _a.triggerNotificationInfoChange({
            action: 'mail_clear',
            content: '',
            num: 0,
            title: '',
        });
        return this.name;
    }
    afterLoadFinish() {
        this.contactReady = false;
        if (inWindow()) {
            this.setMailContentDbCachePath();
            this.modelHandler.initEntryFromStore().then().catch(console.warn);
            this.startWatchMail().then().catch();
            const h = this.mailDbHandler;
            this.getPraiseMedals().then().catch();
            try {
                h.initDbEnable();
            }
            catch (e) {
                console.warn(e);
            }
        }
        this.eventApi.registerSysEventObserver('SubAccountAdded', {
            name: 'SubAccountAdded-MailImpl',
            func: ev => {
                if (ev && ev.eventData) {
                    const { eventData } = ev;
                    const { subAccount } = eventData;
                    if (subAccount && !this.subActions.has(subAccount)) {
                        this.subActions.set(subAccount, new ActionStore());
                    }
                }
            },
        });
        this.eventApi.registerSysEventObserver('SubAccountDeleted', {
            name: 'SubAccountDeleted-MailImpl',
            func: ev => {
                if (ev && ev.eventData) {
                    const { eventData } = ev;
                    const { subAccount } = eventData;
                    if (subAccount && this.subActions.has(subAccount)) {
                        this.subActions.delete(subAccount);
                    }
                }
            },
        });
        return this.name;
    }
    electronLoaded() {
        var _a;
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser) {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'window',
                    popupLevel: 'info',
                    title: '账号状态错误，请稍后重启写信窗口',
                    code: 'PARAM.ERR',
                    confirmCallback: () => {
                        this.systemApi.closeWindow(true);
                    },
                },
                eventSeq: 0,
            });
        }
        if (inWindow() && window.electronLib && this.isMailPage) {
            console.log('[mail] ******* init write page ui called loaded;');
            (_a = this.eventApi.sendSimpleSysEvent('writePageDataExchange')) === null || _a === void 0 ? void 0 : _a.catch(ex => {
                console.error(ex);
                this.errReporter.doReportMessage({
                    error: '写信页面，初始化写信数据发送失败：' + ex.message,
                    data: '',
                    id: '',
                });
            });
        }
    }
    getNeedCheckThread(needCheckThread) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            return false;
        }
        return !!needCheckThread;
    }
    async doListThreadMailBoxEntities(param, noCache, _account) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            noCache = true;
        }
        const result = (await this.doListMailBoxEntities(Object.assign(Object.assign({}, param), { returnModel: true, checkType: 'checkThread', _account }), noCache));
        const newData = result.data.filter(v => {
            if (v.isThread) {
                return v.entry.threadMessageCount > 0;
            }
            return true;
        });
        const validCount = result.data.length - newData.length;
        result.data = newData;
        result.total -= validCount;
        return result;
    }
    async doGetMailByReplyMId(mid) {
        if (!this.actions.mailEntryCache) {
            await this.modelHandler.initEntryFromStore();
        }
        if (this.actions.mailEntryCache) {
            const entryCache = this.actions.mailEntryCache;
            const entry = Object.entries(entryCache)
                .filter(([, val]) => val.id === mid)
                .pop();
            if (entry && entry.length === 2) {
                return entry[1];
            }
        }
        return Promise.reject(new Error('无法找到合适的邮件'));
    }
    buildRawContactItem(item) {
        return this.contactHandler.buildRawContactItem(item);
    }
    callWriteLetterFunc(params) {
        return this.mailOperationHandler.callWriteLetterFunc(params);
    }
    doCancelCompose(cid, deleteDraft, _account) {
        return this.mailOperationHandler.doCancelCompose(cid, deleteDraft, _account);
    }
    async doCheckReadStatus(mid, _account, fetchDeliveryHistory) {
        var _a, _b, _c, _d;
        const statusNetWork = await this.mailOperationHandler.doCheckReadStatus(mid, _account, fetchDeliveryHistory);
        const mailEntryDB = await this.mailDbHandler.getMailById({
            id: mid,
            noContent: true,
            noAttachment: true,
            noContact: true,
            _account,
        });
        if (mailEntryDB && mailEntryDB.length === 1) {
            const detail = (statusNetWork === null || statusNetWork === void 0 ? void 0 : statusNetWork.detail) || [];
            const rcptCountNetWork = detail.length;
            const ownDomainSet = await this.accountApi.doGetOwnDomainSet(_account);
            const isInnerEmail = (email) => isOwnDomainEmail(email, ownDomainSet);
            const canRecomputeInner = ownDomainSet.size > 0;
            let readCountNetWork = 0;
            let innerReadNetWork = 0;
            let innerCountNetWork = 0;
            if (this.productApi.doGetProductVersionId() === 'sirius') {
                const stateTrack = this.storeApi.getSync('stateTrack').data;
                if (stateTrack === 'OFF') {
                    readCountNetWork = detail.filter((item) => {
                        const { email, result } = item;
                        if (result !== 109)
                            return false;
                        return isInnerEmail(email);
                    }).length;
                    innerCountNetWork = detail.filter(item => isInnerEmail(item.email)).length;
                    innerReadNetWork = detail.filter(item => item.result === 109 && isInnerEmail(item.email)).length;
                }
                else {
                    readCountNetWork = detail.filter(i => i.result === 109).length;
                    innerCountNetWork = detail.filter(item => isInnerEmail(item.email)).length;
                    innerReadNetWork = detail.filter(item => item.result === 109 && isInnerEmail(item.email)).length;
                }
            }
            else {
                readCountNetWork = detail.filter(i => i.result === 109).length;
                innerCountNetWork = detail.filter(item => isInnerEmail(item.email)).length;
                innerReadNetWork = detail.filter(item => item.result === 109 && isInnerEmail(item.email)).length;
            }
            const entry = mailEntryDB[0].entry;
            const readCountDB = (_a = entry === null || entry === void 0 ? void 0 : entry.readCount) !== null && _a !== void 0 ? _a : 0;
            const rcptCountDB = (_b = entry === null || entry === void 0 ? void 0 : entry.rcptCount) !== null && _b !== void 0 ? _b : 0;
            const innerReadDB = (_c = entry === null || entry === void 0 ? void 0 : entry.innerRead) !== null && _c !== void 0 ? _c : 0;
            const innerCountDB = (_d = entry === null || entry === void 0 ? void 0 : entry.innerCount) !== null && _d !== void 0 ? _d : 0;
            const innerChanged = canRecomputeInner && (innerReadNetWork !== innerReadDB || innerCountNetWork !== innerCountDB);
            const baseChanged = readCountNetWork !== readCountDB || rcptCountNetWork !== rcptCountDB;
            const changed = baseChanged || innerChanged;
            if (changed) {
                console.log('[mail] read status counts changed, updating DB', {
                    readCount: { from: readCountDB, to: readCountNetWork },
                    rcptCount: { from: rcptCountDB, to: rcptCountNetWork },
                    innerRead: canRecomputeInner ? { from: innerReadDB, to: innerReadNetWork } : 'skipped (ownDomainSet empty)',
                    innerCount: canRecomputeInner ? { from: innerCountDB, to: innerCountNetWork } : 'skipped (ownDomainSet empty)',
                });
                entry.readCount = readCountNetWork;
                entry.rcptCount = rcptCountNetWork;
                if (canRecomputeInner) {
                    entry.innerRead = innerReadNetWork;
                    entry.innerCount = innerCountNetWork;
                }
                this.saveMails(mailEntryDB[0], undefined, undefined, _account).then(() => {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailStoreRefresh',
                        eventStrData: 'updateMailEntities',
                        eventData: [mailEntryDB[0]],
                        _account,
                    });
                });
            }
        }
        return Promise.resolve(statusNetWork);
    }
    doGetMailReadCount(params) {
        return this.mailContentHandler.doGetMailReadCount(params);
    }
    doGetMailReadDetail(params) {
        return this.mailContentHandler.doGetMailReadDetail(params);
    }
    checkReadStatusOfSentMail(result, param) {
        return this.mailContentHandler.checkReadStatusOfSentMail(result, param);
    }
    getThumbUpInfo(mid, tid, page, _account) {
        return this.mailOperationHandler.getThumbUpInfo(mid, tid, page, _account);
    }
    setThumbUpCreate(params) {
        return this.mailOperationHandler.setThumbUpCreate(params);
    }
    getMailConfig() {
        return this.mailOperationHandler.getMailConfig();
    }
    setMailConfig(params) {
        return this.mailOperationHandler.setMailConfig(params);
    }
    getDefaultCCBCC() {
        return this.mailOperationHandler.getDefaultCCBCC();
    }
    setDefaultCCBCC(params) {
        return this.mailOperationHandler.setDefaultCCBCC(params);
    }
    triggerReceive(params) {
        return this.mailOperationHandler.triggerReceive(params);
    }
    async getAuthCodeDesc() {
        return this.mailOperationHandler.getAuthCodeDesc();
    }
    async guessUserSetting(email) {
        return this.mailOperationHandler.guessUserSetting(email);
    }
    async guidePop() {
        return this.mailOperationHandler.guidePop();
    }
    async microsoftAuth(param) {
        return this.mailOperationHandler.microsoftAuth(param);
    }
    async microsoftAuthLoop(accountPreId) {
        return this.mailOperationHandler.microsoftAuthLoop(accountPreId);
    }
    async microsoftAuthInfo(account) {
        return this.mailOperationHandler.microsoftAuthInfo(account);
    }
    async updateDisplayEmail(params) {
        return this.mailOperationHandler.updateDisplayEmail(params);
    }
    async getDisplayName(emailList) {
        return this.mailOperationHandler.getDisplayName(emailList);
    }
    parseMailToWriteLetter(params) {
        var _a;
        const { mailTo } = params;
        const parseResult = parseMailto(mailTo);
        if (parseResult === null || parseResult === void 0 ? void 0 : parseResult.success) {
            const { result } = parseResult;
            const { to, cc, bcc, subject, body } = result;
            const params = {
                mailType: 'common',
                writeType: 'common',
                writeWay: 'newWin',
                withoutPlaceholder: !!(body && body.length),
                _account: (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
            };
            to && (params.contact = [...to]);
            subject && (params.title = subject);
            body && (params.originContent = body);
            cc && (params.ccContact = [...cc]);
            bcc && (params.bccContact = [...bcc]);
            this.dataTrackerHelper.track('pc_mailto_writemail', {
                mailTo,
            });
            this.mailOperationHandler.callWriteLetterFunc(params);
        }
    }
    doDeleteAttachment(params) {
        const { cid, attachId, _account } = params;
        return this.mailOperationHandler.doDeleteAttachment({ cid, attachId, attachmentObj: undefined, _account });
    }
    doRenameAttachment(params) {
        const { cid, attachId, newName, _account } = params;
        return this.mailOperationHandler.doRenameAttachment({ cid, attachId, newName, attachmentObj: undefined, _account });
    }
    async doEditMail(id, payload) {
        const { draft, noPopup, _account } = payload || {};
        if (!noPopup) {
            mailPerfTool.writeMail('start', {
                writeType: draft ? 'editDraft' : 'edit',
            });
        }
        const mailType = await this.doGetMailTypeById(id, _account);
        const isThread = mailType === 'thread';
        return this.mailOperationHandler.doEditMail(id, { draft, noPopup, isThread, _account });
    }
    async doExportMail(mailId, isThread, fileName, dialogConfirmText, _account) {
        const isThreadMode = isThread;
        const noThreadsRes = { threadIds: [], normalIds: Array.isArray(mailId) ? mailId : [mailId] };
        const { threadIds, normalIds } = !isThreadMode ? noThreadsRes : await this.mailDbHandler.classifyThreadMailsByIds(mailId, true, _account);
        const MAIL_EXPORT_LIMIT = 100;
        if (normalIds.length > MAIL_EXPORT_LIMIT) {
            return Promise.reject(new Error(getIn18Text('DAOCHUSHULIANGCHAO1', { count: MAIL_EXPORT_LIMIT })));
        }
        const { threadMessages } = await this.mailDbHandler.getThreadMessageByThreadIds(threadIds, _account);
        if (threadMessages.length > 2000) {
            return Promise.reject(new Error(getIn18Text('DAOCHUSHULIANGCHAO2')));
        }
        const messageIds = threadMessages.map(v => v.mid);
        const ids = [...messageIds, ...normalIds];
        const oneMailExport = ids.length === 1;
        const manyMailExport = ids.length > 1;
        const processFileName = fileName.replace(/<\s*b\s*>/gi, '').replace(/<\s*\/b\s*>/gi, '');
        let leftFileName = processFileName || '无主题';
        const language = getIn18Text('SUOYOUYOUJIAN');
        const languageType = language.length === 5 ? 'zh' : 'en';
        const suffix = languageType === 'zh' ? `${leftFileName}${language}` : `${language}${leftFileName}`;
        leftFileName = messageIds.length > 1 ? suffix : leftFileName;
        const text = getIn18Text('XINJIANDABAO');
        leftFileName = normalIds.length > 1 ? text : leftFileName;
        const fullFileName = `${leftFileName}${util.dateFormat(new Date(), 'yyyyMMdd')}`;
        if (oneMailExport) {
            return this.mailOperationHandler.doExportMailAsEml(ids[0], fullFileName, dialogConfirmText, _account);
        }
        if (manyMailExport) {
            return this.mailOperationHandler.doExportGroupMailAsZip(ids, fullFileName, dialogConfirmText, _account);
        }
        return Promise.reject(new Error(getIn18Text('YOUJIANDAOCHUSHI')));
    }
    doExportMailAsEml(id, fileName, _account) {
        return this.mailOperationHandler.doExportMailAsEml(id, fileName, _account);
    }
    async doExportThreadMailAsZip(threadId, fileName, _account) {
        const threadIds = Array.isArray(threadId) ? threadId : [threadId];
        const results = (await this.db.getByIds(mailTable.status, threadIds, _account));
        if (results.length > 0) {
            const ids = results.reduce((t, v) => {
                const tempIds = Array.isArray(v.threadMessageIds) ? v.threadMessageIds : [];
                return [...t, ...tempIds];
            }, []);
            return this.mailOperationHandler.doExportGroupMailAsZip(ids, fileName, _account);
        }
        return Promise.reject(new Error('聚合邮件列表获取失败'));
    }
    async doGetMailTypeById(id, _account) {
        const { thread, normal } = await this.doGetMailTypeByIds([id], _account);
        if (Array.isArray(thread) && thread.includes(id)) {
            return 'thread';
        }
        if (Array.isArray(normal) && normal.includes(id)) {
            return 'normal';
        }
        return Promise.reject(new Error('邮件不存在'));
    }
    async doGetMailTypeByIds(ids, _account) {
        ids = ids.filter(v => !!v);
        if (ids.length === 0) {
            return {
                thread: [],
                normal: [],
            };
        }
        const idSet = new Set(ids);
        const uniqueIds = [...idSet];
        const { threadIds, normalIds } = await this.mailDbHandler.classifyThreadMailsByIds(uniqueIds, undefined, _account);
        const result = {
            thread: [],
            normal: [],
        };
        uniqueIds.reduce((total, current) => {
            if (threadIds.includes(current)) {
                total.thread.push(current);
                idSet.delete(current);
            }
            else if (normalIds.includes(current)) {
                total.normal.push(current);
                idSet.delete(current);
            }
            return total;
        }, result);
        if (idSet.size > 0) {
            const temp = {
                thread: [],
                normal: [],
            };
            [...idSet].reduce((total, current) => {
                const target = current.split('--')[0];
                if (/^\d+$/.test(target)) {
                    total.thread.push(current);
                }
                else {
                    total.normal.push(current);
                }
                return total;
            }, temp);
            result.thread = [...result.thread, ...temp.thread];
            result.normal = [...result.normal, ...temp.normal];
            if (temp.thread.length > 0) {
                this.syncMailByIds(temp.thread, 'checkThreadDetail', undefined, _account).then();
            }
            if (temp.normal.length > 0) {
                this.syncMailByIds(temp.normal, 'normal', undefined, _account).then();
            }
        }
        return result;
    }
    doFastSend(content) {
        return this.mailOperationHandler.doFastSend(content);
    }
    async replyExternalThumbMail(id, all, noPopup, additionalContent, _account) {
        if (!additionalContent) {
            additionalContent = `
        <div style="font-size: 17px; font-weight: 500; color: #262A33; height: 30px; line-height: 30px">赞 👍</div>
        <div style="font-size: 16px; line-height: 26px; color: #51555C;">
        点赞邮件来自 <a style="color: #386ee7; display: inline-block; text-underline: none; text-decoration: none;" href="https://office.163.com">网易灵犀办公</a>
        </div>
      `;
        }
        const param = await this.doReplayMail(id, all, noPopup, additionalContent, _account);
        return this.doFastSend(param);
    }
    async getTranslateContent(content, from, to, _account) {
        return this.mailContentHandler.getTranslateContent(content, from, to, _account);
    }
    async detectMailContentLang(mid, content) {
        const data = await this.mailContentHandler.detectMailContentLang(content);
        if (data === null || data === void 0 ? void 0 : data.lang) {
            await this.syncContentLangToDb(mid, data.lang);
        }
        return data;
    }
    async syncContentLangToDb(mid, originLang, _account) {
        return this.mailContentHandler.syncContentLangToDb(mid, originLang, _account);
    }
    async getEnglishGrammar(content, _account) {
        return this.mailContentHandler.getEnglishGrammar(content, _account);
    }
    async syncTranslateContentToDb(mid, langType, conditions, _account) {
        return this.mailContentHandler.syncTranslateContentToDb(mid, langType, conditions, _account);
    }
    async getMailContentTableInDb(ids, _account) {
        const result = await this.mailDbHandler.getMailContentTableInDb(ids, _account);
        return result;
    }
    async doForwardMail(id, payload) {
        const { noPopup, additionalContent, _account, owner, colleagueAccId, isTpMail, mailFrom, refId, type } = payload || {};
        if (!noPopup) {
            mailPerfTool.writeMail('start', { writeType: 'forward' });
        }
        let isThread = false;
        if (!isTpMail) {
            const mailType = await this.doGetMailTypeById(id, _account);
            isThread = mailType === 'thread';
        }
        return this.mailOperationHandler.doForwardMail(id, { noPopup, additionalContent, isThread, _account, owner, colleagueAccId, isTpMail, mailFrom, refId, type });
    }
    async doForwardMailAsAttach(id, payload) {
        const { asAttach, asAttachIds, noPopup, additionalContent, _account, owner, colleagueAccId, title, contact, isTpMail, mailFrom, type, refId } = payload || {};
        if (!noPopup) {
            mailPerfTool.writeMail('start', { writeType: 'forwardAsAttach' });
        }
        let isThread = false;
        if (!asAttachIds && !isTpMail) {
            const mailType = await this.doGetMailTypeById(id);
            isThread = mailType === 'thread';
        }
        return this.mailOperationHandler.doForwardMail(id, {
            noPopup,
            additionalContent,
            isThread,
            asAttach,
            asAttachIds,
            _account,
            owner,
            colleagueAccId,
            title,
            contact,
            isTpMail,
            mailFrom,
            type,
            refId,
        });
    }
    doGetAllComposingMailId() {
        return this.mailOperationHandler.doGetAllComposingMailId();
    }
    async doGetMailContentIM(emailMid, teamId) {
        if (!emailMid) {
            return Promise.reject(new Error('no emailMid input'));
        }
        const result = await this.mailContentHandler.doGetMailContentIM(emailMid, teamId);
        if (result && result.tags) {
            result.originalTags = result.tags;
            result.tags = result.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
        }
        if (result && !result.sender) {
            result.sender = this.contactHandler.buildEmptyContact(false)[0];
        }
        return result;
    }
    async updateDbContentState(id, dbContent, taskType = 'default', noContactRace = false, _account) {
        const serverContent = await this.mailContentHandler.getMailContentMakeModelPromise({
            id,
            noFlagInfo: false,
            noCache: true,
            ignoreContact: false,
            noContactRace,
            _account,
        });
        if (serverContent) {
            const isDiff = this.checkMailContentDiff(dbContent, serverContent);
            console.log('[mail content update]', dbContent, serverContent, isDiff);
            if (isDiff) {
                await this.db.deleteById(mailTable.content, id);
                return this.getMailContentFromServer(id, {
                    noFlagInfo: false,
                    noCache: true,
                    taskType,
                    noContactRace,
                    _account,
                });
            }
            return this.mailContentHandler.getMailContentAssemble([serverContent, dbContent]);
        }
        return null;
    }
    checkMailContentDiff(dbContent, serverContent) {
        const keysInEntry = ['title', 'isDefer', 'deferTime', 'deferNotice', 'receiveTime', 'sendTime'];
        const isKeyInEntryDiff = keysInEntry.some(v => {
            if (serverContent.entry[v] !== undefined && dbContent.entry[v] !== serverContent.entry[v]) {
                return true;
            }
            return false;
        });
        if (isKeyInEntryDiff) {
            return true;
        }
        const sendersA = Array.isArray(dbContent.senders) ? dbContent.senders : [dbContent.sender];
        const sendersB = Array.isArray(serverContent.senders) ? serverContent.senders : [serverContent.sender];
        const sendersASet = new Set(sendersA.map(v => v.originName + v.contactItem.contactItemVal));
        const sendersBSet = new Set(sendersB.map(v => v.originName + v.contactItem.contactItemVal));
        const isSendersInclude = util.isArrayInclude([...sendersASet], [...sendersBSet]);
        if (!isSendersInclude) {
            return true;
        }
        const receiversA = Array.isArray(dbContent.receiver) ? dbContent.receiver : [];
        const receiversB = Array.isArray(serverContent.receiver) ? serverContent.receiver : [];
        const receiversASet = new Set(receiversA.map(v => v.originName + v.contactItem.contactItemVal));
        const receiversBSet = new Set(receiversB.map(v => v.originName + v.contactItem.contactItemVal));
        const isReceiversInclude = util.isArrayInclude([...receiversASet], [...receiversBSet]);
        if (!isReceiversInclude) {
            return true;
        }
        return false;
    }
    async doGetMailContent(ids, noFlagInfo, noCache, taskType = 'default', conf) {
        var _a, _b, _c, _d, _e;
        if (util.extractPathFromCid(ids)) {
            return this.doParseEml(ids, conf === null || conf === void 0 ? void 0 : conf._account);
        }
        let result = await this.getMailContentInDb(ids, conf === null || conf === void 0 ? void 0 : conf.noContactRace, conf === null || conf === void 0 ? void 0 : conf._account).then(res => (res ? setMailAttSource(res, 'content') : res));
        console.log('[mail content] got mail content from db: ', result);
        let hasCidImg = false;
        if (result) {
            try {
                if (((_a = result.entry) === null || _a === void 0 ? void 0 : _a.attachment) && ((_b = result.entry) === null || _b === void 0 ? void 0 : _b.attachment.length)) {
                    const contentIds = result.entry.attachment.map(v => v.contentId);
                    const content = ((_c = result.entry.content) === null || _c === void 0 ? void 0 : _c.content) || '';
                    hasCidImg = contentIds.some(contentId => {
                        const cidString = `cid:${contentId}`;
                        if (content.indexOf(cidString) !== -1) {
                            return true;
                        }
                        return false;
                    });
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        if (result && result.isEncryptedMail) {
            result = await this.insertDecryptedContent(result, ids);
        }
        if (result) {
        }
        if (!result || !((_e = (_d = result.entry) === null || _d === void 0 ? void 0 : _d.content) === null || _e === void 0 ? void 0 : _e.content) || noCache || hasCidImg) {
            console.warn('数据库查询邮件详情未成功', ids);
            result = await this.getMailContentFromServer(ids, {
                noFlagInfo,
                noCache,
                taskType,
                noContactRace: conf === null || conf === void 0 ? void 0 : conf.noContactRace,
                _account: conf === null || conf === void 0 ? void 0 : conf._account,
            });
            if (Array.isArray(result === null || result === void 0 ? void 0 : result.entry.attachment) && (result === null || result === void 0 ? void 0 : result.entry.attachment.length) === 1) {
                const datAttachment = result === null || result === void 0 ? void 0 : result.entry.attachment.find(v => v.fileType === 'dat' && v.fileName.endsWith('.dat'));
                if (datAttachment) {
                    this.dataTrackerHelper.track('pc_mail_dat_attachment', {
                        filename: datAttachment.fileName,
                    });
                }
            }
        }
        if (result && result.tags) {
            result.originalTags = result.tags;
            result.tags = result.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
        }
        if (result && !result.sender) {
            result.sender = this.contactHandler.buildEmptyContact(false)[0];
        }
        return result;
    }
    openFilehandleAttachment(attachments, mid, params) {
        return this.mailContentHandler.openFilehandleAttachment(attachments, mid, params);
    }
    async cleanDecryptedCached(_account) {
        var _a;
        const actions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (actions) {
            actions.decryptedMailsCache.clear();
        }
    }
    async insertDecryptedContent(result, id) {
        var _a;
        const { _account } = result;
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const cacheContent = targetActions === null || targetActions === void 0 ? void 0 : targetActions.decryptedMailsCache.get(id);
        if (!(cacheContent === null || cacheContent === void 0 ? void 0 : cacheContent.data) && (cacheContent === null || cacheContent === void 0 ? void 0 : cacheContent.encpwd)) {
            await this.doGetDecryptedContent(id, cacheContent.encpwd, _account);
        }
        const cacheContentAgain = targetActions === null || targetActions === void 0 ? void 0 : targetActions.decryptedMailsCache.get(id);
        if (cacheContentAgain === null || cacheContentAgain === void 0 ? void 0 : cacheContentAgain.data) {
            const { attachments, content } = cacheContentAgain.data;
            result.entry.attachment = attachments;
            result.entry.content = content;
            result.entry.encpwd = cacheContentAgain.encpwd;
            result.isDecrypted = true;
        }
        return result;
    }
    async doGetDecryptedContent(mid, encpwd, _account) {
        var _a;
        const { passed, errMsg, code, data } = await this.mailContentHandler.doGetDecryptedContent(mid, encpwd, _account);
        if (passed && data) {
            const contentInDb = await this.mailDbHandler.doGetMailContent(mid, false, _account);
            const targetActions = (_a = this.getActions({
                actions: this.actions,
                subActions: this.subActions,
                _account: contentInDb === null || contentInDb === void 0 ? void 0 : contentInDb._account,
            })) === null || _a === void 0 ? void 0 : _a.val;
            if (!contentInDb) {
                throw new Error('doGetDecryptedContent no originContent');
            }
            const { html, attachments } = data;
            contentInDb.entry.content = Object.assign(Object.assign({}, contentInDb.entry.content), { content: html.content, contentId: html.contentId, contentLen: html.contentLength });
            const processedModel = await this.mailContentHandler.handleDecryptedMailResponse(contentInDb, attachments, encpwd);
            const cache = {
                encpwd,
                data: {
                    content: processedModel.entry.content,
                    attachments: processedModel.entry.attachment || [],
                },
            };
            targetActions === null || targetActions === void 0 ? void 0 : targetActions.decryptedMailsCache.set(mid, cache);
            return {
                passed: true,
                data: processedModel,
            };
        }
        return {
            passed,
            errMsg,
            code,
        };
    }
    async doChangeMailEncoding(mid, encoding, conf) {
        const result = await this.getMailContentFromServer(mid, {
            encoding,
            _account: conf === null || conf === void 0 ? void 0 : conf._account,
        });
        return result;
    }
    async doGetTpMailContent(params, noCache) {
        var _a, _b;
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser || (currentUser.id === params.owner && params.mailFrom !== 'customer' && params.mailFrom !== 'relatedEmail' && params.mailFrom !== 'subordinate')) {
            console.error('[mail_impl] error doGetTpMailContent', params, currentUser);
            return Promise.reject(new Error('本接口不支持查询本人邮件'));
        }
        if (!params.owner && !params.subEmail) {
            const resultInDb = await this.mailDbHandler.getTpMailById({ id: params.mid, noContent: true });
            if (Array.isArray(resultInDb) && resultInDb.length > 0) {
                const target = resultInDb[0];
                if (target && target.isTpMail && target.owner) {
                    params.owner = target.owner;
                    params.subEmail = target.owner;
                }
            }
        }
        if (!params.owner && !params.subEmail) {
            return Promise.reject(new Error('无法获取三方邮件 owner 属性'));
        }
        const result = await this.mailContentHandler.doGetTpMailContent(params);
        console.log('[tp mail] got mail content from server: ', result, noCache);
        if (result) {
            if (result.tags) {
                result.originalTags = result.tags;
                result.tags = result.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
            }
            if (!result.sender) {
                result.sender = this.contactHandler.buildEmptyContact(false)[0];
            }
            result.entry.attSource = 'content';
            this.saveMails(result).catch();
        }
        else {
            const resultDB = await this.mailDbHandler.doGetTpMailContent(params.mid);
            if (resultDB && ((_b = (_a = resultDB.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content)) {
                return resultDB;
            }
        }
        return result;
    }
    async doGetResignMailContent(params, noCache) {
        const result = await this.mailContentHandler.doGetResignMailContent(params);
        if (result) {
            if (result.tags) {
                result.originalTags = result.tags;
                result.tags = result.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
            }
            if (!result.sender) {
                result.sender = this.contactHandler.buildEmptyContact(false)[0];
            }
            result.entry.attSource = 'content';
            this.saveMails(result).catch();
        }
        else {
        }
        return result;
    }
    async saveMails(mails, taskType = 'default', attrConf, _account) {
        const allMails = Array.isArray(mails) ? mails : [mails];
        const selfMails = allMails.filter(mail => !mail.isTpMail);
        const tpMails = allMails.filter(mail => !!mail.isTpMail);
        if (selfMails.length > 0) {
            await this.mailDbHandler.saveMails(selfMails, taskType, _account, attrConf).catch();
        }
        if (tpMails.length > 0) {
            await this.mailDbHandler.saveTpMails(tpMails).catch();
        }
    }
    async saveMailsByAccounts(mails, taskType = 'default', attrConf, _account) {
        const allMails = Array.isArray(mails) ? mails : [mails];
        const allAccounts = [...new Set(allMails.map(v => v._account).filter(Boolean))];
        const map = new Map();
        allMails.forEach(mail => {
            const key = mail._account || _account;
            if (key) {
                const arr = map.get(key);
                if (Array.isArray(arr)) {
                    arr.push(mail);
                }
                else {
                    map.set(key, [mail]);
                }
            }
        });
        try {
            const saveMailsPromises = allAccounts.map(account => {
                const key = account || _account;
                if (key) {
                    const mailArray = map.get(key) || [];
                    return this.saveMails(mailArray, taskType, attrConf, key);
                }
                return Promise.resolve();
            });
            await Promise.all(saveMailsPromises);
        }
        catch (error) {
            console.log('[saveMailsByAccounts] error:', error);
        }
    }
    async clearExpiredMails() {
        const needClear = await this.mailDbHandler.checkAndSetClearFlag();
        console.log('[mail clear] needClear', needClear);
        if (needClear) {
            const mids = await this.mailDbHandler.collectExpiredMailIds();
            console.log('[mail clear] find ids to check', mids);
            if (mids.length > 0) {
                await this.syncMailByIds(mids);
            }
        }
    }
    async handleSendMDN(id, _account) {
        const urlKey = 'sendMDN';
        const url = this.modelHandler.buildUrl({ key: urlKey, _account });
        const dt = {
            id,
            dispositionInfo: {
                mode: 'manual',
                type: 'displayed',
            },
        };
        return this.impl.post(url, dt, {
            contentType: 'json',
            _account,
        });
    }
    async getDeliveryTagUnread(value, _account) {
        return this.mailContentHandler.getDeliveryTagUnread(value, _account);
    }
    async gptEmailWrite(req, cb = (data) => console.log(data), errorCB = (err) => console.log(err), taskId = '') {
        return this.impl
            .post(this.systemApi.getUrl('getMailGPTWrite'), Object.assign(Object.assign(Object.assign({}, (!process.env.BUILD_ISEDM ? { fromScene: 1 } : {})), { taskId, first: !taskId }), req), {
            timeout: 2 * 60 * 1000,
            contentType: 'json',
        })
            .then(({ data }) => {
            if (!(data === null || data === void 0 ? void 0 : data.success) || !data.data || data.data.finishState === 2) {
                return data;
            }
            if (data.data.finishState === 1) {
                cb(data.data);
                return data.data;
            }
            if (data.data.finishState === 0) {
                const newTaskid = data.data.taskId;
                return setTimeout(() => {
                    this.gptEmailWrite(req, cb, errorCB, newTaskid);
                }, 500);
            }
            return '';
        })
            .catch(e => {
            errorCB(e);
        });
    }
    gptEmailRetouch(req, cb = (data) => console.log(data), errorCB = (err) => console.log(err), taskId = '') {
        return this.impl
            .post(this.systemApi.getUrl('getMailGPTPolish'), Object.assign(Object.assign(Object.assign({}, (!process.env.BUILD_ISEDM ? { fromScene: 1 } : {})), { taskId, first: !taskId }), req), {
            timeout: 2 * 60 * 1000,
            contentType: 'json',
        })
            .then(({ data }) => {
            if (!(data === null || data === void 0 ? void 0 : data.success) || !data.data || data.data.finishState === 2) {
                return data;
            }
            if (data.data.finishState === 1) {
                cb(data.data);
                return data.data;
            }
            if (data.data.finishState === 0) {
                const newTaskid = data.data.taskId;
                return setTimeout(() => {
                    this.gptEmailRetouch(req, cb, errorCB, newTaskid);
                }, 500);
            }
            return '';
        })
            .catch(e => {
            errorCB(e);
        });
    }
    getGPTQuota() {
        return this.impl
            .get(this.systemApi.getUrl('getMailGPTQuote'), !process.env.BUILD_ISEDM
            ? {
                fromScene: 1,
            }
            : {})
            .then(res => { var _a; return ((_a = res.data) === null || _a === void 0 ? void 0 : _a.data) || { dayLeft: 0, dayLimit: 0 }; });
    }
    getGptConfig() {
        return this.impl.get(this.systemApi.getUrl('getMailGPTConfig'), {});
    }
    getGptRecord(req) {
        return this.impl.get(this.systemApi.getUrl('getMailGPTHistory'), req).then(res => { var _a; return (_a = res.data) === null || _a === void 0 ? void 0 : _a.data; });
    }
    async doTranslateGPTAiContent(req, token) {
        const res = await this.impl.post(this.systemApi.getUrl('doTranslateGPTAiContent'), req, {
            contentType: 'json',
            noEnqueue: true,
        });
        return Object.assign(Object.assign({}, res.data), { token });
    }
    filterThreadFolder(data) {
        return data.filter(v => [1, 3].includes(v.entry.folder) || v.entry.folder > 20);
    }
    addThreadMessageIdsForCorp(list, threadMesageIds = []) {
        if (list && list.length) {
            list.forEach(item => {
                item.entry.threadMessageIds = threadMesageIds;
                item.entry.threadMessageCount = threadMesageIds.length;
            });
        }
    }
    async doGetThreadMailContent(id, params, noCache, threadMailIds, _account) {
        if (!id) {
            return Promise.reject(new Error('invalid mail thread id'));
        }
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const threadId = isCorpMail ? id : util.resetThreadMailId(id, true);
        const result = await this.doGetThreadMailContentFromDb(id, params, _account);
        const useSeverRes = isCorpMail || noCache || !result || result.length === 0;
        console.log('[thread mail] content use server res', id, useSeverRes);
        const ids = isCorpMail ? threadMailIds : [threadId];
        const serverPromise = this.mailContentHandler.getThreadMailContentFromNetwork(ids, params, useSeverRes, _account).then(res => {
            console.log('[thread mail] content from server', id, params, res);
            const networkRes = Array.isArray(res) ? res : res.data;
            const dtA = result ? result.filter(it => !it.id.endsWith('-tmp')) : [];
            const dtB = Array.isArray(networkRes) ? networkRes.filter(it => !it.id.endsWith('-tmp')) : [];
            const total = Array.isArray(networkRes) ? networkRes.length : 0;
            const syncParams = Object.assign(Object.assign({}, params), { count: 3000 });
            this.syncAndResendMailEntryHandler(dtA, dtB, total, {
                param: syncParams,
                fromNetwork: useSeverRes,
                threadId: id,
                _account,
            }).then(isChanged => {
                console.log('[thread mail] content diff', id, isChanged);
            });
            if (Array.isArray(res)) {
                if (isCorpMail) {
                    this.addThreadMessageIdsForCorp(res, threadMailIds);
                }
                return res;
            }
            return Object.assign(Object.assign({}, res), { data: Array.isArray(res.data) ? res.data : [] });
        });
        if (useSeverRes) {
            return serverPromise;
        }
        return result;
    }
    async doGetThreadMailContentFromDb(threadId, params, _account) {
        let result = [];
        const orderDesc = params === null || params === void 0 ? void 0 : params.desc;
        const query = Object.assign({ start: params && params.start ? params.start : 0, count: params && params.limit ? params.limit : 3000, adCondition: {
                field: ['isThread', 'threadId', 'rcTime'],
                type: 'between',
                args: [[0, threadId, orderDesc ? -Number.MAX_VALUE : 0], [0, threadId, orderDesc ? 0 : -Number.MAX_VALUE], true, true],
            } }, mailTable.status);
        const detailMailsStatus = (await this.db.getByRangeCondition(query, _account)).filter(v => !!v);
        if (detailMailsStatus.length > 0) {
            const detailMids = detailMailsStatus.map(v => v.mid);
            const detailMails = await this.getMailEntryInDb(detailMids, false, false, _account);
            result = Array.isArray(detailMails) ? detailMails : [];
        }
        console.log('[thread mail] content from db', threadId, params, result);
        return result;
    }
    doGetThreadMailStatus(id, noCache) {
        return this.mailContentHandler.doGetGroupMailStatus(id, noCache);
    }
    async getMailContentInDb(ids, noContactRace = false, _account) {
        const result = await this.mailDbHandler.doGetMailContent(ids, noContactRace, _account);
        return result;
    }
    async getMailContentFromServer(id, conf) {
        const { noFlagInfo, noCache, taskType = 'default', noContactRace = false, _account, encoding } = conf;
        const result = await this.mailContentHandler
            .doGetMailContent(id, {
            noFlagInfo,
            noCache,
            noContactRace,
            _account,
            encoding,
        })
            .then(res => setMailAttSource(res, 'content'));
        console.log('[mail content] from server', result);
        if (!noFlagInfo) {
            this.saveMails(result, taskType, undefined, _account).catch();
        }
        return result;
    }
    async getMailEntryInDb(ids, noContact, noStatus, _account) {
        return this.mailDbHandler.getMailById({
            id: ids,
            noContact,
            noStatus,
            _account,
        });
    }
    doGetReplayContentModel(content) {
        return this.mailOperationHandler.doGetReplayContentModel(content);
    }
    async createUserFolder(items, config, _account) {
        const { syncMailFolder = true } = config;
        return this.mailContentHandler.createUserFolder(items, _account).then(async (res) => {
            if (syncMailFolder) {
                await this.syncMailFolder(_account);
            }
            return res;
        });
    }
    async updateUserFolder(items, _account) {
        return this.mailContentHandler.updateUserFolder(items, _account).then(async (res) => {
            await this.syncMailFolder(_account);
            return res;
        });
    }
    async deleteUserFolder(items, account) {
        return this.mailContentHandler.deleteUserFolder(items, account).then(async (res) => {
            await this.syncMailFolder(account);
            return res;
        });
    }
    async updateMessageInfos(item, _account) {
        return this.mailOperationHandler.updateMessageInfos(item, _account);
    }
    async doListMailBox(noCache, updateStat, from, _account) {
        console.log('[mail box] doListMailBox', noCache, updateStat, from);
        try {
            let result;
            if (!noCache && !updateStat) {
                result = await this.mailDbHandler.doListMailBox(_account);
                console.log('[mail] doListMailBox from db ', result);
                if (result) {
                    this.syncAndResendMailBox(result, _account);
                    return result;
                }
            }
        }
        catch (e) {
            console.warn(e);
        }
        let res = [];
        try {
            res = await this.listMailBoxFromNetwork(noCache, updateStat, _account);
        }
        catch (e) {
            try {
                res = (await this.mailDbHandler.doListMailBox(_account)) || [];
            }
            catch (e) {
                console.warn(e);
            }
            console.warn(e);
        }
        if (from === 'refreshFolder') {
            this.loggerHelper.track('do_list_mail_box_by_refresh_folder', { res, noCache, updateStat });
        }
        return res;
    }
    async doListMailBoxByAccountIds(noCache, _accountIds) {
        console.log('[mail box] doListMailBoxByAccountIds', noCache, _accountIds);
        const accountIds = _accountIds || [this.systemApi.getMainAccount().email];
        try {
            const result = {};
            if (!noCache) {
                const promises = accountIds.map(accountId => this.mailDbHandler.doListMailBox(accountId));
                const mailBoxModelResult = await Promise.all(promises);
                mailBoxModelResult.forEach((item, index) => {
                    result[accountIds[index]] = item || [];
                });
                console.log('[mail] doListMailBoxByAccountIds from db ', result);
                if (result) {
                    return result || [];
                }
            }
        }
        catch (e) {
            console.warn(e);
        }
        let res = {};
        try {
            res = await this.listMailBoxByAccountIdsFromNetwork(noCache, accountIds);
        }
        catch (e) {
            const promises = accountIds.map(accountId => this.mailDbHandler.doListMailBox(accountId));
            const mailBoxModelResult = await Promise.all(promises);
            mailBoxModelResult.forEach((item, index) => {
                res[accountIds[index]] = item || [];
            });
        }
        return res;
    }
    syncAndResendMailBox(cacheResult, _account) {
        this.listMailBoxFromNetwork(true, false, _account).then(netResult => {
            const diff = this.modelHandler.compareMailBoxModel(cacheResult, netResult);
            if (diff) {
                this.eventApi.sendSysEvent({
                    eventName: 'mailChanged',
                    eventStrData: 'syncFolder',
                    eventData: netResult,
                    toAccount: [this.systemApi.getMainAccount().email],
                    _account,
                });
            }
        });
    }
    listMailBoxFromNetwork(noCache, updateStat, _account) {
        const entries = [];
        const promise = this.mailContentHandler.doListMailBox(noCache, updateStat, entries, _account);
        return promise.then(async (res) => {
            const crearFolderTable = true;
            await this.mailDbHandler.saveMailBoxes(entries, _account, crearFolderTable);
            const unread = this.calUnreadFromModel(entries, _account);
            this.modelHandler.updateUnreadCount(unread, _account);
            return res;
        });
    }
    listMailBoxByAccountIdsFromNetwork(noCache, _accountIds) {
        const entries = {};
        const promise = this.mailContentHandler.doListMailBoxByAccountIds(!!noCache, entries, _accountIds);
        return promise.then(async (res) => {
            const crearFolderTable = true;
            return res;
        });
    }
    calUnreadFromModel(entries, _account) {
        const isThread = this.mailConfApi.getMailMergeSettings(_account) === 'true';
        let unread = 0;
        entries.forEach((entry) => {
            if (entry.mailBoxId === mailBoxOfDefault.id || entry.mailBoxType === 'customer' || entry.mailBoxId === mailBoxOfWaitingIssue.id) {
                unread += isThread ? entry.threadMailBoxCurrentUnread : entry.mailBoxCurrentUnread;
            }
        });
        return unread;
    }
    syncAndResendMailEntry(param, cacheRes, networkRes, account) {
        const _account = account || param._account;
        param.noContactRace = true;
        if (networkRes) {
            this.mailDbHandler.doListMailEntry(param, _account).then(async (res) => {
                const dtA = res && res.data ? res.data.filter(it => !it.id.endsWith('-tmp')) : [];
                const dtB = Array.isArray(networkRes) ? networkRes.filter(it => !it.id.endsWith('-tmp')) : [];
                const total = Array.isArray(networkRes) ? networkRes.length : 0;
                await this.syncAndResendMailEntryHandler(dtA, dtB, total, {
                    param,
                    fromNetwork: true,
                    _account,
                });
            });
        }
        else {
            this.listMailEntryFromNetwork(param, true).then(async (res) => {
                var _a;
                const total = Array.isArray(res) ? res.length : res.total;
                const targetActions = (_a = this.getActions({
                    actions: this.actions,
                    subActions: this.subActions,
                    _account,
                })) === null || _a === void 0 ? void 0 : _a.val;
                if ((targetActions === null || targetActions === void 0 ? void 0 : targetActions.curRealListReqSeq) === param.querySeq && param.isRealList) {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailRealListTotalChanged',
                        eventData: {
                            netWorkTotal: total,
                        },
                        _account,
                    });
                }
                const dtA = cacheRes ? cacheRes.data.filter(it => !it.id.endsWith('-tmp')) : [];
                const dtB = (Array.isArray(res) ? res : res.data).filter(it => !it.id.endsWith('-tmp'));
                await this.syncAndResendMailEntryHandler(dtA, dtB, total, {
                    param,
                    fromNetwork: false,
                    _account,
                });
            });
        }
    }
    syncAndResendMailEntryByAccounts(param, cacheRes, networkRes, _account) {
        param.noContactRace = true;
        if (networkRes) {
            const saveModels = Array.isArray(networkRes) ? networkRes.filter(it => !it.id.endsWith('-tmp')) : [];
            this.saveMailsByAccounts(saveModels, undefined, param.attrConf, _account);
        }
        else {
            this.listMailEntryFromNetworkByAccounts(param, true).then(async (res) => {
                const total = Array.isArray(res) ? res.length : res.total;
                const dtA = cacheRes ? cacheRes.data.filter(it => !it.id.endsWith('-tmp')) : [];
                const dtB = (Array.isArray(res) ? res : res.data).filter(it => !it.id.endsWith('-tmp'));
                await this.syncAndResendMailEntryHandler(dtA, dtB, total, {
                    param,
                    fromNetwork: false,
                    _account,
                });
            });
        }
    }
    async syncAndResendMailEntryHandler(dtA, dtB, total, conf) {
        const { param, fromNetwork = false, _account } = conf;
        const eventRefreshType = 'regularMail';
        const isThread = this.mailConfApi.getMailMergeSettings(_account) === 'true';
        const eventMerge = !isThread && param.id !== mailBoxOfTask.id;
        const forEdmMail = edmMailHelper.isEdmMailReq(param.checkType);
        if (!dtA || !dtB) {
            this.doCallMailMsgCenter({
                type: 'syncMail',
                msgCenter: {
                    merge: eventMerge,
                    diff: !dtA || !dtB,
                    refreshType: eventRefreshType,
                },
                checkType: conf.param.checkType,
            }, _account);
            return false;
        }
        const { changedModels, delModels, allModels } = this.compareAllMail(dtA, dtB);
        const needChange = changedModels.length > 0;
        const needDel = delModels.length > 0;
        const isDiff = allModels.length > 0;
        if (!fromNetwork) {
            if (dtA.length === dtB.length && dtB.length < param.count && total === (param.index || 0) + dtA.length) {
                if (!needChange && !needDel) {
                    if (!param.isRealList) {
                        this.eventApi.sendSysEvent({
                            eventName: 'mailChanged',
                            eventStrData: 'syncMailTotal',
                            eventData: { total, param },
                            _account,
                        });
                    }
                    if (!forEdmMail) {
                        this.doCallMailMsgCenter({
                            type: 'syncMail',
                            msgCenter: {
                                merge: eventMerge && !forEdmMail,
                                diff: isDiff,
                                refreshType: eventRefreshType,
                            },
                            checkType: conf.param.checkType,
                        }, _account);
                    }
                    return false;
                }
            }
        }
        const allIds = changedModels.map(v => v.id);
        if (needChange) {
            const saveModels = conf.threadId
                ? changedModels.map(v => (Object.assign(Object.assign({}, v), { threadId: conf.threadId })))
                : changedModels;
            const saveModelsAccounts = [...new Set(saveModels.map(v => v._account).filter(Boolean))];
            if (Array.isArray(param.subEmails) && !!param.subEmails.filter(Boolean).length && saveModelsAccounts.length > 1) {
                await this.saveMailsByAccounts(saveModels, undefined, conf.param.attrConf, _account);
            }
            else {
                await this.saveMails(saveModels, undefined, conf.param.attrConf, _account);
            }
            const threadMessageChangeIds = await this.syncThreadMessages(changedModels, _account);
            allIds.push(...threadMessageChangeIds);
        }
        if (needDel) {
            const selfDelIds = delModels.filter(v => !v.isTpMail).map(v => v.id);
            if (selfDelIds.length > 0) {
                const delModelsAccounts = [...new Set(delModels.map(v => v._account).filter(Boolean))];
                if (Array.isArray(param.subEmails) && !!param.subEmails.filter(Boolean).length && delModelsAccounts.length > 1) {
                }
                else {
                    await this.syncMailByIds(selfDelIds, param.checkType, true, _account);
                }
                allIds.push(...selfDelIds);
            }
            const tpDelIds = delModels.filter(v => v.isTpMail && v.owner).map(v => ({ mids: [v.id], email: v.owner || '' }));
            if (tpDelIds.length > 0) {
                await this.syncTpMailByIds(tpDelIds, param.checkType);
            }
            if (param.checkType === 'checkStarMail') {
                const needDeleteAttrList = delModels.filter(v => mailBoxOfFilterStar[v.entry.folder]).map(v => v.id);
                if (needDeleteAttrList.length > 0) {
                    this.mailDbHandler.deleteMailAttrByMids(needDeleteAttrList, _account).then();
                }
            }
        }
        const diff = !fromNetwork && isDiff;
        this.doCallMailMsgCenter({
            type: 'syncMail',
            data: diff ? Object.assign(Object.assign({}, param), { changedModels }) : param,
            msgCenter: {
                merge: eventMerge && !forEdmMail,
                diff: diff,
                refreshType: eventRefreshType,
            },
            checkType: conf.param.checkType,
        }, _account);
        return isDiff;
    }
    async syncThreadMessages(models, _account) {
        const tempIds = [];
        models.forEach(model => {
            if (model.isThread && Array.isArray(model.entry.threadMessageIds)) {
                tempIds.push(...model.entry.threadMessageIds);
            }
        });
        const threadMessageIds = [...new Set(tempIds)];
        const threadMessageInDb = (await this.db.getByIds(mailTable.status, threadMessageIds, _account));
        const threadMessageIdsInDb = threadMessageInDb.filter(v => !!v).map(v => v.mid);
        const threadMessageChangeIds = threadMessageIds.filter(id => !threadMessageIdsInDb.includes(id));
        await this.syncMailByIds(threadMessageChangeIds, 'normal', true, _account);
        await this.mailDbHandler.saveThreadIds(models);
        return threadMessageChangeIds;
    }
    compareAllMail(dtA, dtB) {
        const delModels = [];
        const changedModels = [];
        const dtAMap = dtA.reduce((total, current) => {
            const id = current.isThread && current.threadId ? current.threadId.split('--')[0] : current.id;
            return total.set(id, current);
        }, new Map());
        const dtBMap = dtB.reduce((total, current) => {
            const id = current.isThread && current.threadId ? current.threadId.split('--')[0] : current.id;
            return total.set(id, current);
        }, new Map());
        dtAMap.forEach((itemA, id) => {
            const itemB = dtBMap.get(id);
            if (!itemB) {
                delModels.push(itemA);
            }
            else {
                const idDifferent = this.modelHandler.compareMailEntryModel(itemA, itemB);
                if (idDifferent) {
                    changedModels.push(itemB);
                }
                dtBMap.delete(id);
            }
        });
        if (dtBMap.size > 0) {
            dtBMap.forEach(itemB => {
                changedModels.push(itemB);
            });
        }
        return {
            delModels,
            changedModels,
            allModels: [...delModels, ...changedModels],
        };
    }
    async doListMailEntitiesFromDb(param, _account) {
        var _a;
        const isThread = this.mailConfApi.getMailMergeSettings() === 'true';
        param.returnModel = true;
        if (edmMailHelper.isEdmMailReq(param.checkType) || param.attrQuery) {
            return this.doListMailEntitiesFromDbInternal(param);
        }
        if (isThread || (param.mids && param.mids.length > 0)) {
            return this.doListMailEntitiesFromDbInternal(param, _account);
        }
        if (param.id === mailBoxOfTask.id) {
            return (await this.getTaskMailInTaskFolder(param));
        }
        const noDeleteTaskMail = true;
        const mailModel = await this.doListMailEntitiesFromDbInternal(param, _account);
        if (mailModel) {
            const mailModelCopied = Object.assign(Object.assign({}, mailModel), { data: [...mailModel.data] });
            const targetActions = (_a = this.getActions({
                actions: this.actions,
                subActions: this.subActions,
                _account,
            })) === null || _a === void 0 ? void 0 : _a.val;
            const result = noDeleteTaskMail
                ? mailModelCopied.data
                : await this.handleDeleteTaskInMailModel(mailModel, targetActions === null || targetActions === void 0 ? void 0 : targetActions.taskMailMap, (param.index || 0) === 0, true, _account);
            mailModelCopied.data = result;
            return mailModelCopied;
        }
        return undefined;
    }
    async doListMailEntitiesFromDbInternal(param, _account) {
        var _a;
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (param.id && (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxDic) && (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxDic[param.id]) && (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxDic[param.id].locked)) {
            return Promise.reject(ErrResult.FA_NEED_AUTH2);
        }
        let data = await this.mailDbHandler.doListMailEntry(param, _account);
        if (data) {
            if (!param.isRealList) {
                data.total += param.count;
            }
        }
        else {
            data = {
                count: 0,
                index: param.index || 0,
                query: param,
                total: 0,
                data: [],
                building: -1,
            };
        }
        return data;
    }
    sortMailList(list) {
        if (list && list.length) {
            return [...list].sort((a, b) => {
                if (a.entry.sendTime && b.entry.sendTime) {
                    const aDate = util.parseDate(a.entry.sendTime);
                    const bDate = util.parseDate(b.entry.sendTime);
                    if (aDate && bDate) {
                        return bDate - aDate;
                    }
                }
                return 0;
            });
        }
        return [];
    }
    getLocalPageData(list, startIndex, pageSize) {
        if (!list || !list.length) {
            return { total: 0, data: [] };
        }
        const total = list.length;
        if (total <= startIndex) {
            return { total, data: [] };
        }
        return {
            data: list.slice(startIndex, startIndex + pageSize),
            total,
        };
    }
    orderByMailList(list, param) {
        console.log('[mail] before orderByMailList', list, param);
        let res;
        const orderbyParams = ['entry.sendTime'];
        const orderType = ['desc'];
        if (list && list.length) {
            if (param.order === 'from') {
                orderbyParams[0] = 'sender.contact.contact.contactLabel';
            }
            else if (param.order === 'size') {
                orderbyParams[0] = 'entry.size';
            }
            else if (param.order === 'subject') {
                orderbyParams[0] = 'entry.title';
            }
            else if (param.order === 'to') {
                orderbyParams[0] = 'receiver[0].contact.contact.contactLabel';
            }
            if (!param.desc) {
                orderType[0] = 'asc';
            }
            res = lodashOrderBy([...list], orderbyParams, orderType);
            if (param.isRealList) {
                return this.getLocalPageData(list, param.index || 0, param.count);
            }
            console.log('[mail] after orderByMailList', res, param);
            return res;
        }
        return [];
    }
    removeThreadInfoForCorp(list) {
        if (list && list.length) {
            list.forEach(item => {
                item.isThread = false;
                item.entry.threadMessageIds = undefined;
                item.entry.threadMessageCount = 0;
            });
        }
    }
    async refreshPageSequential() {
        const requests = [
            {
                func: 'getTaglist',
            },
            {
                func: 'listFolder',
                var: { order: 'custom_virtual' },
            },
            {
                func: 'statMailCount',
                var: this.mailContentHandler.getDoStatMessagesParams(),
            },
        ];
        return this.mailContentHandler.doRequestSequential(requests);
    }
    async doListMailBoxEntities(param, noCache) {
        var _a;
        const { _account } = param;
        if (param.id === FLOLDER.CUSTOMER_UNFOLLOW || param.id === FLOLDER.UNFOLLOW) {
            noCache = true;
        }
        if (param.isResign) {
            return this.doListEdmMailBoxEntities(param, noCache);
        }
        if (edmMailHelper.isEdmMailReq(param.checkType) || param.attrQuery) {
            return this.doListEdmMailBoxEntities(param, noCache);
        }
        if (param.checkType === 'checkStarMail') {
            if (!this.modelHandler.isValidStarFolderId(param.id)) {
                return {
                    data: [],
                    total: 0,
                    index: param.index || 0,
                    count: param.count,
                    query: param,
                };
            }
            return this.doListMailBoxEntriesInternal(param, noCache);
        }
        if (Array.isArray(param === null || param === void 0 ? void 0 : param.subEmails) && !!(param === null || param === void 0 ? void 0 : param.subEmails.filter(Boolean).length)) {
            const mailModel = await this.doListMailBoxEntriesInternalByAccounts(param, noCache);
            return Object.assign(Object.assign({}, mailModel), { data: [...mailModel.data] });
        }
        let result = [];
        const isThread = this.mailConfApi.getMailMergeSettings(_account) === 'true';
        if (isThread && param.id !== mailBoxOfTask.id) {
            return this.doListMailBoxEntriesInternal(param, noCache);
        }
        if (param.mids && param.mids.length > 0) {
            return this.doListMailBoxEntriesInternal(param, noCache);
        }
        if ((!param.mids || param.mids.length === 0) && param.checkType !== 'checkRelatedMail') {
            const isTaskMailBox = param.id === mailBoxOfTask.id;
            if (isTaskMailBox) {
                return this.getTaskMailInTaskFolder(param);
            }
            const noDeleteTaskMail = true;
            const mailModel = await this.doListMailBoxEntriesInternal(param, noCache);
            const mailModelCopied = Object.assign(Object.assign({}, mailModel), { data: [...mailModel.data] });
            const targetActions = (_a = this.getActions({
                actions: this.actions,
                subActions: this.subActions,
                _account,
            })) === null || _a === void 0 ? void 0 : _a.val;
            result = noDeleteTaskMail
                ? mailModelCopied.data
                : await this.handleDeleteTaskInMailModel(mailModelCopied, targetActions === null || targetActions === void 0 ? void 0 : targetActions.taskMailMap, (param.index || 0) === 0, undefined, _account);
            mailModelCopied.data = result;
            return mailModelCopied;
        }
        return Promise.reject(new Error('not implemented'));
    }
    async doListEdmMailBoxEntities(param, noCache) {
        noCache = true;
        const { attrQuery, tpMids } = param;
        if (param.isResign) {
            const tpResult = await this.syncResignMailByIds(param);
            return {
                data: tpResult,
                total: tpResult.length + 1,
                index: 0,
                count: 1,
                query: param,
            };
        }
        if (Array.isArray(tpMids) && tpMids.length > 0) {
            const tpResult = await this.syncTpMailByIds(tpMids, param.checkType);
            return {
                data: tpResult,
                total: tpResult.length + 1,
                index: 0,
                count: tpMids.length,
                query: param,
            };
        }
        if (!attrQuery || (Array.isArray(attrQuery) && attrQuery.length === 0)) {
            return Promise.resolve({
                count: param.count || 0,
                index: param.index || 0,
                query: param,
                total: 0,
                data: [],
                building: -1,
            });
        }
        let result;
        if (!noCache) {
            result = await this.mailDbHandler.doListMailEntry(param);
            console.log('[customer mail] get mail from db', result);
            if (result && result.data && result.data.length > 0) {
                result.total = (param.index || 0) + result.data.length * 2;
                this.syncAndResendMailEntry(param, result);
                return result;
            }
        }
        param.returnModel = true;
        return this.listMailEntryFromNetwork(param, noCache).then(res => {
            const result = res;
            console.log('[customer mail] get mail from network', result);
            const { data } = result;
            if (param.checkType !== 'checkSubordinateMail') {
                this.syncAndResendMailEntry(param, undefined, data);
            }
            if (!result.over) {
                result.total = (param.index || 0) + (data || []).length * 2;
            }
            else {
                result.total = 0;
            }
            return result;
        });
    }
    async doUpdateCustomersByNewMail(models, type) {
        const senderEmailList = models.filter(model => { var _a, _b, _c; return (_c = (_b = (_a = model === null || model === void 0 ? void 0 : model.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName; }).map(model => model.sender.contact.contact.accountName);
        const receiverEmailList = models.reduce((total, model) => {
            const list = model.receiver.filter(v => { var _a, _b; return (_b = (_a = v === null || v === void 0 ? void 0 : v.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName; }).map(v => v.contact.contact.accountName);
            total.push(...list);
            return total;
        }, []);
        const allEmailList = [...senderEmailList, ...receiverEmailList];
        const res = await this.mailPlusCustomerApi.doGetRoleByEmail({ emails: allEmailList, useLx: false });
        const senderIdList = edmMailHelper.getMyCustomerByEmailList(res, senderEmailList);
        const receiverIdList = edmMailHelper.getMyCustomerByEmailList(res, receiverEmailList);
        await this.eventApi.sendSysEvent({
            eventName: 'mailChanged',
            eventStrData: 'refreshCustomer',
            eventData: {
                type: type || 'all',
                senderIdList,
                receiverIdList,
            },
        });
    }
    async doCustomersUnread(param) {
        var _a;
        if ((process.env.BUILD_ISLINGXI && !((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) || !this.edmRoleApi.doGetContactViewPrivilege()) {
            return {
                initialized: true,
                total: 0,
                items: [],
            };
        }
        let result;
        if (Array.isArray(param.customerIds) && param.customerIds.length > 0) {
            result = await this.mailContentHandler.doCustomersUnread(param);
            console.log('[customer unread] detail', result);
        }
        else {
            result = await this.mailContentHandler.doCustomersUnreadTotal();
            console.log('[customer unread] total', result);
        }
        return result;
    }
    async getSharedAccountsUnread() {
        return this.mailContentHandler.getSharedAccountsUnread();
    }
    async getTaskMailInTaskFolder(param) {
        const taskInternalMap = await this.doGetFullTaskMailList(param, true);
        let result = [];
        const mids = [...taskInternalMap.mailIdMap.keys()];
        console.log('[task-mail]', param, mids);
        if (mids.length > 0) {
            const taskIdMailModel = await this.doListMailBoxEntriesInternal({
                mids,
                count: mids.length,
                id: param.id,
            }, false);
            if (taskIdMailModel.data && taskIdMailModel.data.length > 0) {
                taskIdMailModel.data = await this.setTaskInfoToMailModel(taskIdMailModel.data, taskInternalMap.taskMap);
            }
            result = [...taskIdMailModel.data];
        }
        const count = result ? result.length : 0;
        if (count > 0) {
            this.mailTaskApi.setTaskPageInfo(param.index || 0, count);
        }
        const paramIndex = param.index || 0;
        return param.returnModel
            ? {
                query: param,
                count,
                data: result || [],
                total: taskInternalMap.hasMore === 0 || result.length === 0 ? param.index : paramIndex + count + 1,
            }
            : result;
    }
    async handleDeleteTaskInMailModel(mailModel, maps, handleTop, onlyDb = false, _account) {
        const isSubCountReq = window === null || window === void 0 ? void 0 : window.isAccountBg;
        if (isSubCountReq) {
            handleTop = false;
        }
        const { mailIdMap, taskMap, twoTaskIds } = maps;
        let top = [];
        const ret = [];
        const taskAllSize = mailIdMap.size;
        mailModel.data.forEach((model) => {
            if (!model.taskId || !mailIdMap.has(model.entry.id)) {
                ret.push(model);
            }
            if (handleTop) {
                const isTaskTop = twoTaskIds.has(model.id);
                if (isTaskTop) {
                    const taskModel = twoTaskIds.get(model.id);
                    if (taskModel) {
                        model.entry.taskTop = true;
                        model.entry.taskNum = taskAllSize;
                        top[taskModel.pos] = model;
                        twoTaskIds.delete(model.id);
                    }
                }
            }
        });
        if (handleTop && twoTaskIds.size > 0) {
            const entries = onlyDb
                ? await this.doListMailEntitiesFromDbInternal({
                    mids: Array.from(twoTaskIds.keys()),
                    count: twoTaskIds.size,
                }, _account)
                : await this.doListMailBoxEntriesInternal({
                    mids: Array.from(twoTaskIds.keys()),
                    count: twoTaskIds.size,
                    _account,
                }, false);
            if (entries && entries.data) {
                entries.data.forEach(mail => {
                    const taskModel = twoTaskIds.get(mail.id);
                    if (taskModel) {
                        mail.entry.taskTop = true;
                        mail.entry.taskNum = taskAllSize;
                        top[taskModel.pos] = mail;
                    }
                });
            }
        }
        else {
        }
        top = top.filter(it => !!it);
        top = await this.setTaskInfoToMailModel(top, taskMap);
        return [...top, ...ret];
    }
    async doGetFullTaskMailList(param, noCache, onlyDb = false) {
        var _a;
        const mailIdMap = new Map();
        const twoTaskIds = new Map();
        const taskMap = new Map();
        const idx = (param === null || param === void 0 ? void 0 : param.index) || 0;
        const { page } = param.isRealList ? { page: Math.floor(idx / param.count) + 1 } : this.mailTaskApi.getTaskPageInfo(idx);
        const reqParams = {
            status: ((_a = param.filter) === null || _a === void 0 ? void 0 : _a.taskTab) === 0 ? 0 : 1,
            page: param.id === mailBoxOfTask.id ? page : -1,
            size: param.count,
            detailCount: param.id === mailBoxOfTask.id ? -1 : this.topTaskNum,
        };
        const taskList = await this.mailTaskApi.doGetFullTaskMailList(reqParams, noCache, onlyDb);
        let hasMore = 0;
        if (taskList.success && taskList.data) {
            const { todoList, todoToMails, hasNextPage } = taskList.data;
            if (todoList && todoList.length > 0) {
                todoList.forEach(it => {
                    taskMap.set(it.todoId, it);
                });
            }
            if (todoToMails && todoToMails.length > 0) {
                todoToMails.forEach((it, idx) => {
                    mailIdMap.set(it.mid, String(it.todoId));
                    if (idx < this.topTaskNum) {
                        twoTaskIds.set(it.mid, {
                            mid: it.mid,
                            pos: idx,
                            todoId: it.todoId || -1,
                        });
                    }
                });
            }
            hasMore = hasNextPage;
        }
        return {
            mailIdMap,
            twoTaskIds,
            hasMore,
            taskMap,
        };
    }
    async setTaskInfoToMailModel(mailModel, map) {
        const todoIds = [];
        let _account;
        mailModel.forEach(model => {
            if (model.taskId) {
                todoIds.push(model.taskId);
                _account = model._account;
            }
        });
        if (todoIds.length > 0) {
            const { completeTaskMap } = await this.doGetTaskMailContent(todoIds, map, _account);
            mailModel.forEach(model => {
                if (model.taskId && completeTaskMap.has(String(model.taskId))) {
                    model.taskInfo = completeTaskMap.get(String(model.taskId));
                }
            });
        }
        return mailModel;
    }
    async doGetTaskMailContent(todoIds, map, _account) {
        var _a, _b;
        const completeTaskMap = new Map();
        const remain = [];
        const idss = Array.isArray(todoIds) ? todoIds : [todoIds];
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const taskMap = (_b = targetActions === null || targetActions === void 0 ? void 0 : targetActions.taskMailMap) === null || _b === void 0 ? void 0 : _b.taskMap;
        if ((taskMap && taskMap.size > 0) || (map && map.size > 0)) {
            idss.forEach(it => {
                if (taskMap && taskMap.has(it)) {
                    completeTaskMap.set(String(it), taskMap.get(it));
                }
                else if (map && map.has(it)) {
                    completeTaskMap.set(String(it), map.get(it));
                }
                else {
                    remain.push(it);
                }
            });
        }
        else {
            remain.push(...idss);
        }
        if (remain.length > 0) {
            const taskMailModel = await this.mailTaskApi.doGetTaskMailContent(remain, false);
            if (taskMailModel.success && taskMailModel.data) {
                taskMailModel.data.forEach(model => {
                    completeTaskMap.set(String(model.todoId), model);
                });
            }
        }
        return { completeTaskMap };
    }
    async doListMailBoxEntriesInternal(param, noCache) {
        var _a;
        param.returnModel = true;
        const { _account } = param;
        const actions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (param.id && actions && actions.mailBoxDic && actions.mailBoxDic[param.id] && actions.mailBoxDic[param.id].locked) {
            return Promise.reject(ErrResult.FA_NEED_AUTH2);
        }
        if (actions) {
            actions.curMailListReqSeq = actions.curMailSequenceGen.next();
            param.querySeq = actions.curMailListReqSeq;
        }
        if (param.checkType === 'checkStarMail' && !param.attrConf) {
            const attrConf = await this.modelHandler.doGetStarContactQuery(param.id, _account);
            if (!attrConf.id || attrConf.emailList.length === 0) {
                return {
                    data: [],
                    total: 0,
                    index: param.index || 0,
                    count: param.count,
                    query: param,
                };
            }
            param.attrConf = Object.assign(Object.assign({}, attrConf), { attrType: 'star' });
        }
        let result;
        if (param.isRealList && actions) {
            actions.curRealListReqSeq = actions.curMailSequenceGen.next();
            param.querySeq = actions.curRealListReqSeq;
            noCache = true;
        }
        console.log('[mail list] use Query', param, noCache);
        if (!noCache && !(param.id && param.id === mailBoxOfTask.id)) {
            result = await this.mailDbHandler.doListMailEntry(param, _account);
            console.log('[mail list] get mail entry from db', result);
            if (result && result.data && result.data.length >= 1) {
                result.total = param.isRealList ? result.total : (param.index || 0) + param.count * 2;
                const cachedIds = new Set();
                if (param.mids && param.mids.length > 0) {
                    result.data.forEach(it => cachedIds.add(it.id));
                    this.syncAndResendMailEntry({
                        mids: Array.from(cachedIds),
                        count: cachedIds.size,
                        id: param.id,
                        returnModel: true,
                    }, result, undefined, _account);
                }
                else {
                    this.syncAndResendMailEntry(param, result, undefined, _account);
                }
                const isCorpMail = this.systemApi.getIsCorpMailMode();
                if (isCorpMail) {
                    this.removeThreadInfoForCorp(result.data);
                    result.data = this.sortMailList(result.data);
                }
                if (param.mids && param.mids.length > 0 && result.data.length < param.mids.length) {
                    const remainIds = param.mids.filter(it => !cachedIds.has(it));
                    const remain = (await this.mailContentHandler.doListMailBoxEntities({
                        mids: remainIds,
                        count: remainIds.length,
                        returnModel: true,
                        _account,
                    }, true));
                    if (remain && remain.data && remain.data.length > 0) {
                        result.data.push(...remain.data);
                        this.saveMails(remain.data, undefined, param.attrConf, _account).then();
                    }
                }
                return result;
            }
        }
        return this.listMailEntryFromNetwork(param, noCache).then(async (res) => {
            const totalCount = !Array.isArray(res) ? res.total : null;
            let data = Array.isArray(res) ? res : res.data;
            if (param.id === mailBoxOfDefer.id) {
                data = data.sort((a, b) => {
                    if (a.entry.deferTime && b.entry.deferTime) {
                        const aTime = util.parseDate(a.entry.deferTime);
                        const bTime = util.parseDate(b.entry.deferTime);
                        if (aTime !== bTime) {
                            return 0;
                        }
                    }
                    if (a.entry.sendTime && b.entry.sendTime) {
                        const aDate = util.parseDate(a.entry.sendTime);
                        const bDate = util.parseDate(b.entry.sendTime);
                        if (aDate && bDate) {
                            return bDate - aDate;
                        }
                    }
                    return 0;
                });
            }
            try {
                if ((param === null || param === void 0 ? void 0 : param.checkType) === 'checkThread') {
                    const fid = param === null || param === void 0 ? void 0 : param.id;
                    data.forEach(item => {
                        var _a;
                        if ((item === null || item === void 0 ? void 0 : item.isThread) && (item === null || item === void 0 ? void 0 : item.convFids) && ((_a = item === null || item === void 0 ? void 0 : item.convFids) === null || _a === void 0 ? void 0 : _a.length) && fid != null && (item === null || item === void 0 ? void 0 : item.convFids.includes(fid))) {
                            item.entry.folder = fid;
                        }
                    });
                }
            }
            catch (e) {
                console.error('checkThread fid error', e);
            }
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (!param.noSync && !isCorpMail && !(param.id && param.id === mailBoxOfTask.id)) {
                this.syncAndResendMailEntry(param, undefined, data, _account);
            }
            if (!result || !result.data || result.data.length === 0) {
                return res;
            }
            console.log('[mail] return entry by list entry and cache ?? :', res, result);
            if (result) {
                result.data = result.data || [];
                result.total = (param.isRealList ? totalCount : null) || (Array.isArray(res) ? res.length : res.total);
                data = result.data.concat(data);
                if (param.id !== mailBoxOfDefer.id) {
                    result.data = this.sortMailList(data);
                }
            }
            return result;
        });
    }
    async doListMailBoxEntriesInternalByAccounts(param, noCache) {
        param.returnModel = true;
        const { _account } = param;
        let result;
        if (param.isRealList) {
            noCache = true;
        }
        noCache = true;
        console.log('[mail list] use Query', param, noCache);
        if (!noCache && !(param.id && param.id === mailBoxOfTask.id)) {
            result = await this.mailDbHandler.doListMailEntry(param, _account);
            console.log('[mail list] get mail entry from db', result);
            if (result && result.data && result.data.length >= 1) {
                result.total = param.isRealList ? result.total : (param.index || 0) + param.count * 2;
                this.syncAndResendMailEntryByAccounts(param, result, undefined, _account);
                const isCorpMail = this.systemApi.getIsCorpMailMode();
                if (isCorpMail) {
                    this.removeThreadInfoForCorp(result.data);
                    result.data = this.sortMailList(result.data);
                }
                return result;
            }
        }
        return this.listMailEntryFromNetworkByAccounts(param, noCache).then(async (res) => {
            const totalCount = !Array.isArray(res) ? res.total : null;
            let data = Array.isArray(res) ? res : res.data;
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (!param.noSync && !isCorpMail && !(param.id && param.id === mailBoxOfTask.id)) {
                this.syncAndResendMailEntryByAccounts(param, undefined, data, _account);
            }
            if (!result || !result.data || result.data.length === 0) {
                return res;
            }
            console.log('[mail] return entry by list entry and cache ?? :', res, result);
            if (result) {
                result.data = result.data || [];
                result.total = (param.isRealList ? totalCount : null) || (Array.isArray(res) ? res.length : res.total);
                data = result.data.concat(data);
                result.data = this.sortMailList(data);
            }
            return result;
        });
    }
    async doGetThreadMailById(threadId, _account) {
        const result = await this.mailDbHandler.getMailById({
            id: threadId,
            noContent: true,
            _account,
        });
        if (Array.isArray(result) && result.length > 0) {
            return result[0];
        }
        return Promise.resolve(undefined);
    }
    listMailEntryFromNetwork(param, noCache) {
        var _a;
        const { _account } = param;
        const actions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account: _account || param._account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const promise = this.mailContentHandler.doListMailBoxEntities(param, noCache).then(res => {
            const data = Array.isArray(res) ? res : res.data;
            if (!Array.isArray(res)) {
                if (actions && param.id && actions.mailBoxDic && actions.mailBoxDic[param.id] && res.total !== actions.mailBoxDic[param.id].mailBoxTotal) {
                    if (param.checkType !== 'checkSubordinateMail') {
                        this.syncAndResendMailBox([], _account);
                    }
                }
            }
            if (data.length === 0) {
                this.loggerHelper.track('mail_box_db_reach_the_final_mail', {
                    param,
                });
            }
            const currentUser = this.systemApi.getCurrentUser(_account);
            const data1 = data.map((item) => {
                var _a;
                if (item.entry.folder === mailBoxOfSent.id) {
                    return Object.assign(Object.assign({}, item), { authAccountType: ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.authAccountType) || null });
                }
                return item;
            });
            console.log('[mail] get mail entry from network', data1);
            let total = res.total || 0;
            if (param.id && [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].includes(+param.id)) {
                if (data.length === 0) {
                    total = (param.index || 0) + data.length;
                }
                else {
                    total = (param.index || 0) + data.length + 1;
                }
            }
            return Array.isArray(res) ? data1 : Object.assign(Object.assign({}, res), { data: data1, total });
        });
        return promise;
    }
    listMailEntryFromNetworkByAccounts(param, noCache) {
        const promise = this.mailContentHandler.doListMailBoxEntities(param, noCache).then(res => {
            const data = Array.isArray(res) ? res : res.data;
            if (data.length === 0) {
                this.loggerHelper.track('mail_box_db_reach_the_final_mail', {
                    param,
                });
            }
            const data1 = data.map((item) => {
                var _a;
                const currentUser = this.systemApi.getCurrentUser(item._account);
                if (item.entry.folder === mailBoxOfSent.id) {
                    return Object.assign(Object.assign({}, item), { authAccountType: ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.authAccountType) || null });
                }
                return item;
            });
            console.log('[mail] get mail entry from network', data1);
            let total = 0;
            if (data.length === 0) {
                total = (param.index || 0) + data.length;
            }
            else {
                total = (param.index || 0) + data.length + 1;
            }
            return Array.isArray(res) ? data1 : Object.assign(Object.assign({}, res), { data: data1, total });
        });
        return promise;
    }
    doLoadMailInitParamLocal(mid) {
        return this.mailOperationHandler.doLoadMailInitParamLocal(mid);
    }
    async updateMessageTags(params, isThread, needCheckThread = true, _account) {
        if (!params ||
            !params.ids ||
            params.ids.length === 0 ||
            ((!params.add || params.add.length === 0) && (!params.set || params.set.length === 0) && (!params.delete || params.delete.length === 0))) {
            this.sendMailOperationEvent({
                eventStrData: 'tag',
                status: 'fail',
                params: Object.assign(Object.assign({}, params), { isThread, _account }),
                reason: new Error('请求参数错误'),
            });
            return Promise.reject(new Error('请求参数错误'));
        }
        if (needCheckThread) {
            this.sendMailOperationEvent({
                eventStrData: 'tag',
                status: 'start',
                params: Object.assign(Object.assign({}, params), { isThread, _account }),
            });
            const { threadIds, normalIds } = await this.mailDbHandler.classifyThreadMailsByIds(params.ids, undefined, _account);
            const normalPromise = normalIds.length > 0
                ? this.updateMessageTags(Object.assign(Object.assign({}, params), { ids: normalIds }), false, false, _account)
                : Promise.resolve({ succ: true, data: [] });
            const threadPromise = threadIds.length > 0
                ? this.updateMessageTags(Object.assign(Object.assign({}, params), { ids: threadIds }), true, false, _account)
                : Promise.resolve({ succ: true, data: [] });
            return Promise.all([normalPromise, threadPromise]).then(([v1, v2]) => {
                this.sendMailOperationEvent({
                    eventStrData: 'tag',
                    status: [v1 && v1.succ, v2 && v2.succ],
                    params: Object.assign(Object.assign({}, params), { isThread, _account }),
                    result: [v1.data, v2.data],
                    reason: v1.failReason || v2.failReason,
                });
                if (v1 && v2 && v1.succ && v2.succ) {
                    return '';
                }
                return Promise.reject();
            });
        }
        const origin = [];
        const result = await this.mailDbHandler.updateMessageTags(params, origin, isThread, _account);
        this.sendMailOperationEvent({
            eventStrData: 'tag',
            status: 'local',
            params: Object.assign(Object.assign({}, params), { isThread, _account }),
            result: [result],
        });
        try {
            await this.mailOperationHandler.updateMessageTags(params, isThread, _account);
        }
        catch (e) {
            if (origin.length > 0) {
                await this.mailDbHandler.updateMailStatus(origin, _account);
                if (isThread) {
                    this.doListThreadMailBoxEntities({ mids: params.ids, count: params.ids.length }, true, _account).then();
                }
                else {
                    this.doListMailBoxEntities({ mids: params.ids, count: params.ids.length, _account }, true).then();
                }
            }
            return { succ: false, data: origin };
        }
        return { succ: true, data: result };
    }
    async refreshDbMailsByTag(tagOpItems, type, _account) {
        const isThread = this.mailConfApi.getMailMergeSettings() === 'true';
        const newTags = tagOpItems.map(v => v.tag);
        const query = {
            count: 1000,
            index: 0,
            returnModel: true,
            returnTag: true,
            checkType: isThread ? 'checkThread' : 'normal',
            tag: newTags,
        };
        const result = (await this.mailDbHandler.buildQuery(query, _account));
        console.log('[refreshMailsByTag] query', newTags, type, result);
        if (result && result.length > 0) {
            result.forEach(v => {
                if (type === 'add') {
                    v.tags = Array.isArray(v.tags) ? [...new Set([...v.tags, ...newTags])] : newTags;
                }
                else if (type === 'delete') {
                    v.tags = Array.isArray(v.tags) ? v.tags.filter(tag => !newTags.includes(tag)) : [];
                }
                else {
                    v.tags = Array.isArray(v.tags)
                        ? v.tags.map(tag => {
                            const it = tagOpItems.find(o => o.tag === tag);
                            if (it) {
                                return it.alias || tag;
                            }
                            return tag;
                        })
                        : newTags;
                }
            });
            console.log('[refreshMailsByTag] update', result);
            await this.db.putAll(mailTable.status, result, undefined, _account);
            console.log('[refreshMailsByTag] saved', result);
        }
    }
    async getAllMoveOrDelMids(id, ignoreFakeThreadId, _account) {
        const ids = Array.isArray(id) ? id : [id];
        const isThreadMode = this.mailConfApi.getMailMergeSettings() === 'true';
        if (!isThreadMode) {
            return {
                normalIds: ids,
                threadIds: [],
                fakeThreadIds: [],
            };
        }
        const { normalIds, threadIds, fakeThreadIds } = await this.mailDbHandler.classifyThreadMailsByIds(ids, ignoreFakeThreadId, _account);
        let allNormalIds = [...normalIds];
        let finalThreadIds = [...threadIds];
        if (!ignoreFakeThreadId) {
            const { threadMessages } = await this.mailDbHandler.getThreadMessageByThreadIds(threadIds, _account);
            allNormalIds = [...allNormalIds, ...threadMessages.map(v => v.mid)];
        }
        try {
            const foundIds = new Set([...normalIds, ...threadIds, ...fakeThreadIds]);
            const missingIds = ids.filter(id => !foundIds.has(id));
            if (missingIds.length > 0) {
                const missingNormalIds = [];
                const missingThreadIds = [];
                missingIds.forEach(id => {
                    if (/^\d+$/.test(id)) {
                        missingThreadIds.push(id);
                    }
                    else {
                        missingNormalIds.push(id);
                    }
                });
                allNormalIds = [...allNormalIds, ...missingNormalIds];
                finalThreadIds = [...finalThreadIds, ...missingThreadIds];
            }
        }
        catch (error) {
            console.error('[getAllMoveOrDelMids] Error handling missing IDs:', error);
        }
        return {
            normalIds: allNormalIds,
            threadIds: finalThreadIds,
            fakeThreadIds,
        };
    }
    async doDeleteMail({ fid, id, isThread, needCheckThread = true, delFolder = !id, _account, directDelete = false }) {
        needCheckThread = this.getNeedCheckThread(needCheckThread);
        const perfType = delFolder ? 'deleteFolder' : fid === mailBoxOfDeleted.id || directDelete ? 'completeDelete' : 'delete';
        if (needCheckThread) {
            mailPerfTool.moveMail(perfType, 'start', {
                isThread,
            });
            this.sendMailOperationEvent({
                eventStrData: 'delete',
                status: 'start',
                params: { id, fid, isThread },
                _account,
            });
            let targetId = id;
            if (!targetId) {
                const folderRes = (await this.db.getByEqCondition(Object.assign(Object.assign({ query: { folder: fid } }, mailTable.status), { _dbAccount: _account }), _account));
                targetId = folderRes.filter(v => !!v).map(v => v.mid);
            }
            const { normalIds, threadIds } = directDelete ? { normalIds: targetId, threadIds: [] } : await this.getAllMoveOrDelMids(targetId, undefined, _account);
            const normalPromise = normalIds.length > 0
                ? () => this.doDeleteMail({
                    fid,
                    id: normalIds,
                    isThread: false,
                    needCheckThread: false,
                    delFolder,
                    _account,
                    directDelete,
                })
                : () => Promise.resolve({ succ: true, data: [] });
            const threadPromise = threadIds.length > 0 ? () => this.doDeleteThreadMail(threadIds, undefined, _account) : () => Promise.resolve({ succ: true, data: [] });
            return Promise.all([normalPromise(), threadPromise()]).then(([v1, v2]) => {
                this.sendMailOperationEvent({
                    eventStrData: 'delete',
                    status: [v1 && v1.succ, v2 && v2.succ],
                    params: { id, fid, isThread },
                    result: [v1.data, v2.data],
                    reason: v1.failReason || v2.failReason,
                    _account,
                });
                if (v1 && v2 && v1.succ && v2.succ) {
                    mailPerfTool.moveMail(perfType, 'end', {
                        isThread,
                        result: 'success',
                    });
                    this.doListMailBox(undefined, undefined, undefined, _account).then();
                    return { succ: true };
                }
                mailPerfTool.moveMail(perfType, 'end', {
                    isThread,
                    result: 'fail',
                });
                return Promise.reject();
            });
        }
        const origin = [];
        const deletedId = [];
        const moveId = [];
        const result = await this.mailDbHandler.doDeleteMail({
            originData: origin,
            fid,
            id,
            isThread,
            deletedId,
            moveId,
            ignoreThread: true,
            _account,
            directDelete,
        });
        const delFolderPromise = delFolder
            ? () => this.mailOperationHandler.doDeleteMail({
                fid,
                isThread,
                _account,
            })
            : () => Promise.resolve({ succ: true });
        const movePromise = !delFolder && moveId && moveId.length > 0
            ? () => this.mailOperationHandler.doDeleteMail({
                fid: mailBoxOfDefault.id,
                id: moveId,
                isThread,
                _account,
            })
            : () => Promise.resolve({ succ: true });
        const delPromise = Array.isArray(deletedId) && deletedId.length > 0 && !delFolder
            ? () => this.mailOperationHandler.doDeleteMail({
                fid,
                id: deletedId,
                isThread,
                _account,
                directDelete,
            })
            : () => Promise.resolve({ succ: true });
        const retryFn = async () => {
            const re = await Promise.all([delFolderPromise(), delPromise(), movePromise()]);
            if (re[0] && re[0].succ && re[1] && re[1].succ && re[2] && re[2].succ) {
                if (deletedId.length > 0) {
                    this.mailDbHandler
                        .deleteInActionById(deletedId, _account)
                        .then()
                        .catch(e => {
                        console.error('deleteInActionById', e);
                    });
                }
                return { succ: true };
            }
            return Promise.reject();
        };
        const retryGetResult = await this.retryCall(retryFn);
        if (retryGetResult.succ) {
            return { succ: retryGetResult.succ, data: result };
        }
        if (origin && origin.length > 0) {
            await this.mailDbHandler.updateMailStatus(origin, _account);
            id = moveId || id;
            if (id) {
                this.doListMailBoxEntities({
                    mids: Array.isArray(id) ? id : [id],
                    count: Array.isArray(id) ? id.length : 1,
                    _account,
                }, true).then();
            }
        }
        return { succ: false, data: origin };
    }
    doDeleteThreadMail(id, fakeThreadIds, _account) {
        return this.doMoveThreadMail(id, 4, fakeThreadIds, _account);
    }
    sendMailOperationEvent(params) {
        const data = Array.isArray(params.result) ? params.result.filter(v => !!v).flat(1) : undefined;
        const mapResult = Array.isArray(data)
            ? data.reduce((total, current) => {
                if (current && !total.has(current.mid)) {
                    total.set(current.mid, current);
                }
                return total;
            }, new Map())
            : undefined;
        let statusText;
        if (Array.isArray(params.status)) {
            const [v1, v2] = params.status;
            if (v1 && v2) {
                statusText = 'success';
            }
            else if (!v1 && !v2) {
                statusText = 'fail';
            }
            else {
                statusText = 'partial';
            }
        }
        else {
            statusText = params.status;
        }
        console.log('[mail operation]', statusText, params.eventStrData, params.params, mapResult);
        const ev = {
            eventName: 'mailStoreRefresh',
            eventStrData: 'mailOp',
            eventData: {
                status: statusText,
                params: params.params,
                reason: params.reason,
                result: mapResult,
                opType: params.eventStrData,
            },
            _account: params._account,
        };
        this.eventApi.sendSysEvent(ev);
    }
    async retryCall(fn, failReason = '', retry = 3) {
        const data = await fn();
        if (data && data.succ) {
            return Promise.resolve(data);
        }
        await wait((3 - retry) * 200 + 500);
        if (retry > 0) {
            return this.retryCall(fn, failReason, retry - 1);
        }
        return Promise.reject(new Error(failReason));
    }
    async doMarkMail(mark, id, type, isThread, needCheckThread = true, payload, _account) {
        console.log('doMarkMail in api start');
        if (!id || (Array.isArray(id) && id.length === 0) || mark === undefined) {
            this.sendMailOperationEvent({
                eventStrData: type,
                status: 'fail',
                params: { mark, id, type },
                reason: new Error('请求参数错误'),
                _account,
            });
            this.dataTrackerHelper.track('mark_mail_error', {
                stage: 'pre',
                mark,
                type,
                id,
                isThread,
                _account,
            });
            return Promise.reject(new Error('请求参数错误'));
        }
        needCheckThread = this.getNeedCheckThread(needCheckThread);
        if (needCheckThread) {
            this.sendMailOperationEvent({
                eventStrData: type,
                status: 'start',
                params: { mark, id, type },
                _account,
            });
            const { threadIds, normalIds } = await this.mailDbHandler.classifyThreadMailsByIds(id, undefined, _account);
            if (!threadIds.length && !normalIds.length) {
                try {
                    const res = await this.mailOperationHandler.doMarkMail({
                        mark,
                        id,
                        type,
                        isThread,
                        payload,
                        _account,
                    });
                    const { succ } = res;
                    if (succ) {
                        const operationEventParams = {
                            eventStrData: type,
                            status: 'local',
                            params: { mark, id, type },
                        };
                        this.sendMailOperationEvent(Object.assign(Object.assign({}, operationEventParams), { status: 'local', _account }));
                        this.sendMailOperationEvent(Object.assign(Object.assign({}, operationEventParams), { status: 'success', _account }));
                        this.doListMailBoxEntities({ mids: Array.isArray(id) ? id : [id], count: 1, _account }, true);
                        return Promise.resolve({ succ: true });
                    }
                    this.sendMailOperationEvent({
                        eventStrData: type,
                        status: 'fail',
                        params: { mark, id, type },
                        reason: new Error('操作失败'),
                        _account,
                    });
                    return Promise.reject(new Error('操作失败'));
                }
                catch (ex) {
                    this.sendMailOperationEvent({
                        eventStrData: type,
                        status: 'fail',
                        params: { mark, id, type },
                        reason: new Error('操作失败'),
                        _account,
                    });
                    return Promise.reject(ex);
                }
            }
            else {
                const normalPromise = normalIds.length > 0 ? this.doMarkMail(mark, normalIds, type, false, false, payload, _account) : Promise.resolve({ succ: true, data: [] });
                const threadPromise = threadIds.length > 0 ? this.doMarkMail(mark, threadIds, type, true, false, payload, _account) : Promise.resolve({ succ: true, data: [] });
                return Promise.all([normalPromise, threadPromise])
                    .then(([v1, v2]) => {
                    this.sendMailOperationEvent({
                        eventStrData: type,
                        status: [v1 && v1.succ, v2 && v2.succ],
                        params: { mark, id, type },
                        result: [v1.data, v2.data],
                        reason: v1.failReason || v2.failReason,
                        _account,
                    });
                    if (v1 && v1.succ && v2 && v2.succ) {
                        return { succ: true };
                    }
                    this.loggerHelper.track('doMarkMail_error_track', {
                        key: 'Promise.all([normalPromise, threadPromise])',
                        res: `v1: ${v1}, v2: ${v2}`,
                    });
                    return Promise.reject(!(v1 === null || v1 === void 0 ? void 0 : v1.succ) ? v1 : v2);
                })
                    .catch(e => {
                    this.sendMailOperationEvent({
                        eventStrData: type,
                        status: 'fail',
                        params: { mark, id, type },
                        reason: e,
                        _account,
                    });
                    this.loggerHelper.track('doMarkMail_error_track', {
                        key: 'Promise.all([normalPromise, threadPromise]) catch',
                        res: `e: ${e}`,
                    });
                    return Promise.reject(e);
                });
            }
        }
        const result = await this.mailDbHandler.doMarkMail(mark, id, type, isThread, payload, _account);
        if (process.env.BUILD_ISEDM && !isThread && type === 'read' && id) {
            const ids = Array.isArray(id) ? id : [id];
            if (ids.length > 0) {
                this.mailDbHandler
                    .getMailById({
                    id: ids,
                    noContent: true,
                    noAttachment: true,
                    noStatus: true,
                    noContactRace: true,
                    _account,
                })
                    .then(model => {
                    if (model.length > 0) {
                        this.doUpdateCustomersByNewMail(model, 'unread');
                    }
                });
            }
        }
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const operationEventParams = {
            eventStrData: type,
            status: 'local',
            params: { mark, id, type },
            result: [result],
        };
        this.sendMailOperationEvent(Object.assign(Object.assign({}, operationEventParams), { status: 'local', _account }));
        console.log('doMarkMail in api db done');
        const idsInDb = Array.isArray(result) ? result.filter(v => (isCorpMail ? true : (isThread && v.isThread) || (!isThread && !v.isThread))).map(it => it.mid) : [];
        const idsNotInDb = (Array.isArray(id) ? id : [id])
            .filter(v => !idsInDb.includes(v))
            .filter(v => (isCorpMail ? true : (isThread && util.isThreadMailById(v)) || (!isThread && !util.isThreadMailById(v))))
            .map(util.getReadThreadId);
        const allIds = [...new Set([...idsInDb, ...idsNotInDb])];
        if (type === 'read') {
            this.loggerHelper.track('mark_mail', {
                stage: 'after_db',
                mark,
                id,
                isThread,
                result,
                allIds,
            });
        }
        try {
            const retryFn = () => this.mailOperationHandler.doMarkMail({
                mark,
                id: allIds,
                type,
                isThread,
                payload,
                _account,
            });
            await this.retryCall(retryFn);
            console.log('doMarkMail in api server done');
            if (type === 'read') {
                this.loggerHelper.track('mark_mail', {
                    stage: 'after_request',
                    mark,
                    id,
                    isThread,
                });
            }
        }
        catch (ex) {
            this.dataTrackerHelper.track('mark_mail_error', {
                stage: 'request',
                mark,
                type,
                id: allIds,
                isThread,
                error: ex,
            });
            let oData;
            if (idsInDb.length > 0) {
                oData = await this.mailDbHandler.doMarkMail(!mark, idsInDb, type, isThread, undefined, _account);
            }
            this.doListMailBoxEntities({
                mids: allIds,
                count: allIds.length,
                checkType: isThread ? 'checkThread' : 'normal',
                _account,
            }, true).then();
            this.loggerHelper.track('doMarkMail_error_track', {
                key: 'const retryFn = () => this.mailOperationHandler.doMarkMail',
                res: `e: ${ex}, id: ${id}`,
            });
            return { succ: false, data: oData, failReason: ex };
        }
        if (isCorpMail) {
            this.sendMailOperationEvent(Object.assign(Object.assign({}, operationEventParams), { status: 'success', _account }));
        }
        await this.modelHandler.notifyFolderCountChange(true, _account);
        console.log('doMarkMail in api notifyFolderCountChange');
        return { succ: true, data: result };
    }
    async recordMailRead(id, _account) {
        const result = await this.mailOperationHandler.doMarkMail({
            mark: true,
            id,
            type: 'read',
            isThread: false,
            _account,
        });
        return { succ: true, data: result };
    }
    async doMarkMailFolderRead(fids, isThread = false, _account) {
        if (this.markingMailsRead[_account]) {
            console.warn('[mail] doMarkMailFolderRead 正在标记');
            return { succ: false };
        }
        this.markingMailsRead[_account] = true;
        const target = {
            index: 0,
            id: -4,
            count: 100,
            order: 'date',
            desc: true,
            filter: {
                flags: { read: false },
            },
            checkType: isThread ? 'checkThread' : 'normal',
            returnModel: false,
            returnTag: false,
            noContactRace: false,
            accountId: _account,
            _account,
        };
        const mailBoxMarkRead = async (idx) => new Promise(resolve => {
            if (!fids[idx]) {
                this.markingMailsRead[_account] = false;
                resolve({ succ: true });
                return;
            }
            target.id = fids[idx];
            console.log('[mail] doMarkMailFolderRead target.id', target.id);
            try {
                this.listMailEntryFromNetwork(target, true)
                    .then(async (res) => {
                    const data = Array.isArray(res) ? res : res.data;
                    if (data.length) {
                        console.log('[mail] doMarkMailFolderRead res mids', data);
                        await this.doMarkMail(true, data.map(item => item.id), 'read', isThread, undefined, undefined, _account);
                    }
                    setTimeout(() => {
                        if (data.length) {
                            resolve(mailBoxMarkRead(idx));
                        }
                        else {
                            resolve(mailBoxMarkRead(idx + 1));
                        }
                    }, 500);
                })
                    .catch(async (reason) => {
                    console.warn('[mail] doMarkMailFolderRead promise catch', reason);
                    this.markingMailsRead[_account] = false;
                    await this.doMarkMailInfFolder(true, fids[idx], undefined, _account);
                    resolve(mailBoxMarkRead(idx + 1));
                });
            }
            catch (error) {
                console.warn('[mail] doMarkMailFolderRead error', error);
                this.markingMailsRead[_account] = false;
                this.doMarkMailInfFolder(true, fids[idx], undefined, _account);
                resolve(mailBoxMarkRead(idx + 1));
            }
        });
        return mailBoxMarkRead(0);
    }
    async doMarkMailDefer(mid, isDefer, conf, markAll, _account) {
        const params = { mid, isDefer, conf };
        if (isDefer && !conf && !markAll) {
            this.sendMailOperationEvent({
                eventStrData: 'defer',
                status: 'fail',
                params,
                reason: new Error('请求参数错误'),
                _account,
            });
            return Promise.reject(new Error('请求参数错误'));
        }
        if (!markAll) {
            this.sendMailOperationEvent({
                eventStrData: 'defer',
                status: 'start',
                params,
                _account,
            });
        }
        const deferParams = {
            deferTime: (conf === null || conf === void 0 ? void 0 : conf.deferTime) || -1,
            deferNotice: (conf === null || conf === void 0 ? void 0 : conf.deferNotice) || false,
        };
        const result = await this.mailDbHandler.doMarkMailDefer(mid, isDefer, deferParams, _account);
        if (!markAll) {
            this.sendMailOperationEvent({
                eventStrData: 'defer',
                status: 'local',
                params,
                result: [result],
                _account,
            });
        }
        const newId = Array.isArray(result) ? result.map(v => v.mid) : [];
        if (newId.length > 0) {
            const retryFn = () => this.mailOperationHandler.doMarkMail({
                mark: isDefer,
                id: newId,
                type: 'defer',
                needFilter: false,
                deferParams,
                _account,
            });
            try {
                const res = await this.retryCall(retryFn);
                if (!markAll) {
                    this.sendMailOperationEvent({
                        eventStrData: 'defer',
                        status: (res === null || res === void 0 ? void 0 : res.succ) ? 'success' : 'fail',
                        params,
                        result: [result],
                        _account,
                    });
                }
                await this.doListMailBox(true, undefined, undefined, _account);
                return { succ: res === null || res === void 0 ? void 0 : res.succ, data: result };
            }
            catch (e) {
                this.sendMailOperationEvent({
                    eventStrData: 'defer',
                    status: 'fail',
                    params,
                    _account,
                });
                return { succ: false };
            }
        }
        return { succ: true, data: result };
    }
    async doMarkMailDeferAll(deferTime, _account) {
        this.sendMailOperationEvent({
            eventStrData: 'deferAll',
            status: 'start',
            params: null,
            _account,
        });
        try {
            const allDeferMails = await this.doListMailBoxEntities({
                count: 3000,
                id: mailBoxOfDefer.id,
                index: 0,
                returnModel: true,
                returnTag: true,
                topFlag: 'top',
                filter: {
                    defer: deferTime,
                },
                _account,
            }, true);
            const mids = (Array.isArray(allDeferMails) ? allDeferMails : allDeferMails.data).map(v => v.id);
            console.log('[doMarkMailDeferAll] mails', allDeferMails);
            if (mids.length > 0) {
                const markRes = await this.doMarkMailDefer(mids, false, undefined, true, _account);
                console.log('[doMarkMailDeferAll] result', markRes);
                this.sendMailOperationEvent({
                    eventStrData: 'deferAll',
                    status: markRes.succ ? 'success' : 'fail',
                    params: null,
                    _account,
                });
                return markRes;
            }
            return { succ: true };
        }
        catch (e) {
            this.sendMailOperationEvent({
                eventStrData: 'deferAll',
                status: 'fail',
                params: null,
                _account,
            });
            return { succ: false };
        }
    }
    async doMarkStarMailAll(mailboxId) {
        if (!this.modelHandler.isValidStarFolderId(mailboxId)) {
            return { succ: false, failReason: new Error('无效的星标联系人ID') };
        }
        const inQueue = this.markStarMailQueue.queue.some(v => v.id === mailboxId);
        if (inQueue) {
            return { succ: false, failReason: new Error('星标联系人标记中') };
        }
        return new Promise(resolve => {
            const task = () => this.doMarkStarMailAllHandler.call(this, mailboxId, 0).then(resolve).catch(resolve);
            this.markStarMailQueue.queue.push({
                id: mailboxId,
                task,
            });
            if (!this.markStarMailQueue.runningId) {
                this.doMarkStarMailAllTask();
            }
        });
    }
    async doMarkStarMailAllTask() {
        const current = this.markStarMailQueue.queue.shift();
        if (current) {
            this.markStarMailQueue.runningId = current.id;
            await current.task();
            if (this.markStarMailQueue.queue.length > 0) {
                await this.doMarkStarMailAllTask();
            }
            else {
                this.markStarMailQueue.runningId = '';
            }
        }
        else {
            this.markStarMailQueue.runningId = '';
        }
    }
    async doMarkStarMailAllHandler(mailboxId, retry = 0) {
        const reqParam = {
            index: 0,
            id: mailboxId,
            count: 100,
            order: 'date',
            desc: true,
            filter: {
                flags: { read: false },
            },
            checkType: 'checkStarMail',
            returnModel: false,
            returnTag: false,
            noContactRace: false,
        };
        return new Promise(resolve => {
            try {
                this.listMailEntryFromNetwork(reqParam, true)
                    .then(async (res) => {
                    const data = Array.isArray(res) ? res : res.data;
                    if (data.length) {
                        console.log('[mail] doMarkMailFolderRead res mids', data);
                        await this.doMarkMail(true, data.map(item => item.id), 'read');
                    }
                    setTimeout(() => {
                        if (data.length) {
                            resolve(this.doMarkStarMailAllHandler(mailboxId, 0));
                        }
                        else {
                            resolve({ succ: true });
                        }
                    }, 500);
                })
                    .catch(async (reason) => {
                    console.warn('[star mail] mark all list failed', reason);
                    if (retry < 3) {
                        resolve(this.doMarkStarMailAllHandler(mailboxId, retry + 1));
                    }
                    else {
                        resolve({ succ: false, failReason: new Error(reason) });
                    }
                });
            }
            catch (reason) {
                console.warn('[star mail] mark all mark failed', reason);
                if (retry < 3) {
                    resolve(this.doMarkStarMailAllHandler(mailboxId, retry + 1));
                }
                else {
                    resolve({ succ: false, failReason: new Error(typeof reason === 'string' ? reason : '') });
                }
            }
        });
    }
    async doMarkMailPerferred(email, priority, op, _account) {
        const res = await this.mailOperationHandler.doMarkMailPerferred(email, priority, op, _account);
        return res;
    }
    async doMarkMailInfFolder(mark, fid, _isThread, _account) {
        const isThread = _isThread === undefined ? this.mailConfApi.getMailMergeSettings() === 'true' : !!_isThread;
        if (mark === undefined || !fid || fid < 0) {
            this.sendMailOperationEvent({
                eventStrData: 'markFolder',
                status: 'fail',
                params: { mark, fid, isThread },
                reason: new Error('请求参数错误'),
                _account,
            });
            return Promise.reject(new Error('请求参数错误'));
        }
        this.sendMailOperationEvent({
            eventStrData: 'markFolder',
            status: 'start',
            params: { mark, fid, isThread },
            _account,
        });
        const result = await this.mailDbHandler.doMarkMailInfFolder(mark, fid, isThread, _account);
        this.sendMailOperationEvent({
            eventStrData: 'markFolder',
            status: 'local',
            params: { mark, fid, isThread },
            result: [result],
            _account,
        });
        if (result) {
            try {
                const retryFn = () => this.mailOperationHandler.doMarkMailInfFolder(mark, fid, isThread, _account);
                const res = await this.retryCall(retryFn);
                this.sendMailOperationEvent({
                    eventStrData: 'markFolder',
                    status: 'success',
                    params: { mark, fid, isThread },
                    result: [result],
                    _account,
                });
                return res;
            }
            catch (ex) {
                const cids = result.map(it => it.mid);
                const oData = await this.mailDbHandler.doMarkMail(!mark, cids, 'read', undefined, undefined, _account);
                this.sendMailOperationEvent({
                    eventStrData: 'markFolder',
                    status: 'fail',
                    params: { mark, fid, isThread },
                    result: [oData],
                    reason: new Error(ex),
                    _account,
                });
                return { succ: false };
            }
        }
        return this.mailOperationHandler
            .doMarkMailInfFolder(mark, fid, undefined, _account)
            .then(async (res) => {
            await this.modelHandler.notifyFolderCountChange(true, _account);
            this.sendMailOperationEvent({
                eventStrData: 'markFolder',
                status: 'success',
                params: { mark, fid, isThread },
                result,
                _account,
            });
            return res;
        })
            .catch(e => {
            this.sendMailOperationEvent({
                eventStrData: 'markFolder',
                status: 'fail',
                params: { mark, fid, isThread },
                reason: e,
                _account,
            });
            return Promise.reject(e);
        });
    }
    async doMarkMailTagRead(fids, tagName, isThread, _account) {
        var _a;
        if (!tagName) {
            console.error('[mail_impl doMarkMailTagRead] 请传入tagName');
            return {
                succ: false,
            };
        }
        const account = _account || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        const key = `${tagName}@${account}`;
        if (this.markingMailsRead[key]) {
            console.warn('[mail] doMarkMailFolderRead 正在标记');
            return { succ: false };
        }
        this.markingMailsRead[key] = true;
        const target = {
            index: 0,
            id: -4,
            count: 100,
            order: 'date',
            desc: true,
            filter: {
                flags: { read: false },
            },
            checkType: isThread ? 'checkThread' : 'normal',
            returnModel: false,
            returnTag: false,
            noContactRace: false,
            accountId: _account,
            _account,
            tag: [tagName],
        };
        try {
            for (const fid of fids) {
                target.id = fid;
                const res = await this.listMailEntryFromNetwork(target, true);
                const data = Array.isArray(res) ? res : res.data;
                if (data.length) {
                    console.log('[mail] doMarkMailTagRead res mids', data);
                    await this.doMarkMail(true, data.map(item => item.id), 'read', isThread, undefined, undefined, _account);
                }
            }
            return {
                succ: true,
            };
        }
        catch (error) {
            console.error('[mail] doMarkMailTagRead error', error);
            return {
                succ: false,
            };
        }
        finally {
            this.markingMailsRead[key] = false;
        }
    }
    async doMoveMail(id, fid, isThread, needCheckThread = true, _account) {
        if (!id || (Array.isArray(id) && id.length === 0) || !fid || fid < 0) {
            this.sendMailOperationEvent({
                eventStrData: 'move',
                status: 'fail',
                params: { id, fid, isThread },
                reason: new Error('请求参数错误'),
                _account,
            });
            return Promise.reject(new Error('请求参数错误'));
        }
        needCheckThread = this.getNeedCheckThread(needCheckThread);
        if (needCheckThread) {
            mailPerfTool.moveMail('move', 'start', {
                isThread,
            });
            this.sendMailOperationEvent({
                eventStrData: 'move',
                status: 'start',
                params: { id, fid, isThread },
                _account,
            });
            const { threadIds, normalIds, fakeThreadIds } = await this.getAllMoveOrDelMids(id, true, _account);
            const normalPromise = normalIds.length > 0 ? () => this.doMoveMail(normalIds, fid, false, false, _account) : () => Promise.resolve({ succ: true, data: [] });
            const threadPromise = threadIds.length > 0 ? () => this.doMoveThreadMail(threadIds, fid, fakeThreadIds, _account) : () => Promise.resolve({ succ: true, data: [] });
            return Promise.all([normalPromise(), threadPromise()]).then(([v1, v2]) => {
                this.sendMailOperationEvent({
                    eventStrData: 'move',
                    status: [v1 && v1.succ, v2 && v2.succ],
                    params: { id, fid, isThread },
                    result: [v1.data, v2.data],
                    reason: v1.failReason || v2.failReason,
                    _account,
                });
                if (v1 && v2 && v1.succ && v2.succ) {
                    mailPerfTool.moveMail('move', 'end', {
                        isThread,
                        result: 'success',
                    });
                    this.doListMailBox(undefined, undefined, undefined, _account).then();
                    return { succ: true };
                }
                mailPerfTool.moveMail('move', 'end', {
                    isThread,
                    result: 'fail',
                });
                return Promise.reject();
            });
        }
        const origin = [];
        const result = await this.mailDbHandler.doMoveMail(origin, id, fid, isThread, _account);
        const idsInDb = Array.isArray(result) ? result.filter(v => (isThread && v.isThread) || (!isThread && !v.isThread)).map(it => it.mid) : [];
        const idsNotInDb = (Array.isArray(id) ? id : [id])
            .filter(v => !idsInDb.includes(v))
            .filter(v => (isThread && util.isThreadMailById(v)) || (!isThread && !util.isThreadMailById(v)))
            .map(util.getReadThreadId);
        const allIds = [...new Set([...idsInDb, ...idsNotInDb])];
        if (allIds.length > 0) {
            try {
                const retryFn = () => this.mailOperationHandler.doMoveMail({ id: allIds, fid, isThread, _account });
                await this.retryCall(retryFn);
                return {
                    succ: true,
                    data: result,
                };
            }
            catch (ex) {
                await this.mailDbHandler.updateMailStatus(origin, _account);
                this.doListMailBoxEntities({
                    mids: allIds,
                    count: allIds.length,
                    checkType: isThread ? 'checkThread' : 'normal',
                    _account,
                }, true).then();
                return { succ: false, data: origin };
            }
        }
        return { succ: true, data: [] };
    }
    async doMoveThreadMail(id, fid, fakeThreadIds, _account) {
        const threadIds = Array.isArray(id) ? id : [id];
        const fakeIds = Array.isArray(fakeThreadIds) ? fakeThreadIds : [];
        const deletedIds = [...new Set([...threadIds, ...fakeIds])];
        const moveThreadMessage = async () => {
            const { threadMessages } = await this.mailDbHandler.getThreadMessageByThreadIds(threadIds, _account);
            const messageIds = threadMessages.map(v => v.mid);
            const origin = [];
            return this.mailDbHandler.doMoveMail(origin, messageIds, fid);
        };
        const retryFn = async () => {
            const data = await this.mailOperationHandler.doMoveMail({
                id: threadIds,
                fid,
                isThread: true,
                _account,
            });
            if (data && data.succ) {
                return this.mailDbHandler
                    .deleteByIds(deletedIds, _account)
                    .then(moveThreadMessage)
                    .then(() => this.syncMailByIds(deletedIds, 'checkThreadDetail', true, _account))
                    .then(async () => {
                    this.doCallMailMsgCenter({
                        type: 'syncMail',
                        data: { id: fid },
                    }, _account);
                    await this.modelHandler.notifyFolderCountChange(true, _account);
                    return Promise.resolve(data);
                });
            }
            return Promise.reject();
        };
        const { succ } = await this.retryCall(retryFn);
        const results = (await this.db.getByIds(mailTable.status, deletedIds, _account));
        return { succ, data: results.filter(v => !!v) };
    }
    async doNeedSaveTemp(content) {
        const res = await this.mailOperationHandler.doNeedSaveTemp(content);
        return res;
    }
    async doReplayMail(id, all, noPopup, additionalContent, _account, config) {
        const { isTpMail } = config || {};
        if (!noPopup) {
            const writeType = all ? 'replyAll' : 'reply';
            mailPerfTool.writeMail('start', {
                writeType: writeType,
            });
        }
        let isThread = false;
        if (!isTpMail) {
            const mailType = await this.doGetMailTypeById(id, _account);
            isThread = mailType === 'thread';
        }
        return this.mailOperationHandler.doReplayMail(id, all, noPopup, additionalContent, isThread, _account, config);
    }
    doReplayMailWithAttach(id, all, noPopup, additionalContent, _account, config) {
        if (!noPopup) {
            const writeType = all ? 'replyAllWithAttach' : 'replyWithAttach';
            mailPerfTool.writeMail('start', {
                writeType: writeType,
            });
        }
        return this.mailOperationHandler.doReplayMailWithAttach(id, all, noPopup, additionalContent, _account, config);
    }
    async doReplayAllAsNew(id, noPopup, _account) {
        if (!noPopup) {
            mailPerfTool.writeMail('start', {
                writeType: 'replyAllAsNew',
            });
        }
        return this.mailOperationHandler.doReplayAllAsNew(id, noPopup, _account);
    }
    doSaveMailInitParamLocal(content) {
        this.mailOperationHandler.doSaveMailInitParamLocal(content);
    }
    doDelMailInitParamLocal(content) {
        this.mailOperationHandler.doDelMailInitParamLocal(content);
    }
    doSaveMailLocal(content) {
        this.modelHandler.updateLocalContent(content);
    }
    doTransferSign(signHtml) {
        return this.modelHandler.getTransferHtml({ content: signHtml, contentId: '' }, 'sign', false);
    }
    doLocalSearchMail(key, param) {
        return this.mailContentHandler.doLocalSearchMail(key, param);
    }
    async doGetSearchCacheInfo(key, param, searchId, noData, _account) {
        return this.mailContentHandler.doGetSearchCacheInfo(key, param, searchId, noData, _account);
    }
    async doClearSearchCache(_account) {
        return this.mailContentHandler.doClearSearchCache(_account);
    }
    async doClearSearchCache_sd(_account) {
        return this.mailContentHandler.doClearSearchCache_sd(_account);
    }
    async doSearchMailIdByAccount(key, param, localSearch, searchId) {
        const localParams = Object.assign(Object.assign({}, param), { count: 3000 });
        try {
            const list = await this.doSearchMail(key, localParams, localSearch, searchId);
            if (list && list.entities.length > 0) {
                const res = {};
                list.entities.forEach(item => {
                    const account = item._account || '';
                    if (res[account]) {
                        res[account].push(item.id);
                    }
                    else {
                        res[account] = [item.id];
                    }
                });
                return res;
            }
        }
        catch (e) {
            console.error('doSearchMailIdByAccount error', e);
        }
        return {};
    }
    async doSearchMail(key, param, localSearch, searchId) {
        const _account = param._account || '';
        const params = Object.assign(Object.assign({}, param), { checkType: 'normal', _account });
        if (key.startsWith('*#') && key.endsWith('*#')) {
            this.mailContentHandler.doSpecialJob(key);
            return Promise.resolve(this.mailContentHandler.buildSearchResult([[], {}, [], {}], 0, key, 0, params.id, undefined, undefined, _account));
        }
        if (process.env.BUILD_ISWEB || process.env.BUILD_ISEDM) {
            localSearch = false;
        }
        if (localSearch) {
            this.loggerHelper.track('mail_search_local_start', {
                key,
                params,
                searchId,
            });
            return this.doLocalSearchMail(key, params);
        }
        try {
            this.loggerHelper.track('mail_search_cloud_start', {
                key,
                params,
                searchId,
            });
        }
        catch (error) {
            console.error('mail_search_cloud_start track error', error);
        }
        return this.mailContentHandler.doSearchMail(key, params, searchId);
    }
    doSearchMail_sd(key, param, searchId) {
        const _account = param._account || '';
        const params = Object.assign(Object.assign({}, param), { checkType: 'normal', _account });
        return this.mailContentHandler.doSearchMail_sd(key, params, searchId);
    }
    doSearchMailIds(key, param, localSearch, searchId) {
        const _account = param._account || '';
        const params = Object.assign(Object.assign({}, param), { checkType: 'normal', _account });
        if (localSearch) {
            this.loggerHelper.track('mail_search_local_start', {
                key,
                params,
                searchId,
            });
            return this.mailContentHandler.doLocalSearchMailIds(key, params);
        }
        this.loggerHelper.track('mail_search_cloud_start', {
            key,
            params,
            searchId,
        });
        return this.mailContentHandler.doSearchMailIds(key, params, searchId);
    }
    async batchDeleteSearch(config) {
        const { mailSearchKey, isLocalSearch, searchingId, params } = config;
        if (params) {
            this.loggerHelper.track('mail_search_batch_delete', { type: 'search' });
            if ((params === null || params === void 0 ? void 0 : params.subEmails) && (params === null || params === void 0 ? void 0 : params.subEmails.length)) {
                const account2MidListMap = (await this.doSearchMailIdByAccount(mailSearchKey, params, isLocalSearch, searchingId)) || {};
                for (const account in account2MidListMap) {
                    const idlist = account2MidListMap[account];
                    const size = 200;
                    for (let i = 0; i < idlist.length; i += size) {
                        try {
                            await this.doMoveMail(idlist.slice(i, i + size), mailBoxOfDeleted.id, false, false, account);
                            await wait(600);
                        }
                        catch (e) {
                            console.error('[batchDeleteSearch error]', e);
                        }
                        await this.doClearSearchCache(account);
                    }
                }
            }
            else {
                const idlist = await this.doSearchMailIds(mailSearchKey, params, isLocalSearch, searchingId);
                const size = 200;
                for (let i = 0; i < idlist.length; i += size) {
                    try {
                        await this.doMoveMail(idlist.slice(i, i + size), mailBoxOfDeleted.id, false, false, params.accountId || params._account);
                        await wait(600);
                    }
                    catch (e) {
                        console.error('[batchDeleteSearch error]', e);
                    }
                }
                await this.doClearSearchCache(params._account);
            }
            return true;
        }
        return Promise.reject(new Error(false));
    }
    doSaveTemp(params) {
        const { content, saveDraft, auto, _account, callPurpose } = params;
        return this.mailOperationHandler.doSaveTemp({ content, saveDraft, auto, _account, callPurpose }).then(re => {
            setTimeout(() => {
                var _a;
                (_a = this.eventApi
                    .sendSysEvent({
                    eventName: 'mailChanged',
                    eventStrData: 'syncDraft',
                    eventData: {
                        id: content.entry.id,
                    },
                    _account: content._account,
                })) === null || _a === void 0 ? void 0 : _a.catch(ex => {
                    console.error(ex);
                    this.errReporter.doReportMessage({
                        error: '存草稿成功消息数据发送失败：' + ex.message,
                        data: '',
                        id: '',
                    });
                });
            }, 2700);
            return re;
        });
    }
    doGetLatestedDraftId(params) {
        return this.mailOperationHandler.doGetLatestedDraftId(params);
    }
    doSaveDraftLocal(content) {
        return this.mailOperationHandler.doSaveDraftLocal(content);
    }
    doGetContentFromDB(cid, _account) {
        return this.modelHandler.loadEntryFromStore1(cid, _account);
    }
    doGetMailFromDB(cid, _account) {
        return this.modelHandler.loadEntryFromStore(cid, _account);
    }
    async doSaveAttachmentToDB(params) {
        const { cid, _account, attachment } = params;
        try {
            const element = await this.modelHandler.loadEntryFromStore(cid, _account);
            await this.modelHandler.saveEntryToStore(element, undefined, attachment);
            return true;
        }
        catch (error) {
            console.log('doSaveAttachmentToDB error', error);
            return false;
        }
    }
    doSaveContentToDB(item) {
        return this.modelHandler.saveEntryToStore1(item);
    }
    doReSendInitMail(cid, resendAccount, withCloudAtt, latestedCont) {
        return this.mailOperationHandler.doReSendInitMail(cid, resendAccount, withCloudAtt, latestedCont);
    }
    doGetExcludeAttIds(cid, latestedCont) {
        return this.mailOperationHandler.doGetExcludeAttIds(cid, latestedCont);
    }
    doTransferAtts(params) {
        return this.mailOperationHandler.doTransferAtts(params);
    }
    doSendMail(content) {
        this.eventApi.sendSysEvent({
            eventName: 'writePageDataExchange',
            eventData: content.cid,
            eventStrData: 'sending',
            _account: content._account,
        });
        return this.mailOperationHandler
            .doSendMail(content)
            .then(async (re) => {
            if (re.errMsg) {
                setTimeout(() => {
                    this.eventApi.sendSysEvent({
                        eventName: 'writePageDataExchange',
                        eventData: content.cid,
                        eventStrData: 'sendFailed',
                        _account: content._account,
                    });
                }, 100);
            }
            else {
                setTimeout(() => {
                    var _a;
                    (_a = this.eventApi
                        .sendSysEvent({
                        eventName: 'writePageDataExchange',
                        eventData: content.cid,
                        _account: content._account,
                        eventStrData: content.scheduleDate ? 'scheduleDateSucceed' : 'sendSucceed',
                    })) === null || _a === void 0 ? void 0 : _a.catch(ex => {
                        console.error(ex);
                        this.errReporter.doReportMessage({
                            error: '写信成功消息数据发送失败：' + ex.message,
                            data: '',
                            id: '',
                        });
                    });
                }, 1000);
            }
            if (!re.errMsg) {
                const autoAddContact = await this.mailConfApi.getMailAutoAddContact();
                const _letterType = content.entry.writeLetterProp;
                const addContactAfterForwarded = this.mailConfApi.getAutoAddContactAfterForwardConf(content._account || '');
                const addContactAfterReplied = this.mailConfApi.getAutoAddContactAfterReplyConf(content._account || '');
                if (((_letterType === null || _letterType === void 0 ? void 0 : _letterType.includes('forward')) && addContactAfterForwarded) ||
                    ((_letterType === null || _letterType === void 0 ? void 0 : _letterType.includes('reply')) && addContactAfterReplied) ||
                    (autoAddContact && autoAddContact.toString() === '1' && !(_letterType === null || _letterType === void 0 ? void 0 : _letterType.includes('forward')) && !(_letterType === null || _letterType === void 0 ? void 0 : _letterType.includes('reply')))) {
                    this.addNewContact(content.receiver, content._account || '');
                }
                this.sendRecentContact(content.receiver, content._account || '');
                if (content.entry.isDraft || content.entry.folder === 2) {
                    this.doDeleteMail({
                        fid: mailBoxOfDraft.id,
                        id: content.originMailId,
                        isThread: false,
                        _account: content._account,
                    }).then(() => {
                        setTimeout(() => {
                            this.eventApi.sendSysEvent({
                                eventName: 'mailChanged',
                                eventStrData: 'syncDraft',
                                eventData: {
                                    closeDetail: true,
                                    id: content.entry.id,
                                },
                                _account: content._account,
                            });
                        }, 2700);
                    });
                }
            }
            setTimeout(() => {
                this.eventApi.sendSysEvent({
                    eventName: 'mailChanged',
                    eventStrData: 'data',
                    eventData: {
                        entries: [],
                        count: 0,
                        fid: new Set([mailBoxOfSent.id, mailBoxOfDraft.id]),
                        noCache: true,
                    },
                    _account: content._account,
                });
            }, 1700);
            if (content.entry.writeLetterProp && !re.errMsg) {
                switch (content.entry.writeLetterProp) {
                    case 'common':
                        break;
                    case 'forward':
                    case 'reply':
                    case 'replyAll':
                        console.log('[mail] change mailInfo after send succeed', content);
                        if (content.originMailId) {
                            this.mailDbHandler
                                .getMailById({
                                id: content.originMailId,
                                noContent: true,
                                noAttachment: true,
                                noContact: true,
                                _account: content._account,
                            })
                                .then(re => {
                                if (re && re.length === 1) {
                                    if (content.entry.writeLetterProp === 'reply' || content.entry.writeLetterProp === 'replyAll') {
                                        re[0].entry.replayed = true;
                                    }
                                    if (content.entry.writeLetterProp === 'forward') {
                                        re[0].entry.forwarded = true;
                                    }
                                    this.mailDbHandler.saveMails(re[0], undefined, content._account);
                                    this.sendMailOperationEvent({
                                        eventStrData: 'reply',
                                        status: 'success',
                                        params: {
                                            originMailId: content.originMailId,
                                        },
                                        result: [
                                            [
                                                {
                                                    mid: content.entry.id,
                                                    replyStatus: re[0].entry.replayed ? 1 : 0,
                                                    forwardStatus: re[0].entry.forwarded ? 1 : 0,
                                                },
                                            ],
                                        ],
                                        _account: content._account,
                                    });
                                }
                            });
                        }
                        break;
                    default:
                        break;
                }
            }
            return re;
        })
            .catch(reason => {
            setTimeout(() => {
                this.eventApi.sendSysEvent({
                    eventName: 'writePageDataExchange',
                    eventData: content.cid,
                    eventStrData: 'sendFailed',
                    _account: content._account,
                });
            }, 100);
            return Promise.reject(reason);
        });
    }
    doCancelDeliver(content) {
        return this.mailOperationHandler.doCancelDeliver(content);
    }
    doImmediateDeliver(content) {
        return this.mailOperationHandler.doImmediateDeliver(content);
    }
    async getLastMailSyncTime(key, _account) {
        var _a;
        const actions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (actions && actions.lastMailBoxUpdateTime[key] && actions.lastMailBoxUpdateTime[key] > 0) {
            return actions.lastMailBoxUpdateTime[key];
        }
        const storeData = await this.storeApi.get(key, { _account });
        if (actions && storeData && storeData.suc && storeData.data) {
            const number = Number(storeData.data);
            actions.lastMailBoxUpdateTime[key] = number;
            return number;
        }
        return -1;
    }
    setLastMailSyncTime(key, targetActions, _account) {
        if (targetActions)
            targetActions.lastMailBoxUpdateTime[key] = Date.now();
        this.storeApi.put(key, String(targetActions === null || targetActions === void 0 ? void 0 : targetActions.lastMailBoxUpdateTime[key]), { _account }).then().catch(console.error);
        return (targetActions === null || targetActions === void 0 ? void 0 : targetActions.lastMailBoxUpdateTime[key]) || NaN;
    }
    async doUpdateMailBoxStat(taskType, extraData, _account) {
        var _a;
        const timestamp = await this.getLastMailSyncTime(ActionStore.keyMailSyncTime, _account);
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (timestamp < 0) {
            this.setLastMailSyncTime(ActionStore.keyMailSyncTime, targetActions, _account);
        }
        else if (timestamp + MailApiImpl.mailSyncMinPeriod > Date.now() && taskType !== 'push') {
            return;
        }
        this.doUpdateMailBoxStatCall(taskType || 'default', extraData, _account).then(() => {
            this.setLastMailSyncTime(ActionStore.keyMailSyncTime, targetActions, _account);
        });
    }
    async doUpdateMailBoxStatCall(taskType, extraData, _account) {
        return this.mailContentHandler.doUpdateMailBoxStat(taskType, extraData, _account);
    }
    doUploadAttachment(params) {
        return this.mailOperationHandler.doUploadAttachment(params);
    }
    buildUploadedAttachmentDownloadUrl(content, attachId, cloudAdditional, _session, agentNode) {
        return this.mailOperationHandler.buildUploadedAttachmentDownloadUrl(content, attachId, cloudAdditional, _session, agentNode);
    }
    buildAttachmentSliceUploader(uploader, item, cloudUploaderCommonArgs, qrs) {
        return this.mailOperationHandler.buildAttachmentSliceUploader(uploader, item, cloudUploaderCommonArgs, qrs);
    }
    doAbortAttachment(id) {
        return this.mailOperationHandler.doAbortAttachment(id);
    }
    doAbortPastingAttachment(id) {
        return this.mailOperationHandler.doAbortPastingAttachment(id);
    }
    doAddAttachment(cid, attach, flag, _acount) {
        return this.mailOperationHandler.doAddAttachment(cid, attach, flag, _acount);
    }
    doWithdrawMail(mid, tid, _account) {
        return this.mailOperationHandler.doWithdrawMail(mid, tid, _account);
    }
    async doWriteMailToContact(contact, _account, writeWay) {
        mailPerfTool.writeMail('start', { writeType: 'common' });
        return this.mailOperationHandler.doWriteMailToContact(contact, _account, writeWay);
    }
    doWriteMailFromLink(contact, title, originContent, _account, otherParams) {
        mailPerfTool.writeMail('start', { writeType: 'common' });
        return this.mailOperationHandler.doWriteMailFromLink(contact, title, originContent, _account, otherParams);
    }
    doWriteMailToServer() {
        return this.mailOperationHandler.doWriteMailToServer();
    }
    doWriteMailToWaimaoServer() {
        return this.mailOperationHandler.doWriteMailToWaimaoServer();
    }
    getContractItemByEmail(id, type, _account) {
        return this.contactHandler.getContractItemByEmail(id, type, _account);
    }
    doGetGroupMailStatus(id, noCache) {
        return this.mailContentHandler.doGetGroupMailStatus(id, noCache);
    }
    buildEmptyMailEntryModel(param, noStore) {
        return this.mailContentHandler.buildEmptyMailEntryModel(param, noStore);
    }
    async buildCloudAttMailEntryModel(param) {
        return Promise.reject({ param, err: '方法已废弃' });
    }
    async initModel(param) {
        var _a, _b, _c;
        let result;
        const { _account } = param;
        try {
            if (param.result) {
                this.modelHandler.updateLocalContent(param.result);
                result = param.result;
            }
            else {
                result = await this.mailOperationHandler.initModel(param);
            }
            if (result) {
                const copyResult = JSON.parse(JSON.stringify(result));
                if ((_b = (_a = copyResult.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content) {
                    copyResult.entry.content.content = '';
                }
                this.loggerHelper.track('callWriteLetterFunc_initModelresult', {
                    params: JSON.stringify(copyResult),
                });
            }
            console.log('mailImpl initModel result', param, result);
            if (result && !result._id && (param === null || param === void 0 ? void 0 : param.writeWay) === 'newWebTab') {
                await this.doSaveTemp({ content: result, saveDraft: false, auto: true, _account: param._account }).then();
            }
            return Promise.resolve(result);
        }
        finally {
            if (_account && _account !== ((_c = this.systemApi.getCurrentUser()) === null || _c === void 0 ? void 0 : _c.id)) {
                console.log('mailImpl initModel result', param, result);
                this.mailConfApi.loadConfFromServer(_account);
            }
            if (result && !result._id && (param === null || param === void 0 ? void 0 : param.writeWay) !== 'newWebTab') {
                this.doSaveTemp({ content: result, saveDraft: false, auto: true, _account: param._account }).then();
            }
        }
    }
    async requestDelivery(id, bcc, _account) {
        return this.mailOperationHandler.requestDelivery(id, bcc, _account);
    }
    async distributeMailWm(params) {
        return this.mailOperationHandler.distributeMailWm(params);
    }
    async requestDeliveryWm(params) {
        return this.mailOperationHandler.requestDeliveryWm(params);
    }
    async getOthersSubMailbox(account, _account) {
        return this.mailOperationHandler.getOthersSubMailbox(account, _account);
    }
    async getOthersSubMailboxV2(account, _account) {
        return this.mailOperationHandler.getOthersSubMailboxV2(account, _account);
    }
    doBuildEmptyMailEntryModel(param) {
        return this.mailContentHandler.buildEmptyMailEntryModel(param);
    }
    getRelatedMail(param, noCache) {
        console.log('getRelatedMail', param, noCache);
        const { source } = param;
        if (source && ['readMailComb', 'crmSide'].includes(source)) {
            delete param.source;
            return this.getRelatedMailInclSub(param);
        }
        delete param.source;
        return this.mailContentHandler.getRelatedMail(param, noCache);
    }
    async getRelatedMailInclSub(originParam) {
        try {
            const accounts = await this.accountApi.getMainAndSubAccounts();
            const subEmails = (accounts || []).map(item => item.id);
            const params = Object.assign(Object.assign({}, originParam), { subEmails });
            const { status } = originParam;
            const searchTypeMap = {
                ALL: 'receiverAndSender',
                RECEIVED: 'receiver',
                SENT: 'sender',
                ATTACHMENT: 'attachment',
            };
            if (status && searchTypeMap[status]) {
                params.searchType = searchTypeMap[status];
            }
            const searchKey = params.relatedEmail ? params.relatedEmail[0] : '';
            const searchRes = await this.mailContentHandler.doSearchMoreAccounts(searchKey, params);
            console.log('getRelatedMailInclSub searchRes', searchRes);
            return {
                data: searchRes,
                total: searchRes.length,
                index: 0,
                count: searchRes.length,
                query: originParam,
            };
        }
        catch (error) {
            console.log('getRelatedMailInclSub error', error);
        }
        return { data: [], total: 0, index: 0, count: 0, query: originParam };
    }
    async checkSendState(composeId) {
        var _a;
        const mainUser = this.systemApi.getCurrentUser();
        const resp = await this.impl.get(this.systemApi.getUrl('checkSendState'), { vComposeId: composeId, node: this.systemApi.getCurrentNode(), sid: mainUser === null || mainUser === void 0 ? void 0 : mainUser.sessionId });
        if (resp.status === 200) {
            return (_a = resp.data) === null || _a === void 0 ? void 0 : _a.data;
        }
        return Promise.reject(resp.data);
    }
    uploadDyncGroupSendFile() {
        return this.systemApi.getUrl('uploadDyncGroupSendFile');
    }
    downDyncGroupSendFileDemo() {
        return this.systemApi.getUrl('downDyncGroupSendFileDemo');
    }
    async writeMailCopyAttach(params) {
        return this.mailOperationHandler.writeMailCopyAttach(params);
    }
    async getFilePreviewUrl(param) {
        const mailEntry = await this.mailDbHandler.doGetMailContent(param.mid, undefined, param._account);
        const accountId = param._account ? this.storeApi.getEmailIdByEmail(param._account) : '';
        const mainUser = this.systemApi.getCurrentUser();
        const result = await this.impl.get(param.url, Object.assign({ tid: mailEntry === null || mailEntry === void 0 ? void 0 : mailEntry.entry.tid }, (accountId && mainUser ? { mainAccount: mainUser.id } : {})), {
            _account: param._account,
        });
        if (result && result.data) {
            if (process.env.BUILD_ISELECTRON) {
                const res = result.data;
                const subAccountSessioName = param && param._account ? this.systemApi.getSessionNameOfSubAccount(param._account || '') : '';
                if (subAccountSessioName && res.data) {
                    res.data = `${res.data}&_session=${subAccountSessioName}`;
                }
                return res;
            }
            const ret = result.data;
            return ret;
        }
        return { success: false };
    }
    onFocus() {
        if (this.systemApi.isMainPage()) {
            this.doUpdateMailBoxStatCall('resume').then();
        }
        return this.name;
    }
    async syncAllMails(total = 200, start = 0, _account) {
        var _a;
        console.log('[mail sync] syncAllMails');
        let timestamp = await this.getLastMailSyncTime(ActionStore.keyMailContentSyncTime, _account);
        const targetActions = (_a = this.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const judgeTimestamp = timestamp;
        let retry = 0;
        const retryCall = async () => {
            retry += 1;
            this.setLastMailSyncTime(ActionStore.keyMailContentSyncTime, undefined, _account);
            timestamp = await this.getLastMailSyncTime(ActionStore.keyMailContentSyncTime, _account);
            if (timestamp <= 0 && retry < 5) {
                await retryCall();
            }
        };
        await retryCall();
        if (judgeTimestamp + MailApiImpl.MAIL_CONTENT_SYNC_MIN_PERIOD > Date.now()) {
            console.log('[mail sync] not now');
            return;
        }
        if (MailApiImpl.mailSyncing) {
            console.log('[mail sync] is syncing');
            return;
        }
        this.loggerHelper.track('mail_sync_start', { total, judgeTimestamp });
        MailApiImpl.mailSyncing = true;
        console.log('[mail sync] start');
        const { mailBoxDic } = targetActions || {};
        if (mailBoxDic) {
            try {
                const mailBoxIds = [];
                Object.keys(mailBoxDic).forEach(mbid => {
                    mailBoxIds.push(Number(mbid));
                });
                const mailBoxSync = (idx) => {
                    const k = mailBoxIds[idx];
                    const mailBox = mailBoxDic[k];
                    if (mailBox && !mailBox.locked && mailBox.mailBoxTotal > 0) {
                        setTimeout(() => {
                            this.handleMailBoxSync(start, total, mailBox, _account).then(() => {
                                mailBoxSync(idx + 1);
                            });
                        }, 2000);
                    }
                };
                mailBoxSync(0);
            }
            catch (ex) {
                console.warn(ex);
            }
            finally {
                MailApiImpl.mailSyncing = false;
                this.setLastMailSyncTime(ActionStore.keyMailContentSyncTime, targetActions, _account);
            }
        }
    }
    async handleMailBoxSync(start, total, mailBox, _account) {
        console.log('[mail sync] handleMailBoxSync mailbox', mailBox);
        let index = start;
        let error = 0;
        const retryCall = async () => {
            try {
                const data = await this.mailContentHandler.doListMailBoxEntities({
                    index,
                    count: 100,
                    id: Number(mailBox.id),
                    _account,
                });
                await wait(MailApiImpl.MAIL_SYNC_WAIT_SPAN);
                const __ret = await this.handleSyncList(data, index, start, _account);
                index = __ret.index;
                if (__ret.empty) {
                    return Promise.resolve();
                }
            }
            catch (e) {
                console.warn(e);
                error += 1;
            }
            if (index < total && error < 3) {
                await retryCall();
            }
            return Promise.resolve();
        };
        await retryCall();
        const isThread = this.mailConfApi.getMailMergeSettings() === 'true';
        const unread = await this.mailContentHandler.doListMailBoxEntities({
            index,
            count: 60,
            id: Number(mailBox.id),
            filter: {
                flags: { read: false },
            },
            checkType: isThread ? 'checkThread' : 'normal',
            _account,
        });
        await wait(MailApiImpl.MAIL_SYNC_WAIT_SPAN);
        await this.handleSyncList(unread, index, start, _account);
        await wait(MailApiImpl.MAIL_SYNC_WAIT_SPAN);
        await this.syncByTimestamp(mailBox);
    }
    async handleSyncList(data, index, start, _account) {
        const dt = Array.isArray(data) ? data : data.data;
        let empty = false;
        if (dt && dt.length > 0) {
            console.log('[mail sync] handleSyncList');
            await this.saveMails(dt, undefined, undefined, _account);
            await wait(MailApiImpl.MAIL_SYNC_WAIT_SPAN);
            if (index < 20 && start === 0) {
                console.log('[mail sync] syncMailContent');
                await this.syncMailContent(dt, _account);
            }
            index += dt.length;
        }
        else {
            empty = true;
        }
        return { index, empty };
    }
    async syncMailContent(dt, _account) {
        const mids = dt.map(it => it.id);
        const savedMails = await this.mailDbHandler.getMailById({
            id: mids,
            noContact: true,
            noAttachment: true,
            noData: true,
            noStatus: true,
            noContent: false,
            _account,
        });
        const set = new Set(savedMails.map(it => it.id));
        const needSyncContentMail = dt.filter(it => !set.has(it.id));
        if (needSyncContentMail.length > 0) {
            await this.syncMailContentInternal(needSyncContentMail);
        }
    }
    async syncMailContentInternal(needSyncContentMail, _account) {
        const ids = [];
        needSyncContentMail.forEach(it => {
            if (it && it.id) {
                ids.push(it.id);
            }
        });
        return ids.reduce((item, cur) => item
            .then(() => wait(MailApiImpl.MAIL_SYNC_WAIT_SPAN))
            .then(() => this.mailContentHandler.doGetMailContent(cur, { _account }))
            .then(con => {
            this.saveMails(con, undefined, undefined, _account);
        }), Promise.resolve());
    }
    async syncByTimestamp(mailBox) {
        try {
            const now = Date.now();
            const statuses = await this.mailDbHandler.getMailLeastUpdated(Number(mailBox.id), now - ActionStore.minUpdateSpan, now - ActionStore.maxUpdateSpan);
            const tempStatuses = statuses.map(v => ({
                isThread: v.isThread === 1,
                id: v.mid,
                convFids: v.convFids,
                threadId: v.threadId,
            }));
            const normalTempStatuses = tempStatuses.filter(v => v.isThread);
            const threadTempStatuses = tempStatuses.filter(v => !v.isThread);
            const normalIds = normalTempStatuses.map(v => v.id);
            const threadIds = threadTempStatuses.map(v => v.id);
            const allThreadIds = [...this.mailDbHandler.getAllThreadIds(threadTempStatuses), ...threadIds];
            const p1 = this.syncMailByIds(normalIds, 'normal');
            const p2 = this.syncMailByIds(allThreadIds, 'checkThread');
            return Promise.all([p1, p2]).then(([res1, res2]) => {
                const res = [];
                if (Array.isArray(res1)) {
                    res.push(...res1);
                }
                if (Array.isArray(res2)) {
                    res.push(...res2);
                }
                return res;
            });
        }
        catch (ex) {
            console.warn(ex);
        }
        return [];
    }
    async syncMailByIds(mids, checkType, skipWait, _account) {
        const isThread = checkType && ['checkThreadDetail', 'checkThread'].includes(checkType);
        const originMids = [...mids];
        if (isThread) {
            mids = [...new Set(mids.map(v => v.split('--')[0]))];
        }
        const ret = [];
        if (mids && mids.length > 0) {
            ret.push(mids.length);
            const mailBoxEntities = isThread
                ? await this.mailContentHandler.getThreadMailContentFromNetwork(mids, {
                    returnConvInfo: true,
                }, undefined, _account)
                : await this.mailContentHandler.doListMailBoxEntities({
                    mids,
                    count: mids.length,
                    returnModel: false,
                    _account,
                });
            if (!mailBoxEntities) {
                return ret;
            }
            let data = Array.isArray(mailBoxEntities) ? mailBoxEntities : mailBoxEntities.data;
            const now = Date.now();
            data = data.filter(it => now - (it.updateTime || 0) > MailApiImpl.mailSyncMinPeriod);
            if (edmMailHelper.isEdmMailReq(checkType)) {
                data = data.filter(it => edmMailHelper.filterEdmFid(it.entry.folder));
            }
            if (data) {
                ret.push(data.length);
                if (mids.length > data.length || isThread) {
                    const delMids = [];
                    const set = new Set(this.mailDbHandler.getAllThreadIds(data, true));
                    if (isThread) {
                        delMids.push(...set, ...originMids);
                    }
                    else {
                        mids.forEach(it => {
                            if (!set.has(it)) {
                                delMids.push(it);
                            }
                        });
                    }
                    if (delMids.length > 0) {
                        await this.mailDbHandler.deleteInActionById(delMids, _account);
                    }
                    else {
                        console.warn('[mail-db] it do not happen');
                    }
                }
                await this.saveMails(data, undefined, undefined, _account);
                if (!skipWait) {
                    await wait(MailApiImpl.MAIL_SYNC_WAIT_SPAN);
                }
            }
        }
        return ret;
    }
    async syncMailByIdsByAccounts(mails, checkType, _account) {
        const allMails = mails.filter(v => !v.isTpMail);
        const allAccounts = [...new Set(allMails.map(v => v._account).filter(Boolean))];
        const map = new Map();
        allMails.forEach(mail => {
            const key = mail._account || _account;
            if (key) {
                const arr = map.get(key);
                if (Array.isArray(arr)) {
                    arr.push(mail.id);
                }
                else {
                    map.set(key, [mail.id]);
                }
            }
        });
        try {
            const syncMailByIdsPromises = allAccounts.map(account => {
                const key = account || _account;
                if (key) {
                    const idArray = map.get(key) || [];
                    return this.syncMailByIds(idArray, checkType, true, key);
                }
                return Promise.resolve();
            });
            await Promise.all(syncMailByIdsPromises);
        }
        catch (error) {
            console.log('[syncMailByIdsByAccounts] error:', error);
        }
    }
    async syncTpMailByIds(param, checkType) {
        var _a;
        const allMids = param.reduce((t, v) => [...t, ...v.mids], []);
        const query = param.reduce((total, current) => {
            const { email, mids } = current;
            if (email) {
                const oldIds = total.get(email);
                if (!oldIds) {
                    total.set(email, mids);
                }
                else {
                    total.set(email, [...oldIds, ...mids]);
                }
            }
            return total;
        }, new Map());
        const queryList = [...query.entries()].map(([email, mids]) => {
            var _a, _b, _c;
            return ({
                email,
                mids,
                subEmail: email,
                mainAccount: (_a = param[0]) === null || _a === void 0 ? void 0 : _a.mainAccount,
                refId: (_b = param[0]) === null || _b === void 0 ? void 0 : _b.refId,
                type: (_c = param[0]) === null || _c === void 0 ? void 0 : _c.type,
            });
        });
        const mailBoxEntities = await this.mailContentHandler.listCustomerMailEntryById(queryList, checkType, (_a = param[0]) === null || _a === void 0 ? void 0 : _a.colleagueAccId);
        const newData = Array.isArray(mailBoxEntities) ? mailBoxEntities : mailBoxEntities.data;
        const filterNewData = newData;
        const newIdSet = filterNewData.reduce((t, v) => t.add(v.id), new Set());
        console.log('[sync tp mail] ids exist', filterNewData);
        if (allMids.length > filterNewData.length) {
            const delIds = allMids.filter(id => !newIdSet.has(id));
            console.log('[sync tp mail] ids to del', delIds);
            if (delIds.length > 0) {
                await this.mailDbHandler.deleteTpMailsById(delIds);
            }
        }
        return filterNewData;
    }
    async syncResignMailByIds(param) {
        const mailBoxEntities = await this.mailContentHandler.listResignMailEntryById(param);
        const newData = Array.isArray(mailBoxEntities) ? mailBoxEntities : mailBoxEntities.data;
        return newData;
    }
    sendRecentContact(receiver, _account) {
        const toList = [];
        const ccList = [];
        const bccList = [];
        receiver.forEach(item => {
            switch (item.mailMemberType) {
                case 'to':
                    toList.push({
                        contactId: item.contactItem.contactId,
                        email: item.contactItem.contactItemVal,
                    });
                    break;
                case 'cc':
                    ccList.push({
                        contactId: item.contactItem.contactId,
                        email: item.contactItem.contactItemVal,
                    });
                    break;
                case 'bcc':
                    bccList.push({
                        contactId: item.contactItem.contactId,
                        email: item.contactItem.contactItemVal,
                    });
                    break;
                default:
                    break;
            }
        });
        const commonParams = {
            conditionType: 1,
            _account,
        };
        this.contactApi.addRecentContact({
            memberParams: {
                to: Object.assign(Object.assign({}, commonParams), { contactlist: toList, contactType: 1 }),
                cc: Object.assign(Object.assign({}, commonParams), { contactlist: ccList, contactType: 2 }),
                bcc: Object.assign(Object.assign({}, commonParams), { contactlist: bccList, contactType: 3 }),
            },
            _account,
        });
    }
    async addNewContact(receiver, _account) {
        if (!receiver || receiver.length <= 0) {
            return;
        }
        console.log('auto add receivers', receiver);
        const mailList = [];
        const needInsert = [];
        receiver.forEach(item => {
            var _a, _b;
            const email = item.contactItem.contactItemVal || ((_b = (_a = item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName);
            if (item.contact.contact.type === 'external') {
                mailList.push(email);
                needInsert.push(item);
            }
        });
        if (!mailList.length) {
            return;
        }
        const contactList = await this.contactApi.doGetContactByItem({
            type: 'EMAIL',
            value: mailList,
            filterType: 'personal',
        });
        const emailSet = new Set();
        contactList
            .map(item => (item.contactInfo || []).map(item => item.contactItemVal))
            .flat()
            .forEach(subEmail => {
            emailSet.add(subEmail);
        });
        const insertList = [];
        needInsert.forEach(item => {
            var _a, _b;
            const email = (item.contactItem.contactItemVal || ((_b = (_a = item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName)).toLowerCase();
            if (!emailSet.has(email)) {
                insertList.push(item);
            }
        });
        if (!insertList.length) {
            return;
        }
        this.contactHandler.addContact(insertList, _account);
    }
    async syncMailFolder(_account) {
        console.log('[mail box] syncMailFolder, account:', _account);
        const promise = this.mailDbHandler.listMailBoxRawEntry(_account);
        const promise1 = this.mailContentHandler.listMailEntry({ order: 'custom_virtual' }, 'listFolder', true, _account);
        await Promise.all([promise, promise1]).then(async ([cache, network]) => {
            console.log(cache, network);
            if (network && network.length > 0) {
                await this.mailDbHandler.saveMailBoxes(network);
            }
            const netSet = new Map();
            network === null || network === void 0 ? void 0 : network.forEach(it => {
                netSet.set(it.id, it);
            });
            const delIds = [];
            cache === null || cache === void 0 ? void 0 : cache.forEach(it => {
                if (!netSet.has(it.id)) {
                    delIds.push(Number(it.id));
                }
            });
            const filterDelIds = delIds.filter(v => !!v);
            if (filterDelIds.length > 0) {
                await this.mailDbHandler.db.deleteById(mailBoxTable, filterDelIds, _account);
            }
        });
    }
    async doGetMailSearchRecords(count = 10, _account) {
        return this.mailDbHandler.doGetMailSearchRecords(count, 'search', _account);
    }
    async doGetMailSearchRecords_sd(count = 10, _account) {
        return this.mailDbHandler.doGetMailSearchRecords(count, 'search_sd', _account);
    }
    async doSaveMailSearchRecord(content, _account) {
        const contents = Array.isArray(content) ? content : [content];
        try {
            const list = await this.mailDbHandler.doGetMailSearchRecords(50, 'search', _account);
            if (contents && contents.length) {
                const idMap = {};
                contents.forEach(item => {
                    if (item.content) {
                        idMap[item.content.trim()] = !0;
                    }
                });
                const repeatIdList = list.filter(item => item.content && idMap[item.content.trim()]).map(item => item.id);
                if (repeatIdList && repeatIdList.length) {
                    await this.mailDbHandler.updateMailSearchRecord({
                        id: repeatIdList,
                        deleteFlag: 1,
                    }, _account);
                }
            }
        }
        catch (e) {
            console.error('[Error doGetMailSearchRecords]', e);
        }
        if (contents && contents.length) {
            await this.mailDbHandler.doSaveMailSearchRecord(contents, 'search', _account);
        }
    }
    async doSaveMailSearchRecord_sd(content, _account) {
        const contents = Array.isArray(content) ? content : [content];
        try {
            const list = await this.mailDbHandler.doGetMailSearchRecords(50, 'search_sd', _account);
            if (contents && contents.length) {
                const idMap = {};
                contents.forEach(item => {
                    if (item.content) {
                        idMap[item.content.trim()] = !0;
                    }
                });
                const repeatIdList = list.filter(item => item.content && idMap[item.content.trim()]).map(item => item.id);
                if (repeatIdList && repeatIdList.length) {
                    await this.mailDbHandler.updateMailSearchRecord({
                        id: repeatIdList,
                        deleteFlag: 1,
                    }, _account);
                }
            }
        }
        catch (e) {
            console.error('[Error doSaveMailSearchRecord_sd]', e);
        }
        if (contents && contents.length) {
            await this.mailDbHandler.doSaveMailSearchRecord(contents, 'search_sd', _account);
        }
    }
    async doDeleteMailSearchRecord(id, isDel = true, _account) {
        const ids = Array.isArray(id) ? id : [id];
        await this.mailDbHandler.updateMailSearchRecord({
            id: ids,
            deleteFlag: isDel ? 1 : 0,
        }, _account);
    }
    generateRndId() {
        return this.modelHandler.generateRndId();
    }
    async doGetPraiseMedals() {
        if (!this.actions.praiseMedals || this.actions.praiseMedals.length === 0) {
            await this.getPraiseMedals();
        }
        return this.actions.praiseMedals;
    }
    async scanMailsSetStrangers() {
        var _a;
        console.log('scanMailsSetStrangers');
        if (this.scanningMails)
            return;
        this.scanningMails = true;
        const oldScanBoundaryMailId = (_a = this.storeApi.getSync('scanBoundaryMailId')) === null || _a === void 0 ? void 0 : _a.data;
        let newScanBoundaryMailId = null;
        const scanRecent1wMails = async () => {
            const scanMaxNum = 10000;
            let count = 0;
            const nowTime = new Date().getTime();
            const expireTime = 60 * 24 * 60 * 60 * 1000;
            const contactStrangerMap = new Map();
            const loopLen = 50;
            const { mailBoxDic } = this.actions;
            let dicIds = [1];
            if (mailBoxDic) {
                dicIds =
                    mailBoxDic &&
                        Object.keys(mailBoxDic).reduce((total, key) => {
                            const { mailBoxType } = mailBoxDic[Number(key)];
                            if (mailBoxType !== 'sys') {
                                return [...total, Number(key)];
                            }
                            return total;
                        }, [...dicIds]);
            }
            const dealMail = (mail) => {
                const { id, senders, sender, entry } = mail;
                if (!newScanBoundaryMailId)
                    newScanBoundaryMailId = id;
                const senderArr = senders || [sender] || [];
                senderArr &&
                    senderArr.forEach(item => {
                        const { inContactBook, contact } = item;
                        if (!inContactBook) {
                            const { contact: contactInfo } = contact;
                            const { accountName, contactName } = contactInfo;
                            const sendTimeMS = new Date(String(entry.sendTime)).getTime();
                            if (!contactStrangerMap.has(accountName)) {
                                contactStrangerMap.set(accountName, {
                                    accountName,
                                    contactName,
                                    mailIds: [id],
                                    sendTime: sendTimeMS,
                                    priority: null,
                                });
                            }
                            else {
                                const existedContactStranger = contactStrangerMap.get(accountName);
                                if (existedContactStranger) {
                                    const { mailIds, sendTime: existedSendTime } = existedContactStranger;
                                    contactStrangerMap.set(accountName, Object.assign(Object.assign({}, existedContactStranger), { mailIds: mailIds ? [...mailIds, id] : [id], sendTime: sendTimeMS > existedSendTime ? sendTimeMS : existedSendTime }));
                                }
                            }
                        }
                    });
            };
            const getNextLoop = async ({ index, dicIndex }) => {
                console.log('getNextLoop', index, dicIndex);
                const preDicId = dicIds[dicIndex];
                if (!preDicId)
                    return;
                const mailList = await this.mailDbHandler.doListMailEntry({
                    id: preDicId,
                    index,
                    count: loopLen,
                });
                console.log('mailListmailList', mailList);
                const mails = (mailList === null || mailList === void 0 ? void 0 : mailList.data) || [];
                if (!mails || (mails === null || mails === void 0 ? void 0 : mails.length) === 0) {
                    await intoNextFolder(dicIndex + 1);
                }
                let loopRes = '';
                for (let i = 0; i < mails.length; i++) {
                    const pre = mails[i];
                    const { createTime, id } = pre;
                    if (oldScanBoundaryMailId === id)
                        return;
                    if (createTime && nowTime - createTime > expireTime) {
                        loopRes = 'nextFolder';
                        break;
                    }
                    if (count >= scanMaxNum)
                        return;
                    dealMail(pre);
                    count += 1;
                    if (i === mails.length - 1) {
                        if (mails.length < loopLen) {
                            loopRes = 'nextFolder';
                            break;
                        }
                        loopRes = 'nextLoop';
                        break;
                    }
                }
                if (loopRes === 'nextLoop') {
                    await getNextLoop({ index: index + loopLen, dicIndex });
                }
                if (loopRes === 'nextFolder') {
                    await intoNextFolder(dicIndex + 1);
                }
            };
            const intoNextFolder = async (dicIndex) => {
                await getNextLoop({ index: 0, dicIndex });
            };
            await getNextLoop({ index: 0, dicIndex: 0 });
            return contactStrangerMap;
        };
        try {
            const contactStrangerMap = await scanRecent1wMails();
            const newUserArr = [];
            contactStrangerMap.forEach(value => newUserArr.push(value));
            if (newUserArr.length > 0) {
                await this.newUsersIntoEmailList(newUserArr);
                newScanBoundaryMailId && this.storeApi.putSync('scanBoundaryMailId', newScanBoundaryMailId);
            }
            this.scanningMails = false;
        }
        catch (error) {
            console.log('scan 1w mails fail', error);
            this.scanningMails = false;
        }
    }
    async newMailIntoStrangers(newComer) {
        if (!this.contactReady)
            return;
        console.log('newMailIntoStrangers', newComer);
        const mails = Array.isArray(newComer) ? newComer : [newComer];
        const contactStrangers = [];
        mails.forEach(mail => {
            const { id, senders, sender, entry } = mail;
            const senderArr = senders || [sender] || [];
            senderArr &&
                senderArr.forEach(item => {
                    const { inContactBook, contact } = item;
                    if (!inContactBook) {
                        const { contact: contactInfo } = contact;
                        const { accountName, contactName } = contactInfo;
                        contactStrangers.push({
                            accountName,
                            contactName,
                            mailIds: [id],
                            sendTime: new Date(String(entry.sendTime)).getTime(),
                            priority: null,
                        });
                    }
                });
        });
        if (contactStrangers.length > 0) {
            await this.newUsersIntoEmailList(contactStrangers);
        }
    }
    async newUsersIntoEmailList(originUsers, occasion) {
        const users = originUsers.filter(item => (item === null || item === void 0 ? void 0 : item.accountName) && !!this.systemApi.handleAccountAndDomain(item.accountName).account);
        if (users.length < 1)
            return true;
        try {
            const accountNameArr = users.map(item => item.accountName);
            const searchEmailListRes = await this.db.getByIds({
                dbName: 'contact_dexie',
                tableName: 'email_list',
            }, accountNameArr);
            console.log('searchEmailListRes', searchEmailListRes);
            const nowTime = new Date().getTime();
            const emailListUpdateArr = searchEmailListRes.map((item, index) => {
                const { accountName, priority, contactName, mailIds, sendTime, isSystemAccount } = users[index];
                if (!item) {
                    const newItem = {
                        accountName,
                        contactName,
                        createTime: nowTime,
                        updateTime: nowTime,
                        mailIds: mailIds || [],
                        priority: priority === null ? -1 : priority,
                        latestSendTime: sendTime,
                        isSystemAccount: isSystemAccount || false,
                    };
                    return newItem;
                }
                const { mailIds: existedMailIds, latestSendTime, priority: existedPriority, isSystemAccount: existedIsSystemAccount } = item;
                let newLatestSendTime = null;
                if (!sendTime && !latestSendTime)
                    newLatestSendTime = null;
                else if ((!sendTime && latestSendTime) || (sendTime && !latestSendTime)) {
                    newLatestSendTime = sendTime || latestSendTime;
                }
                else
                    newLatestSendTime = Math.max(sendTime, latestSendTime);
                const newIsSystemAccount = typeof isSystemAccount === 'boolean' ? isSystemAccount : existedIsSystemAccount || false;
                return Object.assign(Object.assign({}, item), { updateTime: nowTime, mailIds: Array.from(new Set([...existedMailIds, ...(mailIds || [])])), latestSendTime: newLatestSendTime, priority: priority === null ? existedPriority : priority, isSystemAccount: newIsSystemAccount });
            });
            await this.db.putAll({
                dbName: 'contact_dexie',
                tableName: 'email_list',
            }, emailListUpdateArr);
            const eventData = occasion === 'mark'
                ? {
                    markedAccountNames: accountNameArr,
                }
                : {};
            this.eventApi.sendSysEvent({
                eventName: 'emailListChange',
                eventStrData: occasion || '',
                eventData,
            });
            return true;
        }
        catch (error) {
            console.log('入email_list表失败');
            return false;
        }
    }
    async doGetAllStrangers() {
        try {
            const allStrangers = await this.db.getByEqCondition({
                dbName: 'contact_dexie',
                tableName: 'email_list',
                query: { priority: -1 },
                order: 'latestSendTime',
                desc: true,
            });
            const filterStrangers = allStrangers.filter(item => (item === null || item === void 0 ? void 0 : item.accountName) && !!this.systemApi.handleAccountAndDomain(item.accountName).account);
            return filterStrangers.reverse();
        }
        catch (error) {
            console.log('获取所有陌生人失败', error);
            return [];
        }
    }
    async doGetRecent3Strangers() {
        try {
            const baseConds = {
                dbName: 'contact_dexie',
                tableName: 'email_list',
                query: { priority: -1 },
            };
            const strangers = await this.db.getByEqCondition(Object.assign(Object.assign({}, baseConds), { order: 'latestSendTime', desc: true }));
            return {
                recent3Strangers: strangers.reverse().slice(0, 3),
                strangerCount: strangers.length,
            };
        }
        catch (error) {
            console.log('获取最近3个陌生人失败', error);
            return {
                recent3Strangers: [],
                strangerCount: 0,
            };
        }
    }
    async mailOperationEmailListChange(ev) {
        console.log('mailOperationEmailListChange', ev);
        try {
            const { eventStrData, eventData } = ev;
            if (eventStrData === 'delete') {
                const { status, params } = eventData;
                if (status !== 'success')
                    return;
                const { id, fid } = params;
                if (fid !== 4)
                    return;
                let delMailIdArr = [];
                if (typeof id === 'string')
                    delMailIdArr = [id];
                if (Array.isArray(id))
                    delMailIdArr = id;
                if (delMailIdArr.length < 1)
                    return;
                const rangeRes = await this.db.getByRangeCondition({
                    dbName: 'contact_dexie',
                    tableName: 'email_list',
                    adCondition: {
                        type: 'anyOf',
                        field: 'mailIds',
                        args: delMailIdArr,
                    },
                });
                if (!rangeRes || rangeRes.length < 1)
                    return;
                const updateTime = new Date().getTime();
                const resetItems = [];
                const delIds = [];
                rangeRes.forEach((item) => {
                    const filterMailIds = (item.mailIds || []).filter((mailIdItem) => !delMailIdArr.includes(mailIdItem));
                    if (filterMailIds.length > 0) {
                        resetItems.push(Object.assign(Object.assign({}, item), { updateTime, mailIds: filterMailIds }));
                    }
                    else {
                        delIds.push(item.accountName);
                    }
                });
                await this.db.putAll({
                    dbName: 'contact_dexie',
                    tableName: 'email_list',
                }, resetItems);
                await this.db.deleteById({
                    dbName: 'contact_dexie',
                    tableName: 'email_list',
                }, delIds);
                this.eventApi.sendSysEvent({
                    eventName: 'emailListChange',
                    eventStrData: '',
                    eventData: {},
                });
            }
        }
        catch (error) {
            console.log('邮件彻底删除 emaillist修改失败', error);
        }
    }
    async contactNotityEmailListChange(ev) {
        try {
            const { eventData } = ev;
            console.log('contactNotityEmailListChange', ev);
            const { contact_personal: pContact, contact_enterprise: eContact } = eventData;
            const { insertDiff: pInsertDiff, updateDiff: pUpdateDiff, deleteDiff: pDeleteDiff } = pContact || {};
            const { insertDiff: eInsertDiff, updateDiff: eUpdateDiff, deleteDiff: eDeleteDiff } = eContact || {};
            const insertAndUpdateContactIds = [...(pInsertDiff || []), ...(pUpdateDiff || []), ...(eInsertDiff || []), ...(eUpdateDiff || [])];
            let resArr = [];
            if ((insertAndUpdateContactIds === null || insertAndUpdateContactIds === void 0 ? void 0 : insertAndUpdateContactIds.length) > 0) {
                const contactArr = await this.contactApi.doGetContactById(insertAndUpdateContactIds);
                resArr = (contactArr || []).map((item) => {
                    const { contact } = item;
                    const { accountName, contactName, priority } = contact;
                    return {
                        accountName,
                        contactName,
                        priority: priority,
                    };
                });
            }
            const deleteContactIds = [...(pDeleteDiff || []), ...(eDeleteDiff || [])];
            let res1Arr = [];
            if ((deleteContactIds === null || deleteContactIds === void 0 ? void 0 : deleteContactIds.length) > 0) {
                res1Arr = deleteContactIds.map((item) => ({
                    accountName: item,
                    priority: -1,
                }));
            }
            await this.newUsersIntoEmailList([...resArr, ...res1Arr]);
        }
        catch (error) {
            console.log('通讯录发生变化 emaillist响应失败', error);
        }
    }
    async systemAccountsIntoEmailList() {
        try {
            let mySystemAccounts = [];
            mySystemAccounts = SystemAccounts;
            const systemUsers = mySystemAccounts.map((item) => ({
                accountName: item,
                priority: 0,
                isSystemAccount: true,
            }));
            await this.newUsersIntoEmailList(systemUsers);
        }
        catch (error) {
            console.log('系统账号插入emaillist失败', error);
        }
    }
    async listAttachments(params) {
        const result = await this.mailContentHandler.listAttachments(params);
        return result;
    }
    async assembleMail(data) {
        const res = Object.assign(Object.assign({}, data), { id: data.emailMid, tid: data.emailTid, sentDate: new Date(data.sentDate).toString() });
        const prItem = this.contactHandler.mapMailEntryToProcessingItem(res, data.emailMid);
        return this.contactHandler.handleContactList([prItem]).then((it) => this.mailContentHandler.handleMailContentResponse(it, true));
    }
    async doUploadMail(cid, fid) {
        if (!isElectron()) {
            return Promise.reject(new Error('只可以在electron中调用'));
        }
        const matched = util.extractPathFromCid(cid);
        if (!matched || matched.length < 2) {
            return Promise.reject(new Error('错误的ID'));
        }
        const filePath = matched[1];
        const fileExist = window.electronLib.fsManage.isExist(filePath);
        console.log('[upload mail] file path', filePath, 'is exist', fileExist);
        if (!fileExist) {
            return Promise.reject(new Error('文件不存在'));
        }
        const file = await window.electronLib.fsManage.readFile(filePath);
        if (file.length <= 0) {
            return Promise.reject(new Error('文件损坏'));
        }
        const uploadResult = await this.mailContentHandler.uploadMail(fid, file);
        console.log('[upload mail] file', file, 'result', uploadResult);
        this.doGetParsedEmlFromDb(cid).then(emlContentInDb => {
            if (emlContentInDb) {
                emlContentInDb.id = uploadResult.mid;
                this.db.put(mailComposeDataTable, emlContentInDb).catch();
            }
        });
        return uploadResult;
    }
    async doImportMails(conf, useDragImport) {
        let result = [];
        if (inElectron && useDragImport) {
            result = await this.doImportMailByDrag(conf);
        }
        else if (!inElectron) {
            result = await this.doImportMailInWeb(conf);
        }
        else {
            result = await this.doImportMailInElectron(conf);
        }
        return result;
    }
    async doImportMailInWeb(conf) {
        const { fileList = [], fid, _account } = conf;
        const result = [];
        const _extension = '.eml';
        const uploadPromise = [];
        const filteredFileList = new Map();
        const _doImportSingleMail = async (file, idx) => {
            const buffer = (await file.arrayBuffer());
            const res = await this.mailContentHandler.uploadMail(fid, buffer, _account);
            return {
                mid: res.mid,
                fileName: file.name,
                success: true,
                idx,
            };
        };
        fileList.forEach(item => {
            filteredFileList.set(`${item.name}_${item.size}`, item);
        });
        [...filteredFileList.values()].forEach((file, idx) => {
            if (file.name.includes(_extension)) {
                uploadPromise.push(_doImportSingleMail(file, idx));
            }
            else {
                result.push({ fileName: file.name, success: false, reason: 'invalid extension' });
            }
        });
        const uploadRes = await Promise.allSettled(uploadPromise);
        uploadRes.forEach(_res => {
            if (_res.status === 'fulfilled') {
                result.push({ mid: _res.value.mid, fileName: _res.value.fileName, success: true });
            }
            else {
                result.push({ mid: '', fileName: '', success: false, reason: JSON.stringify(_res) });
            }
        });
        try {
            this.dataTrackerHelper.track('import_mail_web_trace', {
                files: fileList,
                result,
            });
        }
        catch (error) {
            console.error('import_mail_web_trace error', error);
        }
        return result;
    }
    async _filterDupFileByMd5(pathList, _account, finallyRes = [], ignoreDuplicateFid = 4) {
        if (pathList.length <= 0) {
            return new Map();
        }
        const calcMd5Promise = [];
        const md5Map = new Map();
        const _doGetFileMd5 = async (path) => {
            const md5 = await window.electronLib.fsManage.getFileMd5(path);
            return { path, md5 };
        };
        const _genFailedResult = (times, reason, faildRes = []) => {
            for (let i = 0; i < times; i++) {
                faildRes.push({
                    mid: '',
                    fileName: '',
                    success: false,
                    reason,
                });
            }
            return faildRes;
        };
        pathList.forEach(path => {
            calcMd5Promise.push(_doGetFileMd5(path));
        });
        const calcMd5PromiseRes = await Promise.allSettled(calcMd5Promise);
        calcMd5PromiseRes.forEach(res => {
            if (res.status === 'fulfilled') {
                md5Map.set(res.value.md5, res.value.path);
            }
        });
        if (md5Map.size < calcMd5PromiseRes.length) {
            _genFailedResult(calcMd5PromiseRes.length - md5Map.size, 'local repeat', finallyRes);
        }
        const dubMd5List = await this.getDuplicateMailByLocalMd5([...md5Map.keys()], _account, ignoreDuplicateFid);
        if (dubMd5List === null || dubMd5List === void 0 ? void 0 : dubMd5List.length) {
            _genFailedResult(dubMd5List.length, 'network repeat', finallyRes);
            dubMd5List.forEach(md5 => {
                md5Map.delete(md5);
            });
        }
        return md5Map;
    }
    async getDuplicateMailByLocalMd5(md5List, _account, ignoreDuplicateFid = 4) {
        const existsLocalMails = await this.fileApi.checkMailMd5Exists([...md5List], _account);
        if (existsLocalMails.length) {
            const existsNetworkMails = await this.listMailEntryFromNetwork({
                mids: existsLocalMails.map(mail => mail.mid),
                count: existsLocalMails.length,
                _account,
            }, true);
            const midsFromNetwork = (Array.isArray(existsNetworkMails) ? existsNetworkMails : existsNetworkMails.data)
                .filter(it => { var _a; return ((_a = it === null || it === void 0 ? void 0 : it.entry) === null || _a === void 0 ? void 0 : _a.folder) !== ignoreDuplicateFid; })
                .map(it => it.id);
            const dupMails = existsLocalMails.filter(localMail => midsFromNetwork.indexOf(localMail.mid) !== -1);
            return dupMails.map(mail => mail.mailMd5);
        }
        return [];
    }
    async doImportMailByDrag(conf) {
        const { fileList = [], fid, _account } = conf;
        const result = [];
        const uploadPromise = [];
        const filteredFileList = new Map();
        const calcMd5Promise = [];
        const localMailModelList = [];
        const isSubCountReq = window === null || window === void 0 ? void 0 : window.isAccountBg;
        const _doImportSingleMail = async (file, idx, md5) => {
            let buffer;
            try {
                if (isSubCountReq) {
                    buffer = (await window.electronLib.fsManage.readFile(file.path));
                }
                else {
                    buffer = (await file.arrayBuffer());
                }
                const res = await this.mailContentHandler.uploadMail(fid, buffer, _account);
                return {
                    mid: res.mid,
                    fileName: file.name,
                    success: true,
                    path: file.path,
                    idx,
                    mailMd5: md5,
                };
            }
            catch (error) {
                const reason = JSON.stringify(error);
                return {
                    mid: '',
                    fileName: '',
                    success: false,
                    reason,
                };
            }
        };
        const _genFailedResult = (times, reason, faildRes = []) => {
            for (let i = 0; i < times; i++) {
                faildRes.push({
                    mid: '',
                    fileName: '',
                    success: false,
                    reason,
                });
            }
            return faildRes;
        };
        const _doGetFileMd5 = async (file) => {
            try {
                let buffer;
                if (isSubCountReq) {
                    buffer = (await window.electronLib.fsManage.readFile(file.path));
                }
                else {
                    buffer = (await file.arrayBuffer());
                }
                const hash = createHash('md5');
                const _buffer = Buffer.from(buffer);
                try {
                    _buffer._isBuffer = true;
                }
                catch (error) {
                    console.error('[error] buffer._isBuffer', error);
                }
                hash.update(_buffer);
                return { md5: hash.digest('hex').toUpperCase(), file };
            }
            catch (e) {
                _genFailedResult(1, (e === null || e === void 0 ? void 0 : e.message) || '获取md5报错', result);
                return Promise.reject();
            }
        };
        fileList.forEach(file => {
            calcMd5Promise.push(_doGetFileMd5(file));
        });
        const calcMd5PromiseRes = await Promise.allSettled(calcMd5Promise);
        calcMd5PromiseRes.forEach(res => {
            if (res.status === 'fulfilled') {
                filteredFileList.set(res.value.md5, res.value.file);
            }
        });
        const dubMd5List = await this.getDuplicateMailByLocalMd5([...filteredFileList.keys()], _account, conf.ignoreDuplicateFid);
        if (dubMd5List === null || dubMd5List === void 0 ? void 0 : dubMd5List.length) {
            _genFailedResult(dubMd5List.length, 'network repeat', result);
            dubMd5List.forEach(md5 => {
                filteredFileList.delete(md5);
            });
        }
        [...filteredFileList].forEach(([md5, file], idx) => {
            uploadPromise.push(_doImportSingleMail(file, idx, md5));
        });
        const uploadRes = await Promise.allSettled(uploadPromise);
        uploadRes.forEach(_res => {
            if (_res.status === 'fulfilled') {
                const { mid = '', fileName = '', mailMd5 = '', success } = _res.value;
                localMailModelList.push({ mid, mailMd5, mailLocalPath: fileName });
                result.push({ mid, fileName, success });
            }
        });
        await this.fileApi.saveImportMails(localMailModelList, _account);
        return result;
    }
    async doImportMailInElectron(conf) {
        const { fid, _account } = conf;
        const result = [];
        const _extension = '.eml';
        const loopPathPromise = [];
        const uploadPromise = [];
        const localMailModelList = [];
        let dirPathList = [];
        const _doCollectFilePath = async (path) => {
            const filePath = await window.electronLib.fsManage.loopDirPath(path, _extension, true);
            if (Array.isArray(filePath) && filePath.length > 0) {
                return filePath;
            }
            if (typeof filePath === 'string') {
                return [filePath];
            }
            return [];
        };
        const _doImportSingleMail = async (path, name, md5) => {
            let reason = '';
            try {
                if (window.electronLib.fsManage.isExist(path)) {
                    const fileBuffer = (await window.electronLib.fsManage.readFile(path));
                    const res = await this.mailContentHandler.uploadMail(fid, fileBuffer, _account);
                    return {
                        mid: res.mid,
                        fileName: name,
                        success: true,
                        mailMd5: md5,
                    };
                }
            }
            catch (error) {
                reason = JSON.stringify(error);
                this.dataTrackerHelper.track('import_mail_error', {
                    path,
                    name,
                    error: reason,
                });
                console.warn('_doImportSingleMail in electron error has occured', error);
            }
            return {
                mid: '',
                fileName: name,
                success: false,
                mailMd5: '',
                reason,
            };
        };
        const selectRes = await window.electronLib.windowManage.select({
            properties: this.isMac ? ['openDirectory', 'openFile', 'multiSelections'] : ['openFile', 'multiSelections'],
            filters: [{ name: 'email', extensions: ['eml'] }],
            buttonLabel: '上传',
        });
        if (selectRes.success) {
            const paths = Array.isArray(selectRes.path) ? selectRes.path : [selectRes.path];
            paths.forEach((path) => {
                loopPathPromise.push(_doCollectFilePath(path));
            });
            const res = await Promise.allSettled(loopPathPromise);
            res.forEach((pathResult) => {
                if (pathResult.status === 'fulfilled' && pathResult.value) {
                    dirPathList = dirPathList.concat(pathResult.value);
                }
                else if (pathResult.status === 'rejected') {
                    result.push({
                        mid: '',
                        fileName: '',
                        success: false,
                        reason: 'can not find dir or files: ' + (pathResult === null || pathResult === void 0 ? void 0 : pathResult.reason),
                    });
                }
            });
            const filteredLocalMailModel = await this._filterDupFileByMd5([...new Set(dirPathList)], _account, result, conf.ignoreDuplicateFid);
            [...filteredLocalMailModel].forEach(([md5, path]) => {
                uploadPromise.push(_doImportSingleMail(path, path, md5));
            });
            const uploadRes = await Promise.allSettled(uploadPromise);
            uploadRes.forEach(resData => {
                if (resData.status === 'fulfilled') {
                    const importRes = resData.value;
                    result.push({
                        mid: importRes.mid,
                        mailMd5: importRes.mailMd5,
                        fileName: importRes.fileName,
                        success: importRes.success,
                    });
                    localMailModelList.push({ mid: importRes.mid || '', mailMd5: importRes.mailMd5 || '', mailLocalPath: importRes.fileName || '' });
                }
                else if (resData.status === 'rejected') {
                    result.push({
                        mid: '',
                        fileName: '',
                        success: false,
                        reason: 'upload failed: ' + resData.reason,
                    });
                }
            });
            await this.fileApi.saveImportMails(localMailModelList, _account);
        }
        else {
            result.push({
                mid: '',
                fileName: '',
                success: false,
                reason: 'canceled',
            });
        }
        return result;
    }
    doGetParsedEmlFromDb(cid, _account) {
        return this.db.getById(mailComposeDataTable, cid, _account);
    }
    async trackEmlOpenEvent() {
        try {
            this.loggerHelper.track('pcMail_OpenLocalEml_withLX');
        }
        catch (ex) {
            console.error('trackEmlOpenEvent-Error', ex);
        }
    }
    showUIMsg(msg, popupLevel = 'error') {
        try {
            if (!msg || !msg.length)
                return;
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventData: {
                    popupType: 'window',
                    popupLevel,
                    title: msg,
                },
            });
        }
        catch (ex) {
            console.error('showErrorMsg-catch', ex);
        }
    }
    getIsSendAttachmentWritePage() {
        if (this.isMailPage) {
            return inWindow() ? location.href.indexOf('send-as-attachment') > 0 : false;
        }
        return false;
    }
    async storeFilePathsByKey(key, filePaths) {
        try {
            await window.electronLib.storeManage.set('memory', key, filePaths);
        }
        catch (ex) {
            console.error('storeFilePathsByKey-error', ex);
        }
    }
    async getStoreFilesByKey(key) {
        try {
            const res = await window.electronLib.storeManage.get('memory', key);
            window.electronLib.storeManage.set('memory', key, []);
            return res;
        }
        catch (ex) {
            console.error('getStoreFileByKey-error', ex);
            return [];
        }
    }
    async handleSendFileAsAttachment(filePaths) {
        try {
            const storeKey = new Date().getTime().toString() + Math.random().toString();
            await this.storeFilePathsByKey(storeKey, filePaths);
            this.systemApi.createWindow({ type: 'writeMailAttachmentPage', additionalParams: { 'send-as-attachment': 'true', 'store-key': storeKey } });
        }
        catch (ex) {
            console.error('handleSendFileAsAttachment-catch', ex);
        }
    }
    async openEmlMails(filePaths) {
        for (const filePath of filePaths) {
            try {
                this.trackEmlOpenEvent();
                const cid = await this.preParseEml(filePath);
                const res = await this.systemApi.createWindowWithInitData({ type: 'readMail', additionalParams: { account: '' } }, {
                    eventName: 'initPage',
                    eventData: cid,
                    _account: '',
                });
                if (!res.success) {
                    console.warn('[open eml] error', filePath, res.message);
                }
                await wait(500);
            }
            catch (e) {
                console.warn('[open eml] error', e);
            }
        }
    }
    async preParseEml(filePath) {
        if (isElectron()) {
            const fileExist = window.electronLib.fsManage.isExist(filePath);
            if (!fileExist) {
                return Promise.reject(new Error('文件不存在'));
            }
            const stat = await window.electronLib.fsManage.stat(filePath);
            const lastModified = stat.mtime.getTime();
            return `eml-${filePath}-${lastModified}`;
        }
        return Promise.reject(new Error('只可以在electron中调用'));
    }
    async doParseEml(cid, encoding, _account) {
        if (process.env.BUILD_ISELECTRON) {
            const content = await this.doGetParsedEmlFromDb(cid, _account);
            console.log('[parse eml] from db', cid, content);
            if (content) {
                return content;
            }
            const matched = util.extractPathFromCid(cid);
            if (!matched) {
                return Promise.reject(new Error('错误的EML ID'));
            }
            const filePath = matched[1];
            const lastModified = +matched[2];
            const parsedMail = await window.electronLib.fsManage.parseEml(filePath, lastModified);
            parsedMail.id = cid;
            console.log('[parse eml] parse mail', parsedMail);
            await this.handleEmlAttachments(parsedMail, encoding || parsedMail.encoding);
            const mailContentRes = this.parsedMailToResponseContent(parsedMail);
            const processingItem = await this.mailContentHandler.getMailContentProcessResponse(mailContentRes.id, mailContentRes);
            const mailModel = await this.mailContentHandler.handleMailContentResponse(processingItem, true, 'eml', undefined, _account);
            mailModel.localFilePath = filePath;
            mailModel.cid = cid;
            console.log('[parse eml] return model', mailModel);
            await this.db.put(mailComposeDataTable, mailModel, _account).catch();
            return mailModel;
        }
        console.warn('[parse eml] 只可以在electron中调用');
        return Promise.reject(new Error('只可以在electron中调用'));
    }
    async handleEmlAttachments(parsedMail, encoding = 'utf8') {
        const { attachments } = parsedMail;
        if (Array.isArray(attachments) && attachments.length > 0) {
            for (const attach of attachments) {
                if (isWinmailDatAttachment(attach.contentType, attach.filename)) {
                    if (inElectron) {
                        try {
                            const result = await window.electronLib.fsManage.parseTNEFFile(attach.content, encoding);
                            console.log('[parse eml] html from .dat attachment', result);
                            if (typeof result === 'string') {
                                parsedMail.html = result;
                            }
                            else if (Array.isArray(result)) {
                                parsedMail.attachments.push(...result);
                            }
                            else {
                                console.warn('[parse eml] html from .dat attachment get nothing');
                            }
                        }
                        catch (e) {
                            console.log('[parse eml] html from .dat attachment error', e);
                        }
                    }
                }
            }
        }
        return parsedMail;
    }
    parsedMailToResponseContent(parseMail) {
        const { cc = [], html, subject = '', headerLines = [], date, from, to = [], bcc = [], replyTo, text = '' } = parseMail;
        const attachments = parseMail.attachments
            .filter(v => !isWinmailDatAttachment(v.contentType, v.filename))
            .map((v, index) => ({
            filename: v.filename || '',
            contentId: v.contentId || '',
            estimateSize: v.size,
            contentLength: v.content.length,
            id: index + 1,
            contentType: v.contentType,
            inlined: v.contentDisposition === 'inline' || v.related,
            content: v.content,
        }));
        const xPriority = headerLines.find(v => v.key === 'x-priority');
        const priority = xPriority && xPriority.line ? xPriority.line.match(/X-Priority:\s*(\d+)/) : null;
        const contentHtml = {
            filename: 'ATT00002.html',
            content: typeof html === 'string' ? html : '',
            contentLength: typeof html === 'string' ? html.length : 0,
            contentType: 'text/html',
            id: 1,
            inlined: false,
        };
        const contentText = Object.assign(Object.assign({}, contentHtml), { content: text });
        return {
            id: parseMail.id,
            attachments,
            html: contentHtml,
            text: contentText,
            subject,
            priority: Array.isArray(priority) && priority[1] !== undefined ? +priority[1] : 3,
            sentDate: date ? util.formatDate(new Date(date).getTime()) : '',
            from: Array.isArray(from) ? from.map(v => v.text) : [from ? from.text : ''],
            to: Array.isArray(to) ? to.map(v => v.text) : [to.text],
            cc: Array.isArray(cc) ? cc.map(v => v.text) : [cc.text],
            bcc: Array.isArray(bcc) ? bcc.map(v => v.text) : [bcc.text],
            replyTo: Array.isArray(replyTo) ? replyTo.map(v => v.text) : [replyTo ? replyTo.text : ''],
        };
    }
    getMailDeliveryDetail(mid, _account) {
        return this.mailContentHandler.getMailDeliveryDetail(mid, _account);
    }
    async doListStarContact(_account) {
        const starList = await this.mailDbHandler.doListStarContact(_account);
        console.log('[star mail] star List', starList);
        return starList;
    }
    handleEmailListStringToParsedContent(listStr, ret) {
        return this.contactHandler.handleEmailListStringToParsedContent(listStr, ret);
    }
    async getMailReadList(tid, _account) {
        try {
            if (!tid) {
                return {
                    success: false,
                    errorMsg: 'tid is null',
                };
            }
            const url = this.systemApi.getAccountUrl('mailReadList', _account);
            const data = await this.impl.post(url, { tid }, { _account }).then(data => data.data);
            if (data && data.code && data.code.toString() === '200') {
                const timeZone = this.mailConfApi.getTimezone();
                const readList = (data.result && data.result.data) || [];
                return {
                    success: true,
                    data: readList.map(item => {
                        const timeZoneDate = this.systemApi.getDateByTimeZone(item.readTime, timeZone);
                        item.readTime = dayjs(timeZoneDate).format('MM-DD HH:mm');
                        item.localReadTime = dayjs(item.localReadTime).format('MM-DD HH:mm');
                        return item;
                    }),
                };
            }
            return {
                success: false,
                errorMsg: '未知错误',
            };
        }
        catch (ex) {
            const errorMsg = typeof ex === 'string' ? ex : (ex && ex.message) || '未知错误';
            return {
                success: false,
                errorMsg,
            };
        }
    }
    getMailHeaders(mid, _account) {
        return this.mailContentHandler.getMailHeaders(mid, _account);
    }
    getExePath() {
        return window.electronLib.appManage.getPath('exe');
    }
    async getShouldUseInstallDir() {
        if (!process.env.BUILD_ISELECTRON)
            return false;
        const isWin = !window.electronLib.env.isMac;
        if (isWin) {
            const exePath = await this.getExePath();
            if (exePath && exePath.toLowerCase().indexOf('c:') === 0) {
                return false;
            }
            return true;
        }
        return false;
    }
    async getExeDir() {
        return this.getExePath().then((exeDir) => {
            if (exeDir && exeDir.includes('.exe') && exeDir.includes('\\')) {
                const lastPathSplitInx = exeDir.lastIndexOf('\\');
                return exeDir.substring(0, lastPathSplitInx);
            }
            return '';
        });
    }
    async getDefaultMailCachePath() {
        const shouldUseInstallDir = await this.getShouldUseInstallDir();
        let cacheDir = '';
        if (shouldUseInstallDir) {
            const exeDir = await this.getExeDir();
            try {
                cacheDir = await window.electronLib.fsManage.mkDir('download', exeDir);
            }
            catch (ex) {
                cacheDir = await window.electronLib.fsManage.normalizePath(`${exeDir}/download`);
            }
        }
        else {
            try {
                cacheDir = await window.electronLib.fsManage.mkDir('download');
            }
            catch (ex) {
                const userDataPath = await window.electronLib.appManage.getPath('userData');
                cacheDir = await window.electronLib.fsManage.normalizePath(`${userDataPath}/download`);
            }
        }
        return cacheDir;
    }
    async getMailCachePath() {
        try {
            if (!process.env.BUILD_ISELECTRON)
                return '';
            const data = this.storeApi.getSync(MAIL_CACHE_CUSTOMDIRKEY, globalStoreConfig);
            if (data && data.suc && data.data) {
                return data.data;
            }
            return this.getDefaultMailCachePath();
        }
        catch (ex) {
            console.error('getMailCachePath-error', ex);
            return this.getDefaultMailCachePath();
        }
    }
    async setMailCachePath(path) {
        try {
            this.storeApi.putSync(MAIL_CACHE_CUSTOMDIRKEY, path, globalStoreConfig);
            this.setMailContentDbCachePath();
            window.electronLib.fsManage.mkDir('', path);
            return {
                success: true,
            };
        }
        catch (ex) {
            console.error('setMailCachePath-catch', ex);
            return {
                success: false,
                errorMsg: (ex && ex.message) || '未知原因',
            };
        }
    }
    async selectMailCacheDirPath() {
        try {
            const res = await window.electronLib.windowManage.select({ properties: ['openDirectory'], buttonLabel: '使用该目录' });
            if (res.success) {
                const selectPath = res.path[0];
                if (selectPath.length === 3 && selectPath.endsWith('\\')) {
                    return {
                        success: true,
                        path: selectPath,
                    };
                }
                const exeDir = await this.getExeDir();
                const blackFolders = [exeDir];
                const isBlackFolder = blackFolders.find(blackStr => selectPath.toLowerCase().includes(blackStr.toLowerCase()));
                if (isBlackFolder) {
                    return {
                        success: false,
                        errorMsg: getIn18Text('UNABLE_CACHE_PATH_TIP'),
                    };
                }
                let hasPermisssion = false;
                try {
                    const accessRes = await window.electronLib.fsManage.getIsFolderHasFullAccess(selectPath);
                    if (accessRes.success && accessRes.createRes) {
                        hasPermisssion = true;
                    }
                }
                catch (ex) {
                    console.error('fs getIsFolderHasFullAccess error', ex);
                    hasPermisssion = false;
                }
                if (hasPermisssion) {
                    return {
                        success: true,
                        path: selectPath,
                    };
                }
                return {
                    success: false,
                    errorMsg: getIn18Text('NO_ACCESS_CACHE_PATH_TIP'),
                };
            }
            return {
                success: true,
                path: '',
            };
        }
        catch (ex) {
            return {
                success: false,
                errorMsg: (ex && ex.message) || '未知原因',
            };
        }
    }
    async doGetFoldersForPushConfig(_account) {
        try {
            const mailBoxs = await this.doListMailBox(true, undefined, undefined, _account);
            mailBoxs.forEach(item => {
                if (item && item.children && item.children.length > 0) {
                    item.children = [];
                }
            });
            const allMailBoxs = [];
            traverseMailBoxs(mailBoxs, allMailBoxs);
            const shouldConfigFolders = allMailBoxs.filter(mailBoxItem => {
                if (mailBoxItem && mailBoxItem.children && mailBoxItem.children.length) {
                    mailBoxItem.children = [];
                }
                const { mailBoxId } = mailBoxItem;
                if (!mailBoxId) {
                    return false;
                }
                if (mailBoxId === 1) {
                    return true;
                }
                if (Number.parseInt(mailBoxId.toString()) >= 100) {
                    return true;
                }
                return false;
            });
            return {
                success: true,
                data: shouldConfigFolders,
            };
        }
        catch (ex) {
            return {
                success: false,
                errorMsg: (ex && ex.message) || '',
            };
        }
    }
    async cleanPushConfig(_account) {
        this.pushApi.cleanPushConfig(_account);
    }
    async getPushConfig(type = 0, _account) {
        return this.pushApi.getCurrentPushConfig(type, _account);
    }
    async setPushConfig(config, _account) {
        return this.pushApi.setCurrentConfig(config, _account);
    }
    async doGetAllAccountsPushConfig() {
        try {
            const mailAndSubAccounts = await this.accountApi.getMainAndSubAccounts({ expired: false });
            const promises = mailAndSubAccounts.map(accountItem => {
                if (accountItem.accountType === 'mainAccount') {
                    return this.getPushConfig(undefined, undefined).then(res => (Object.assign({ email: accountItem.loginAccount || accountItem.id }, res)));
                }
                return this.getPushConfig(undefined, accountItem.id).then(res => (Object.assign({ email: accountItem.agentEmail || accountItem.id }, res)));
            });
            const pushConfigResArr = await Promise.all(promises);
            const resArr = [];
            pushConfigResArr.forEach(pushConfigItem => {
                if (pushConfigItem.success && pushConfigItem.data) {
                    resArr.push({
                        email: pushConfigItem.email,
                        data: pushConfigItem.data,
                    });
                }
            });
            return {
                success: true,
                data: resArr,
            };
        }
        catch (ex) {
            return {
                success: false,
                errorMsg: (ex && ex.message) || '',
            };
        }
    }
    async doGetAllAccountsFoldersForConfig() {
        try {
            const mailAndSubAccounts = await this.accountApi.getMainAndSubAccounts({ expired: false });
            const promises = mailAndSubAccounts.map(accountItem => {
                if (accountItem.accountType === 'mainAccount') {
                    return this.doGetFoldersForPushConfig().then(res => (Object.assign({ email: accountItem.loginAccount || accountItem.id }, res)));
                }
                return this.doGetFoldersForPushConfig(accountItem.id).then(res => (Object.assign({ email: accountItem.agentEmail || accountItem.id }, res)));
            });
            const foldersConfigResArr = await Promise.all(promises);
            const res = [];
            foldersConfigResArr.forEach(configRes => {
                if (configRes.success) {
                    res.push({
                        email: configRes.email,
                        folders: configRes.data,
                    });
                }
            });
            return {
                success: true,
                data: res,
            };
        }
        catch (ex) {
            console.log('doGetAllAccountsFoldersForConfig-error', ex);
            return {
                success: false,
                errorMsg: (ex && ex.messsage) || '',
            };
        }
    }
    async handleRawMailContent(id, rawContent) {
        return this.mailContentHandler.handleRawMailContent(id, rawContent);
    }
    async doGetMailContentInquiry(handoverEmailId) {
        if (!handoverEmailId) {
            return Promise.reject(new Error('no handoverEmailId input'));
        }
        const result = await this.mailContentHandler.doGetMailContentInquiry(handoverEmailId);
        if (result && result.tags) {
            result.originalTags = result.tags;
            result.tags = result.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
        }
        if (result && !result.sender) {
            result.sender = this.contactHandler.buildEmptyContact(false)[0];
        }
        return result;
    }
    async doSearchMoreAccounts(searchKey, params) {
        return this.mailContentHandler.doSearchMoreAccounts(searchKey, params);
    }
    async unlockSecurityLock(password, _account) {
        return this.mailContentHandler.unlockSecurityLock(password, _account);
    }
}
MailApiImpl.mailSyncMinPeriod = 25 * 1000;
MailApiImpl.MAIL_SYNC_WAIT_SPAN = 15 * 1000;
MailApiImpl.MAIL_CONTENT_SYNC_MIN_PERIOD = 30 * 60 * 1000;
MailApiImpl.SAVE_FILES_WAIT = 2 * 60 * 1000;
MailApiImpl.user = undefined;
MailApiImpl.mailSyncing = false;
const mailApiImpl = new MailApiImpl();
api.registerLogicalApi(mailApiImpl);
export default mailApiImpl;
